 unit PrjFormDecisionData;

interface

uses
  System.SysUtils,
  System.Classes,
  Vcl.Controls,
  Vcl.Graphics,
  Vcl.StdCtrls,
  Vcl.Imaging.GIFImg,
  Data.DB,
  Types,

  Vcl.Grids,


  JS,
  Web,
  WEBLib.Grids,
  WEBLib.DBCtrls,
  WEBLib.Graphics,
  WEBLib.Controls,
  WEBLib.Forms,
  WEBLib.Dialogs,
  WEBLib.StdCtrls,
  WEBLib.ExtCtrls,
  WEBLib.ComCtrls,
  WEBLib.DB,
  VCL.TMSFNCTypes,
  VCL.TMSFNCUtils,
  VCL.TMSFNCGraphics,
  VCL.TMSFNCGraphicsTypes,
  VCL.TMSFNCCustomControl,
  VCL.TMSFNCWidgetGauge,

  XData.Web.Connection,
  XData.Web.JsonDataset,
  XData.Web.Dataset,

  PrjFormDefault,
  PrjClassHBMDataAccess;


type
  TPreCalcType = (pctNone, pctSaveAndLock, pctSave);
  TDecisionMode = (dcmNone, dcmDecision, dcmPlanCalculation);


  TPrjFormsDecisionData = class(TPrjFormsDefault)
    pgcEntscheidungen: TPageControl;
    pgcSheetFaelleInstitute: TTabSheet;
    pgcSheetStationenPersonal: TTabSheet;
    pgcSheetFinanzen: TTabSheet;
    pnInstitutsEntscheidungen: TPanel;
    pnLeistungsPlanung: TPanel;
    pnLeistungsKategorie: TPanel;
    pnPersonal: TPanel;
    pnFinanzen: TPanel;
    lblStation1: TLabel;
    WebLabel1: TLabel;
    WebLabel2: TLabel;
    WebLabel3: TLabel;
    WebLabel5: TLabel;
    WebLabel6: TLabel;
    RFE_KrdKurz: TDBEdit;
    RFE_KrdLang: TDBEdit;
    RFE_Dividen: TDBEdit;
    RFE_WpKauf: TDBEdit;
    pnFinanzGenerell: TPanel;
    WebLabel8: TLabel;
    La5_Abt1: TLabel;
    La5_Abt2: TLabel;
    La5_Abt3: TLabel;
    WebLabel10: TLabel;
    WebLabel13: TLabel;
    WebLabel17: TLabel;
    RFE_Imag1: TDBEdit;
    RFE_Patie: TDBEdit;
    RFE_Train: TDBEdit;
    RFE_Imag2: TDBEdit;
    RFE_Imag3: TDBEdit;
    RFE_Ratio: TDBEdit;
    pnLeftNavigation: TPanel;
    lblPeriode: TLabel;
    btnClose: TButton;
    btnSave: TButton;
    spedPeriode: TSpinEdit;
    btnPrint: TButton;
    btnCancel: TButton;
    brnHelp: TButton;
    lblAbteilung: TLabel;
    spedAbteilung: TSpinEdit;
    lblKrankenhaus: TLabel;
    spedKrankenhaus: TSpinEdit;
    btnSaveAndLock: TButton;
    pnVersetzungMitarbeiter: TPanel;
    La3_Abt2: TLabel;
    La3_Abt3: TLabel;
    LF3_NachA1: TDBEdit;
    LF3_NachA2: TDBEdit;
    RFE_AbteilungName: TEdit;
    WebLabel20: TLabel;
    pnUeberschuss: TPanel;
    pnRationalisierung: TPanel;
    WebLabel4: TLabel;
    WebLabel7: TLabel;
    WebLabel9: TLabel;
    WebMessageDlg: TMessageDlg;
    pnKodierdienst: TPanel;
    cbxOutsourceWaescherei: TDBCheckBox;
    lblOutsourcingAlternativen: TLabel;
    cb_CodD: TDBCheckBox;
    lblCaseManagementAktiv: TLabel;
    lblLaundryAktiv: TLabel;
    lblCaseManagement: TLabel;
    WebLabel16: TLabel;
    WebLabel18: TLabel;
    WebLabel19: TLabel;

    XDataWebDataSetPerfPlan: TXDataWebDataSet;
    PerfPlanDataSource: TDataSource;
    XDataWebConnection1: TXDataWebConnection;
    XDataWebDataSetPerfCat: TXDataWebDataSet;
    PerfCatWebDataSource: TDataSource;
    XDataWebDataSetPerfMisc: TXDataWebDataSet;
    PerfMiscWebDataSource: TDataSource;
    XDataWebDataSetFaelle: TXDataWebDataSet;
    ed_LeistPlAbteilung: TEdit;
    FaelleDataSource: TDataSource;
    ed_LeistPlStation1: TEdit;
    ed_LeistPlStation2: TEdit;
    ed_LeistPlStation3: TEdit;
    ed_LeistPlStation5: TEdit;
    ed_LeistPlStation4: TEdit;
    ed_LeistPlStation6: TEdit;
    ed_LeistPlStationSumme: TEdit;
    edLeistPlWahl1Stat1: TEdit;
    edLeistPlWahl1Stat2: TEdit;
    edLeistPlWahl1Stat3: TEdit;
    edLeistPlWahl1Stat5: TEdit;
    edLeistPlWahl1Stat4: TEdit;
    edLeistPlWahl1Stat6: TEdit;
    edLeistPlWahl1Summe: TEdit;
    edLeistPlWahl2Stat1: TEdit;
    edLeistPlWahl2Stat2: TEdit;
    edLeistPlWahl2Stat3: TEdit;
    edLeistPlWahl2Stat5: TEdit;
    edLeistPlWahl2Stat4: TEdit;
    edLeistPlWahl2Stat6: TEdit;
    edLeistPlWahl2Summe: TEdit;
    edLeistPlNormStat1: TEdit;
    edLeistPlNormStat2: TEdit;
    edLeistPlNormStat3: TEdit;
    edLeistPlNormStat5: TEdit;
    edLeistPlNormStat4: TEdit;
    edLeistPlNormStat6: TEdit;
    edLeistPlNormSumme: TEdit;
    edLeistPlSumStat1: TEdit;
    edLeistPlSumStat2: TEdit;
    edLeistPlSumStat3: TEdit;
    edLeistPlSumStat5: TEdit;
    edLeistPlSumStat4: TEdit;
    edLeistPlSumStat6: TEdit;
    edLeistPlSumSumme: TEdit;
    edLeistSumFaelleAbtl: TEdit;
    WebLabel11: TLabel;
    WebLabel12: TLabel;
    WebLabel14: TLabel;
    WebLabel15: TLabel;
    WebLabel21: TLabel;
    WebLabel22: TLabel;
    ed_LeistKatWahlLeist1AnzAltZi: TEdit;
    ed_LeistKatWahlLeist2AnzAltZi: TEdit;
    ed_LeistKatNormalAnzAltZi: TEdit;
    ed_LeistSummeAnzAltZi: TEdit;
    ed_LeistKatWahlLeist1AnzAltBt: TEdit;
    ed_LeistKatWahlLeist2AnzAltBt: TEdit;
    ed_LeistKatNormalAnzAltBt: TEdit;
    ed_LeistSummeAnzAltBt: TEdit;
    ed_LeistKatWahlLeist1Umwandlung: TEdit;
    ed_LeistKatWahlLeist2Umwandlung: TEdit;
    ed_LeistKatNormalUmwandlung: TEdit;
    ed_LeistSummeUmwandlung: TEdit;
    ed_LeistKatWahlLeist1ErwAbbau: TEdit;
    ed_LeistKatWahlLeist2ErwAbbau: TEdit;
    ed_LeistKatNormalErwAbbau: TEdit;
    ed_LeistSummeErwAbbau: TEdit;
    ed_LeistKatWahlLeist1AnzNeuZi: TEdit;
    ed_LeistKatWahlLeist2AnzNeuZi: TEdit;
    ed_LeistKatNormalAnzNeuZi: TEdit;
    ed_LeistSummeAnzNeuZi: TEdit;
    ed_LeistKatWahlLeist1AnzNeuBt: TEdit;
    ed_LeistKatWahlLeist2AnzNeuBt: TEdit;
    ed_LeistKatNormalAnzNeuBt: TEdit;
    ed_LeistSummeAnzNeuBt: TEdit;
    ed_LeistKatWahlLeist1Zuschlag: TEdit;
    ed_LeistKatWahlLeist2Zuschlag: TEdit;
    ed_LeistKatNormalZuschlag: TEdit;
    lb_LeistKatStation: TLabel;
    lb_LeistKatAnzahlAlt: TLabel;
    lb_LeistKatUmwandlung: TLabel;
    lb_LeistKatErwAbbau: TLabel;
    lb_LeistKatAnzahlNeu: TLabel;
    lb_LeistKatZuschlag: TLabel;
    lb_LeistKatStat1: TLabel;
    lb_LeistKatStat2: TLabel;
    lb_LeistKatStat3: TLabel;
    lb_LeistKatStatSumme: TLabel;
    ed_PersMassEinstellungenArzt: TEdit;
    ed_PersMassEntlassungArzt: TEdit;
    ed_PersMassTrainingArzt: TEdit;
    ed_PersMassNebenkostenArzt: TEdit;
    ed_PersMassEinstellungenPflege: TEdit;
    ed_PersMassEntlassungPflege: TEdit;
    ed_PersMassTrainingPflege: TEdit;
    ed_PersMassNebenkostenPflege: TEdit;
    lb_MassHead: TLabel;
    lb_MassArztHead: TLabel;
    lb_MassPflegeHead: TLabel;
    lb_PersMassEinstellung: TLabel;
    lb_PersMassEntlassung: TLabel;
    lb_PersMassTraining: TLabel;
    lb_PersMassNebenkosten: TLabel;
    lb_PersMassEinstellungEinh: TLabel;
    lb_PersMassEntlassungEinh: TLabel;
    lb_PersMassTrainingEinh: TLabel;
    lb_PersMassNebenkostenEinh: TLabel;
    lb_PersMassNebenkostenInstitut: TLabel;
    ed_PersMassNebenkostenInstitut: TEdit;
    pgcSheetKPI: TTabSheet;
    pnKPIData: TPanel;
    XDataWebDataSetKPIData: TXDataWebDataSet;
    KPIDataWebDataSource: TDataSource;
    weblabKPIHeadline: TLabel;
    procedure btnCancelClick(Sender: TObject);
    procedure btnCloseClick(Sender: TObject);
    procedure btnSaveAndLockClick(Sender: TObject);
    procedure pgcEntscheidungenChange(Sender: TObject);
    procedure RFE_KrdKurzExit(Sender: TObject);

    procedure spedAbteilungChanged(Sender: TObject);
    procedure spedKrankenhausChange(Sender: TObject);
    procedure spedPeriodeChange(Sender: TObject);
    procedure strGridLeistungskategorienValidateEdit(Sender: TObject; ACol, ARow: LongInt; var Value: string);
    procedure strGridPersonalMassnahmenCanEditCell(Sender: TObject; ACol, ARow: Integer; var CanEdit: Boolean);
    procedure strGridPersonalMassnahmenGetCellEditor(Sender: TObject; ACol, ARow: Integer; var AEditor: TGridCellEditor);
    procedure strGridPersonalMassnahmenValidateEdit(Sender: TObject; ACol, ARow: LongInt; var Value: string);
    procedure WebFormCreate(Sender: TObject);

    [Async]
    procedure webBtnSaveClick(Sender: TObject); async;
    procedure XDataWebDataSetFaelleAfterOpen(DataSet: TDataSet);
    procedure XDataWebDataSetPerfCatAfterOpen(DataSet: TDataSet);
    procedure XDataWebDataSetPerfCatEditError(DataSet: TDataSet; E: EDatabaseError; var Action: TDataAction);
    procedure XDataWebDataSetPerfMiscAfterOpen(DataSet: TDataSet);

    [Async]
    procedure XDataWebDataSetPerfPlanAfterOpen(DataSet: TDataSet); async;
    procedure XDataWebDataSetPerfPlanEditError(DataSet: TDataSet; E: EDatabaseError; var Action: TDataAction);
    procedure XDataWebDataSetKPIDataAfterOpen(DataSet: TDataSet);
    procedure XDataWebDataSetKPIDataEditError(DataSet: TDataSet; E: EDatabaseError; var Action: TDataAction);
    procedure edLeistPlWahl1Stat1Exit(Sender: TObject);
    procedure btnPrintClick(Sender: TObject);
    procedure ed_LeistKatWahlLeist1AnzAltZiExit(Sender: TObject);
  strict private
    FPreCalcMode : TPreCalcType;

    function ColumnSum(const ACol, AFromRow, AToRow: integer; var AGrid: TStringGrid): double;

    [Async]
    function DrawGridPG1Leistungsplanung: Boolean; async; virtual;

    [Async]
    function DrawGridPG2LeistKategorien: Boolean; async; virtual;

    function strGridPersonalMassnahmenGesperrt(aCol, aRow: Integer): Boolean;
    [Async]
    function DrawGridPG2PersonalMassnahmen: Boolean; async;

    function SaveGridPG2PersonalMassnahmen: Boolean;

    [Async]
    function InteractiveSaveLockData(AQuickSave: Boolean = false): Boolean; async; virtual;
    [Async]
    function SaveData: Boolean; async; virtual;
    [Async]
    function SetupData: Boolean; async;
    [Async]
    procedure CancelData(AMessage : string); async; virtual;
    [Async]
    procedure ToggleGUI; async;

    [Async]
    function UpdatePerformancePlaning: Boolean; async; virtual;
    function UnsetReadOnlyFlag(AFlag: Boolean): Boolean;

  private
    FCallingForm: TFormIdentifier;
    FDataChanged: Boolean;
    FDecisionMode: TDecisionMode;
    FFirstRun : boolean;

    [Async]
    function DrawGridPG2LeistPlanungRedraw: Boolean; async;
    [Async]
    function DrawGridPG2LeistKategorienRedraw: Boolean; async;
    [Async]
    function SaveGridPG1LeistungsKategorien: Boolean; async;
    [Async]
    function SaveGridPG1Leistungsplanung: Boolean; async;

    { Private-Deklarationen }
  public
    [Async]
    function Done: Boolean; async; override;
    [Async]
    function Init: Boolean; async; override;

    [Async]
    function ReInit: Boolean; async;

    [Async]
    function SetUpPage1(AFirstRun: Boolean = false): Boolean; async; virtual;
    [Async]
    function SetUpPage2(AFirstRun: Boolean = false): Boolean; async; virtual;
    [Async]
    function SetUpPage3(AFirstRun: Boolean = false): Boolean; async; virtual;

    { Public-Deklarationen }
  published
    property DataChanged: Boolean read FDataChanged write FDataChanged default false;
    property CallingForm: TFormIdentifier read FCallingForm write FCallingForm;
    property DecisionMode: TDecisionMode read FDecisionMode;
  protected procedure LoadDFMValues; override; end;


const
   cEDataBackBtnMsg      = 'Alle geänderten Werte seit der letzten Speicherung werden verworfen ?';
   cEDataCancelkBtnMsg   = 'Alle geänderten Werte werden verworfen ?';
   cEDatChangePeriodMsg  = 'Sie wechseln das Geschäftsjahr, sollen Ihre Änderungen gespeichert werden ?';
   cEDataSaveMsg         = 'Sollen die Entscheidungsdaten gespeichert werden ?';
   cEDataSaveLockMsg     = 'Sollen die Entscheidungsdaten gespeichert und abgeschlossen werden ?' + #10#13 +
                           'Eine weitere Bearbeitung ist anschließend nicht mehr möglich..';
   cEDataSaveLockSPLMsg  = 'Sollen die Entscheidungsdaten gespeichert und [abgeschlossen] werden ?' + #10#13 +
                           'Als Spielleiter werden die Daten nicht abgeschlossen';

   cVK_EDatTxt           = 'Planungsrechnungs-Entscheidungen';
   cCancelDlgMsg         = 'Sollen die Entscheidungen wirklich verworfen werden?';
   cInterMediateSvaeMsg  = 'Sollen Ihre bisherigen Dateneingaben gespeichert werden ?';


var
  PrjFormsDecisionData: TPrjFormsDecisionData;

implementation

{$I HBMOnline.inc}


{$R *.dfm}

uses
  wxBaseClassWebTools,
  PrjFormTLNReportSelection,
  PrjFormPDFDisplay,
  PrjClassHelperClasses,

  {$IFDEF APPISTLN}
  uHBMMainT,
  {$ELSE}
  PrjFormMain,
  {$ENDIF}

  System.Math,
  HBMWebData,
  HBMWebDef;

procedure TPrjFormsDecisionData.CancelData(AMessage : string);
var LModalResult : TModalResult;
begin
  LModalResult := await(TModalResult, WebMessageDlg.ShowDialog(AMessage, mtConfirmation, [mbYes,mbNo]));
  if LModalResult = mrYes then
  begin
    ModalResult := mrCancel;
    close;
  end;
end;

procedure TPrjFormsDecisionData.btnCancelClick(Sender: TObject);
begin
  CancelData(cEDataCancelkBtnMsg);
end;

procedure TPrjFormsDecisionData.btnCloseClick(Sender: TObject);
begin
  CancelData(cEDataBackBtnMsg);
end;

procedure TPrjFormsDecisionData.btnPrintClick(Sender: TObject);
var LReportSelection : TPrjFormsTLNReportSelection;
  procedure AfterCreate(AForm: TObject);
  begin
    if Assigned(LReportSelection) and (LReportSelection is TPrjFormsTLNReportSelection) then
    begin
      window.location.hash := 'TPrjFormsTLNReportSelection';
      ( LReportSelection as TPrjFormsTLNReportSelection ).FormIdentifier      := wxFrmPrintTLNReports;
      ( LReportSelection as TPrjFormsTLNReportSelection ).Init;
      if DataModule.TokenInformation.isTeilnehmer then
      begin
        ( LReportSelection as TPrjFormsTLNReportSelection ).Caption  := 'Teilnehmer Berichte';
      end;
      if DataModule.TokenInformation.isSpielleiter then
      begin
        ( LReportSelection as TPrjFormsTLNReportSelection ).FormIdentifier      := wxFrmPrintSPLReports;
        ( LReportSelection as TPrjFormsTLNReportSelection ).lblPeriode.Visible  := true;
        ( LReportSelection as TPrjFormsTLNReportSelection ).lblPeriode.Caption  := 'Krankenhaus ' + DataModule.HBMDefaultData.AktuellesUnternehmen.ToString;;
        ( LReportSelection as TPrjFormsTLNReportSelection ).spedPeriode.Enabled := true;
        ( LReportSelection as TPrjFormsTLNReportSelection ).spedPeriode.Visible := true;
        ( LReportSelection as TPrjFormsTLNReportSelection ).spedPeriode.Value   := DataModule.HBMDefaultData.AktuellesUnternehmen;
        ( LReportSelection as TPrjFormsTLNReportSelection ).Init;
        ( LReportSelection as TPrjFormsTLNReportSelection ).Caption  := 'Spielleiter Berichte';
      end;
    end;
  end;
  procedure AfterShowModal(AValue: TModalResult);
  begin
    // Hier können wir jetzt alles machen was nach dem schließen des Fensters sein muss
  end;
begin
  LReportSelection              := TPrjFormsTLNReportSelection.CreateNew( @AfterCreate);
  LReportSelection.Popup        := true;
  LReportSelection.PopupOpacity := 0.2;
  LReportSelection.ShowModal(@AfterShowModal);
end;

function TPrjFormsDecisionData.ColumnSum(const ACol, AFromRow, AToRow: integer; var AGrid: TStringGrid): double;
var LcntRow : integer;
var LcntSum : double;
begin
  for LcntRow := AFromRow to AToRow do
  begin
    if not TryStrToFloat(AGrid.Cells[ACol, LcntRow], LcntSum) then
    begin
      result := result + 0;
    end else
    begin
      result := result + LcntSum;
    end;
  end;
end;

function TPrjFormsDecisionData.Done: Boolean;
begin
  WaitMessage.Show;

  XDataWebDataSetPerfPlan.Cancel;
  XDataWebDataSetPerfCat.Cancel;
  XDataWebDataSetPerfMisc.Cancel;
  XDataWebDataSetFaelle.Cancel;
  XDataWebDataSetKPIData.Cancel;

  XDataWebDataSetPerfPlan.Close;
  XDataWebDataSetPerfCat.Close;
  XDataWebDataSetPerfMisc.Close;
  XDataWebDataSetFaelle.Close;
  XDataWebDataSetKPIData.Close;

  if DataModule.TokenInformation.isTeilnehmer and DataChanged then
  begin
    Await(Self.UpdatePerformancePlaning);
  end;

  if (FPreCalcMode = pctSaveAndLock) and DataChanged then
  begin
    if DataModule.HBMDefaultData.Vorkalkulation <= DataModule.HBMDefaultData.AktuellePeriode then
    begin
      wxBaseWriteLog.Write('pctSaveAndLock ---- dcmDecision ', slDebug);
      DataModule.HBMDefaultData.CalculatedDepartment  := DataModule.HBMDefaultData.AktuelleAbteilung;
      DataModule.HBMDefaultData.CalculatedEnterprise  := DataModule.HBMDefaultData.AktuellesUnternehmen;
      DataModule.HBMDefaultData.CalculatedPeriod      := DataModule.HBMDefaultData.AktuellePeriode;
      DataModule.HBMDefaultData.Vorkalkulation        := 1;
    end;
    WaitMessage.Hide;
  end else if (FPreCalcMode = pctSave) and DataChanged then
  begin
    if FDecisionMode = dcmPlanCalculation then
    begin
      wxBaseWriteLog.Write('pctSave & dcmPreCalculation----', slDebug);
      DataModule.HBMDefaultData.CalculatedDepartment  := DataModule.HBMDefaultData.AktuelleAbteilung;
      DataModule.HBMDefaultData.CalculatedEnterprise  := DataModule.HBMDefaultData.AktuellesUnternehmen;
      DataModule.HBMDefaultData.CalculatedPeriod      := DataModule.HBMDefaultData.AktuellePeriode;
      {$IFDEF APPISTLN}
      await(DataAccess.RequestDaten('N', HBMMainT.XDataWebConnectionMain, 'PRE'));
      {$ELSE}
      await(DataAccess.RequestDaten('N', PrjFormsMain.XDataWebConnectionMain, 'PRE' ));
      {$ENDIF}
    end;
    WaitMessage.Hide;
  end else
  begin
    WaitMessage.Hide;
  end;
end;

function TPrjFormsDecisionData.SaveGridPG1Leistungsplanung: Boolean;
var LCol            : integer;
var LSearchOptions  : TLocateOptions;
var LDRGId          : integer;
begin
  try
    LSearchOptions  := [];
    if not XDataWebDataSetFaelle.IsEmpty then
    begin
      for LCol := 1 to 6 do
      begin
        case LCol of
          1 : begin
                LDRGId := drgFaelle.FindAssignmentByName(ed_LeistPlStation1.Text);
              end;
          2 : begin
                LDRGId := drgFaelle.FindAssignmentByName(ed_LeistPlStation2.Text);
              end;
          3 : begin
                LDRGId := drgFaelle.FindAssignmentByName(ed_LeistPlStation3.Text);
              end;
          4 : begin
                LDRGId := drgFaelle.FindAssignmentByName(ed_LeistPlStation4.Text);
              end;
          5 : begin
                LDRGId := drgFaelle.FindAssignmentByName(ed_LeistPlStation5.Text);
              end;
          6 : begin
                LDRGId := drgFaelle.FindAssignmentByName(ed_LeistPlStation6.Text);
              end;
        end;

//        if XDataWebDataSetPerfPlan.Locate('Hppg_Drg_Display_Order', LCol, LSearchOptions ) then
        if XDataWebDataSetPerfPlan.Locate('HPPG_DRG_IDENTIFIER', LDRGId, LSearchOptions ) then
        begin
	        if not (XDataWebDataSetPerfPlan.State in [dsEdit]) then
            XDataWebDataSetPerfPlan.Edit;
          if XDataWebDataSetPerfPlan.State in [dsEdit] then
          begin
            case LCol of
              1     : begin
                        if drgFaelle.FindAssignmentByName(ed_LeistPlStation1.Text) <> -1 then
                        begin
                          XDataWebDataSetPerfPlan.FieldByName('Hppg_Optional_Service1').AsFloat := edLeistPlWahl1Stat1.Text.toDouble;
                          XDataWebDataSetPerfPlan.FieldByName('Hppg_Optional_Service2').AsFloat := edLeistPlWahl2Stat1.Text.toDouble;
                          XDataWebDataSetPerfPlan.FieldByName('Hppg_Normal').AsFloat 			      := edLeistPlNormStat1.Text.toDouble;
                        end;
                      end;
              2     : begin
                        if drgFaelle.FindAssignmentByName(ed_LeistPlStation2.Text) <> -1 then
                        begin
                          XDataWebDataSetPerfPlan.FieldByName('Hppg_Optional_Service1').AsFloat := edLeistPlWahl1Stat2.Text.toDouble;
                          XDataWebDataSetPerfPlan.FieldByName('Hppg_Optional_Service2').AsFloat := edLeistPlWahl2Stat2.Text.toDouble;
                          XDataWebDataSetPerfPlan.FieldByName('Hppg_Normal').AsFloat			      := edLeistPlNormStat2.Text.toDouble;
                        end;
                      end;
              3     : begin
                        if drgFaelle.FindAssignmentByName(ed_LeistPlStation3.Text) <> -1 then
                        begin
                          XDataWebDataSetPerfPlan.FieldByName('Hppg_Optional_Service1').AsFloat := edLeistPlWahl1Stat3.Text.toDouble;
                          XDataWebDataSetPerfPlan.FieldByName('Hppg_Optional_Service2').AsFloat := edLeistPlWahl2Stat3.Text.toDouble;
                          XDataWebDataSetPerfPlan.FieldByName('Hppg_Normal').AsFloat			      := edLeistPlNormStat3.Text.toDouble;
                        end;
                      end;
              4     : begin
                        if drgFaelle.FindAssignmentByName(ed_LeistPlStation4.Text) <> -1 then
                        begin
                          XDataWebDataSetPerfPlan.FieldByName('Hppg_Optional_Service1').AsFloat := edLeistPlWahl1Stat4.Text.toDouble;
                          XDataWebDataSetPerfPlan.FieldByName('Hppg_Optional_Service2').AsFloat := edLeistPlWahl2Stat4.Text.toDouble;
                          XDataWebDataSetPerfPlan.FieldByName('Hppg_Normal').AsFloat			      := edLeistPlNormStat4.Text.toDouble;
                        end;
                      end;
              5     : begin
                        if drgFaelle.FindAssignmentByName(ed_LeistPlStation5.Text) <> -1 then
                        begin
                          XDataWebDataSetPerfPlan.FieldByName('Hppg_Optional_Service1').AsFloat := edLeistPlWahl1Stat5.Text.toDouble;
                          XDataWebDataSetPerfPlan.FieldByName('Hppg_Optional_Service2').AsFloat := edLeistPlWahl2Stat5.Text.toDouble;
                          XDataWebDataSetPerfPlan.FieldByName('Hppg_Normal').AsFloat			      := edLeistPlNormStat5.Text.toDouble;
                        end;
                      end;
              6     : begin
                        if drgFaelle.FindAssignmentByName(ed_LeistPlStation6 .Text) <> -1 then
                        begin
                          XDataWebDataSetPerfPlan.FieldByName('Hppg_Optional_Service1').AsFloat := edLeistPlWahl1Stat6.Text.toDouble;
                          XDataWebDataSetPerfPlan.FieldByName('Hppg_Optional_Service2').AsFloat := edLeistPlWahl2Stat6.Text.toDouble;
                          XDataWebDataSetPerfPlan.FieldByName('Hppg_Normal').AsFloat			      := edLeistPlNormStat6.Text.toDouble;
                        end;
                      end;
            end;
            XDataWebDataSetPerfPlan.Post;
          end;
        end;
	    end;
      XDataWebDataSetPerfPlan.ApplyUpdates;
//      ToggleGUI;
    end else
    begin
      wxBaseWriteLog.Write('Error occured in TPrjFormsDecisionData.SaveGridPG1Leistungsplanung, XDataWebDataSetFaelle is empty', slDebug);
    end;
  except
    wxBaseWriteLog.Write('Exception occured in modul TPrjFormsDecisionData.SaveGridPG1Leistungsplanung', slDebug);
    result := false;
  end;
end;


function TPrjFormsDecisionData.UpdatePerformancePlaning: Boolean;
begin
  Result := true;
  try
    DataModule.HBMDefaultData.CalculatedDepartment  := spedAbteilung.Value;
    DataModule.HBMDefaultData.CalculatedEnterprise  := spedKrankenhaus.Value;
    DataModule.HBMDefaultData.CalculatedPeriod      := spedPeriode.Value;
    DataModule.HBMDefaultData.TLNIsLocked           := False;
    if DataModule.TokenInformation.isTeilnehmer then
    begin
      if (FDecisionMode = dcmDecision) then
      begin
        if DataModule.TokenInformation.isTeilnehmer then
          DataModule.HBMDefaultData.TLNIsLocked := True;

        {$IFDEF APPISTLN}
        result := await(DataAccess.RequestDaten('U', HBMMainT.XDataWebConnectionMain,'LOCK'));
        {$ELSE}
        result := await(DataAccess.RequestDaten('U', PrjFormsMain.XDataWebConnectionMain,'LOCK'));
        {$ENDIF}
      end;
      if FDecisionMode = dcmPlanCalculation then
      begin
        {$IFDEF APPISTLN}
        result := await(DataAccess.RequestDaten('U', HBMMainT.XDataWebConnectionMain,'COUNT'));
        {$ELSE}
        result := await(DataAccess.RequestDaten('U', PrjFormsMain.XDataWebConnectionMain,'COUNT'));
        {$ENDIF}
      end;

      await(XDataWebDataSetPerfPlan.Refresh);
      await(XDataWebDataSetFaelle.Refresh);
    end;
  except
    Result := false;
  end;
end;

function TPrjFormsDecisionData.DrawGridPG1Leistungsplanung: Boolean;
var LCol            : integer;
var LSearchOptions  : TLocateOptions;
var LRowSums        : array of double;
begin
  Result  := true;
  LCol    := 1;
  LSearchOptions  := [];
  SetLength(LRowSums, 3);

  LRowSums[0] := 0;
  LRowSums[1] := 0;
  LRowSums[2] := 0;

  try
    if not XDataWebDataSetFaelle.IsEmpty then
    begin
      XDataWebDataSetFaelle.First;
      ed_LeistPlAbteilung.Text    := Abteilungen.FindAssignment(spedAbteilung.Value).FContent;
      ed_LeistPlStationSumme.Text := 'Summen';
      while not XDataWebDataSetFaelle.Eof do
      begin
        case LCol of
          1 : begin
                ed_LeistPlStation1.Text := XDataWebDataSetFaelle.FieldByName('Mafa_Fallname').AsString;
              end;
          2 : begin
                ed_LeistPlStation2.Text := XDataWebDataSetFaelle.FieldByName('Mafa_Fallname').AsString;
              end;
          3 : begin
                ed_LeistPlStation3.Text := XDataWebDataSetFaelle.FieldByName('Mafa_Fallname').AsString;
              end;
          4 : begin
                ed_LeistPlStation4.Text := XDataWebDataSetFaelle.FieldByName('Mafa_Fallname').AsString;
              end;
          5 : begin
                ed_LeistPlStation5.Text := XDataWebDataSetFaelle.FieldByName('Mafa_Fallname').AsString;
              end;
          6 : begin
                ed_LeistPlStation6.Text := XDataWebDataSetFaelle.FieldByName('Mafa_Fallname').AsString;
              end;
        end;

        if not XDataWebDataSetPerfPlan.IsEmpty then
        begin
          if XDataWebDataSetPerfPlan.Locate('Hppg_Drg_Identifier', XDataWebDataSetFaelle.FieldByName('Mafa_Assignment').AsInteger, LSearchOptions  ) then
          begin
            case LCol of
              1     : begin
                        edLeistPlWahl1Stat1.Text  := Str_F_To_Str(XDataWebDataSetPerfPlan.FieldByName('Hppg_Optional_Service1').AsFloat, 8, 0);
                        edLeistPlWahl2Stat1.Text  := Str_F_To_Str(XDataWebDataSetPerfPlan.FieldByName('Hppg_Optional_Service2').AsFloat, 8, 0);
                        edLeistPlNormStat1.Text   := Str_F_To_Str(XDataWebDataSetPerfPlan.FieldByName('Hppg_Normal').AsFloat, 8, 0);
                        edLeistPlSumStat1.Text    := Str_F_To_Str( XDataWebDataSetPerfPlan.FieldByName('Hppg_Optional_Service1').AsFloat +
                                                                   XDataWebDataSetPerfPlan.FieldByName('Hppg_Optional_Service2').AsFloat +
                                                                   XDataWebDataSetPerfPlan.FieldByName('Hppg_Normal').AsFloat, 8, 0);
                      end;
              2     : begin
                        edLeistPlWahl1Stat2.Text  := Str_F_To_Str(XDataWebDataSetPerfPlan.FieldByName('Hppg_Optional_Service1').AsFloat, 8, 0);
                        edLeistPlWahl2Stat2.Text  := Str_F_To_Str(XDataWebDataSetPerfPlan.FieldByName('Hppg_Optional_Service2').AsFloat, 8, 0);
                        edLeistPlNormStat2.Text   := Str_F_To_Str(XDataWebDataSetPerfPlan.FieldByName('Hppg_Normal').AsFloat, 8, 0);
                        edLeistPlSumStat2.Text    := Str_F_To_Str( XDataWebDataSetPerfPlan.FieldByName('Hppg_Optional_Service1').AsFloat +
                                                                   XDataWebDataSetPerfPlan.FieldByName('Hppg_Optional_Service2').AsFloat +
                                                                   XDataWebDataSetPerfPlan.FieldByName('Hppg_Normal').AsFloat, 8, 0);
                      end;
              3     : begin
                        edLeistPlWahl1Stat3.Text  := Str_F_To_Str(XDataWebDataSetPerfPlan.FieldByName('Hppg_Optional_Service1').AsFloat, 8, 0);
                        edLeistPlWahl2Stat3.Text  := Str_F_To_Str(XDataWebDataSetPerfPlan.FieldByName('Hppg_Optional_Service2').AsFloat, 8, 0);
                        edLeistPlNormStat3.Text   := Str_F_To_Str(XDataWebDataSetPerfPlan.FieldByName('Hppg_Normal').AsFloat, 8, 0);
                        edLeistPlSumStat3.Text    := Str_F_To_Str( XDataWebDataSetPerfPlan.FieldByName('Hppg_Optional_Service1').AsFloat +
                                                                   XDataWebDataSetPerfPlan.FieldByName('Hppg_Optional_Service2').AsFloat +
                                                                   XDataWebDataSetPerfPlan.FieldByName('Hppg_Normal').AsFloat, 8, 0);
                      end;
              4     : begin
                        edLeistPlWahl1Stat4.Text  := Str_F_To_Str(XDataWebDataSetPerfPlan.FieldByName('Hppg_Optional_Service1').AsFloat, 8, 0);
                        edLeistPlWahl2Stat4.Text  := Str_F_To_Str(XDataWebDataSetPerfPlan.FieldByName('Hppg_Optional_Service2').AsFloat, 8, 0);
                        edLeistPlNormStat4.Text   := Str_F_To_Str(XDataWebDataSetPerfPlan.FieldByName('Hppg_Normal').AsFloat, 8, 0);
                        edLeistPlSumStat4.Text    := Str_F_To_Str( XDataWebDataSetPerfPlan.FieldByName('Hppg_Optional_Service1').AsFloat +
                                                                   XDataWebDataSetPerfPlan.FieldByName('Hppg_Optional_Service2').AsFloat +
                                                                   XDataWebDataSetPerfPlan.FieldByName('Hppg_Normal').AsFloat, 8, 0);
                      end;
              5     : begin
                        edLeistPlWahl1Stat5.Text  := Str_F_To_Str(XDataWebDataSetPerfPlan.FieldByName('Hppg_Optional_Service1').AsFloat, 8, 0);
                        edLeistPlWahl2Stat5.Text  := Str_F_To_Str(XDataWebDataSetPerfPlan.FieldByName('Hppg_Optional_Service2').AsFloat, 8, 0);
                        edLeistPlNormStat5.Text   := Str_F_To_Str(XDataWebDataSetPerfPlan.FieldByName('Hppg_Normal').AsFloat, 8, 0);
                        edLeistPlSumStat5.Text    := Str_F_To_Str( XDataWebDataSetPerfPlan.FieldByName('Hppg_Optional_Service1').AsFloat +
                                                                   XDataWebDataSetPerfPlan.FieldByName('Hppg_Optional_Service2').AsFloat +
                                                                   XDataWebDataSetPerfPlan.FieldByName('Hppg_Normal').AsFloat, 8, 0);
                      end;
              6     : begin
                        edLeistPlWahl1Stat6.Text  := Str_F_To_Str(XDataWebDataSetPerfPlan.FieldByName('Hppg_Optional_Service1').AsFloat, 8, 0);
                        edLeistPlWahl2Stat6.Text  := Str_F_To_Str(XDataWebDataSetPerfPlan.FieldByName('Hppg_Optional_Service2').AsFloat, 8, 0);
                        edLeistPlNormStat6.Text   := Str_F_To_Str(XDataWebDataSetPerfPlan.FieldByName('Hppg_Normal').AsFloat, 8, 0);
                        edLeistPlSumStat6.Text    := Str_F_To_Str( XDataWebDataSetPerfPlan.FieldByName('Hppg_Optional_Service1').AsFloat +
                                                                   XDataWebDataSetPerfPlan.FieldByName('Hppg_Optional_Service2').AsFloat +
                                                                   XDataWebDataSetPerfPlan.FieldByName('Hppg_Normal').AsFloat, 8, 0);
                      end;
            end;
            LRowSums[0] := LRowSums[0] + XDataWebDataSetPerfPlan.FieldByName('Hppg_Optional_Service1').AsFloat;
            LRowSums[1] := LRowSums[1] + XDataWebDataSetPerfPlan.FieldByName('Hppg_Optional_Service2').AsFloat;
            LRowSums[2] := LRowSums[2] + XDataWebDataSetPerfPlan.FieldByName('Hppg_Normal').AsFloat;

          end else
          begin
            case LCol of
              1     : begin
                        edLeistPlWahl1Stat1.Text  := Str_F_To_Str(0, 8, 0);
                        edLeistPlWahl2Stat1.Text  := Str_F_To_Str(0, 8, 0);
                        edLeistPlNormStat1.Text   := Str_F_To_Str(0, 8, 0);
                        edLeistPlSumStat1.Text    := Str_F_To_Str(0, 8, 0);

                        edLeistPlWahl1Stat1.ReadOnly  := False;
                        edLeistPlWahl2Stat1.ReadOnly  := False;
                        edLeistPlNormStat1.ReadOnly   := False;
                        edLeistPlSumStat1.ReadOnly    := False;
                      end;
              2     : begin
                        edLeistPlWahl1Stat2.Text  := Str_F_To_Str(0, 8, 0);
                        edLeistPlWahl2Stat2.Text  := Str_F_To_Str(0, 8, 0);
                        edLeistPlNormStat2.Text   := Str_F_To_Str(0, 8, 0);
                        edLeistPlSumStat2.Text    := Str_F_To_Str(0, 8, 0);

                        edLeistPlWahl1Stat2.ReadOnly  := False;
                        edLeistPlWahl2Stat2.ReadOnly  := False;
                        edLeistPlNormStat2.ReadOnly   := False;
                        edLeistPlSumStat2.ReadOnly    := False;
                      end;
              3     : begin
                        edLeistPlWahl1Stat3.Text  := Str_F_To_Str(0, 8, 0);
                        edLeistPlWahl2Stat3.Text  := Str_F_To_Str(0, 8, 0);
                        edLeistPlNormStat3.Text   := Str_F_To_Str(0, 8, 0);
                        edLeistPlSumStat3.Text    := Str_F_To_Str(0, 8, 0);

                        edLeistPlWahl1Stat3.ReadOnly  := False;
                        edLeistPlWahl2Stat3.ReadOnly  := False;
                        edLeistPlNormStat3.ReadOnly   := False;
                        edLeistPlSumStat3.ReadOnly    := False;
                      end;
              4     : begin
                        edLeistPlWahl1Stat4.Text  := Str_F_To_Str(0, 8, 0);
                        edLeistPlWahl2Stat4.Text  := Str_F_To_Str(0, 8, 0);
                        edLeistPlNormStat4.Text   := Str_F_To_Str(0, 8, 0);
                        edLeistPlSumStat4.Text    := Str_F_To_Str(0, 8, 0);

                        edLeistPlWahl1Stat4.ReadOnly  := False;
                        edLeistPlWahl2Stat4.ReadOnly  := False;
                        edLeistPlNormStat4.ReadOnly   := False;
                        edLeistPlSumStat4.ReadOnly    := False;
                      end;
              5     : begin
                        edLeistPlWahl1Stat5.Text  := Str_F_To_Str(0, 8, 0);
                        edLeistPlWahl2Stat5.Text  := Str_F_To_Str(0, 8, 0);
                        edLeistPlNormStat5.Text   := Str_F_To_Str(0, 8, 0);
                        edLeistPlSumStat5.Text    := Str_F_To_Str(0, 8, 0);

                        edLeistPlWahl1Stat5.ReadOnly  := False;
                        edLeistPlWahl2Stat5.ReadOnly  := False;
                        edLeistPlNormStat5.ReadOnly   := False;
                        edLeistPlSumStat5.ReadOnly    := False;
                      end;
              6     : begin
                        edLeistPlWahl1Stat6.Text  := Str_F_To_Str(0, 8, 0);
                        edLeistPlWahl2Stat6.Text  := Str_F_To_Str(0, 8, 0);
                        edLeistPlNormStat6.Text   := Str_F_To_Str(0, 8, 0);
                        edLeistPlSumStat6.Text    := Str_F_To_Str(0, 8, 0);

                        edLeistPlWahl1Stat6.ReadOnly  := False;
                        edLeistPlWahl2Stat6.ReadOnly  := False;
                        edLeistPlNormStat6.ReadOnly   := False;
                        edLeistPlSumStat6.ReadOnly    := False;
                      end;
            end;
          end;
        end;
        XDataWebDataSetFaelle.Next;
        inc(LCol);
      end;

      edLeistPlWahl1Summe.Text   := Str_F_To_Str(LRowSums[0], 8, 0);
      edLeistPlWahl2Summe.Text   := Str_F_To_Str(LRowSums[1], 8, 0);
      edLeistPlNormSumme.Text    := Str_F_To_Str(LRowSums[2], 8, 0);
      edLeistPlSumSumme.Text     := Str_F_To_Str(LRowSums[0] + LRowSums[1] + LRowSums[2], 8, 0);
      edLeistSumFaelleAbtl.Text  := Str_F_To_Str(LRowSums[0] + LRowSums[1] + LRowSums[2], 8, 0);

      while LCol < 7 do
      begin
        case LCol of
          1     : begin
                    ed_LeistPlStation1.Text   :=  '- NZ -';
                    edLeistPlWahl1Stat1.Text  := Str_F_To_Str(0, 8, 0);
                    edLeistPlWahl2Stat1.Text  := Str_F_To_Str(0, 8, 0);
                    edLeistPlNormStat1.Text   := Str_F_To_Str(0, 8, 0);
                    edLeistPlSumStat1.Text    := Str_F_To_Str(0, 8, 0);

                    edLeistPlWahl1Stat1.ReadOnly  := True;
                    edLeistPlWahl2Stat1.ReadOnly  := True;
                    edLeistPlNormStat1.ReadOnly   := True;
                    edLeistPlSumStat1.ReadOnly    := True;

                  end;
          2     : begin
                    ed_LeistPlStation2.Text   :=  '- NZ -';
                    edLeistPlWahl1Stat2.Text  := Str_F_To_Str(0, 8, 0);
                    edLeistPlWahl2Stat2.Text  := Str_F_To_Str(0, 8, 0);
                    edLeistPlNormStat2.Text   := Str_F_To_Str(0, 8, 0);
                    edLeistPlSumStat2.Text    := Str_F_To_Str(0, 8, 0);

                    edLeistPlWahl1Stat2.ReadOnly  := True;
                    edLeistPlWahl2Stat2.ReadOnly  := True;
                    edLeistPlNormStat2.ReadOnly   := True;
                    edLeistPlSumStat2.ReadOnly    := True;
                  end;
          3     : begin
                    ed_LeistPlStation3.Text :=  '- NZ -';
                    edLeistPlWahl1Stat3.Text  := Str_F_To_Str(0, 8, 0);
                    edLeistPlWahl2Stat3.Text  := Str_F_To_Str(0, 8, 0);
                    edLeistPlNormStat3.Text   := Str_F_To_Str(0, 8, 0);
                    edLeistPlSumStat3.Text    := Str_F_To_Str(0, 8, 0);

                    edLeistPlWahl1Stat3.ReadOnly  := True;
                    edLeistPlWahl2Stat3.ReadOnly  := True;
                    edLeistPlNormStat3.ReadOnly   := True;
                    edLeistPlSumStat3.ReadOnly    := True;

                  end;
          4     : begin
                    ed_LeistPlStation4.Text :=  '- NZ -';
                    edLeistPlWahl1Stat4.Text  := Str_F_To_Str(0, 8, 0);
                    edLeistPlWahl2Stat4.Text  := Str_F_To_Str(0, 8, 0);
                    edLeistPlNormStat4.Text   := Str_F_To_Str(0, 8, 0);
                    edLeistPlSumStat4.Text    := Str_F_To_Str(0, 8, 0);

                    edLeistPlWahl1Stat4.ReadOnly  := True;
                    edLeistPlWahl2Stat4.ReadOnly  := True;
                    edLeistPlNormStat4.ReadOnly   := True;
                    edLeistPlSumStat4.ReadOnly    := True;
                  end;
          5     : begin
                    ed_LeistPlStation5.Text :=  '- NZ -';
                    edLeistPlWahl1Stat5.Text  := Str_F_To_Str(0, 8, 0);
                    edLeistPlWahl2Stat5.Text  := Str_F_To_Str(0, 8, 0);
                    edLeistPlNormStat5.Text   := Str_F_To_Str(0, 8, 0);
                    edLeistPlSumStat5.Text    := Str_F_To_Str(0, 8, 0);

                    edLeistPlWahl1Stat5.ReadOnly  := True;
                    edLeistPlWahl2Stat5.ReadOnly  := True;
                    edLeistPlNormStat5.ReadOnly   := True;
                    edLeistPlSumStat5.ReadOnly    := True;
                  end;
          6     : begin
                    ed_LeistPlStation6.Text :=  '- NZ -';
                    edLeistPlWahl1Stat6.Text  := Str_F_To_Str(0, 8, 0);
                    edLeistPlWahl2Stat6.Text  := Str_F_To_Str(0, 8, 0);
                    edLeistPlNormStat6.Text   := Str_F_To_Str(0, 8, 0);
                    edLeistPlSumStat6.Text    := Str_F_To_Str(0, 8, 0);

                    edLeistPlWahl1Stat6.ReadOnly  := True;
                    edLeistPlWahl2Stat6.ReadOnly  := True;
                    edLeistPlNormStat6.ReadOnly   := True;
                    edLeistPlSumStat6.ReadOnly    := True;
                  end;
        end;

        inc(LCol);
      end;
    end else
    begin
      wxBaseWriteLog.Write('Error occured in TPrjFormsDecisionData.DrawGridPG1Leistungsplanung, XDataWebDataSetFaelle is empty', slDebug);
    end;
  except
    wxBaseWriteLog.Write('Exception occured in TPrjFormsDecisionData.DrawGridPG1Leistungsplanung', slDebug);
    Result := false;
  end;
end;

function TPrjFormsDecisionData.SaveGridPG1LeistungsKategorien: Boolean;
begin
  result := true;
  try
    if not (XDataWebDataSetPerfCat.State in [dsEdit]) then
      XDataWebDataSetPerfCat.Edit;
    if XDataWebDataSetPerfCat.State in [dsEdit] then
    begin
      // Wahlleistung 1
      // Anzahl alt
      XDataWebDataSetPerfCat.FieldByName('Hpcc_Optional_Service1_Room_Old').AsFloat := ed_LeistKatWahlLeist1AnzAltZi.Text.toDouble;
      XDataWebDataSetPerfCat.FieldByName('Hpcc_Optional_Service1_Bed_Old').AsFloat  := ed_LeistKatWahlLeist1AnzAltBt.Text.toDouble;
      // Umwandlung
      XDataWebDataSetPerfCat.FieldByName('Hpcc_Optional_Service1_Change_Room').AsFloat := ed_LeistKatWahlLeist1Umwandlung.Text.toDouble;
      // Erweiterter Abbau
      XDataWebDataSetPerfCat.FieldByName('Hpcc_Optional_Service1_Dismantling_Room').AsFloat := ed_LeistKatWahlLeist1ErwAbbau.Text.toDouble;
      // Anzahl neu
      XDataWebDataSetPerfCat.FieldByName('Hpcc_Optional_Service1_Room_New').AsFloat := ed_LeistKatWahlLeist1AnzNeuZi.Text.toDouble;
      XDataWebDataSetPerfCat.FieldByName('Hpcc_Optional_Service1_Bed_New').AsFloat := ed_LeistKatWahlLeist1AnzNeuBt.Text.toDouble;
      // Zuschlag pro Tag
      XDataWebDataSetPerfCat.FieldByName('Hpcc_Optional_Service1_Surcharge').AsFloat := ed_LeistKatWahlLeist1Zuschlag.Text.toDouble;

      // Wahlleistung 2
      // Anzahl alt
      XDataWebDataSetPerfCat.FieldByName('Hpcc_Optional_Service2_Room_Old').AsFloat := ed_LeistKatWahlLeist2AnzAltZi.Text.toDouble;
      XDataWebDataSetPerfCat.FieldByName('Hpcc_Optional_Service2_Bed_Old').AsFloat := ed_LeistKatWahlLeist2AnzAltBt.Text.toDouble;
      // Umwandlung
      XDataWebDataSetPerfCat.FieldByName('Hpcc_Optional_Service2_Change_Room').AsFloat := ed_LeistKatWahlLeist2Umwandlung.Text.toDouble;
      // Erweiterter Abbau
      XDataWebDataSetPerfCat.FieldByName('Hpcc_Optional_Service2_Dismantling_Room').AsFloat := ed_LeistKatWahlLeist2ErwAbbau.Text.toDouble;
      // Anzahl neu
      XDataWebDataSetPerfCat.FieldByName('Hpcc_Optional_Service2_Room_New').AsFloat := ed_LeistKatWahlLeist2AnzNeuZi.Text.toDouble;
      XDataWebDataSetPerfCat.FieldByName('Hpcc_Optional_Service2_Bed_New').AsFloat := ed_LeistKatWahlLeist2AnzNeuBt.Text.toDouble;
      // Zuschlag pro Tag
      XDataWebDataSetPerfCat.FieldByName('Hpcc_Optional_Service2_Surcharge').AsFloat := ed_LeistKatWahlLeist2Zuschlag.Text.toDouble;

      // Normal
      // Anzahl alt
      // Anzahl alt

      XDataWebDataSetPerfCat.FieldByName('Hpcc_Normal_Room_Old').AsFloat := ed_LeistKatNormalAnzAltZi.Text.toDouble;
      XDataWebDataSetPerfCat.FieldByName('Hpcc_Normal_Bed_Old').AsFloat := ed_LeistKatNormalAnzAltBt.Text.toDouble;
      // Umwandlung
      XDataWebDataSetPerfCat.FieldByName('Hpcc_Normal_Change_Room').AsFloat := ed_LeistKatNormalUmwandlung.Text.toDouble;
      // Erweiterter Abbau
      XDataWebDataSetPerfCat.FieldByName('Hpcc_Normal_Dismantling_Room').AsFloat := ed_LeistKatNormalErwAbbau.Text.toDouble;
      // Anzahl neu
      XDataWebDataSetPerfCat.FieldByName('Hpcc_Normal_Room_New').AsFloat := ed_LeistKatNormalAnzNeuZi.Text.toDouble;
      XDataWebDataSetPerfCat.FieldByName('Hpcc_Normal_Bed_New').AsFloat := ed_LeistKatNormalAnzNeuBt.Text.toDouble;
      // Zuschlag pro Tag
      XDataWebDataSetPerfCat.FieldByName('Hpcc_Normal_Surcharge').AsFloat := ed_LeistKatNormalZuschlag.Text.toDouble;

      XDataWebDataSetPerfCat.FieldByName('Hpcc_Employment_Med').AsFloat       := ed_PersMassEinstellungenArzt.Text.ToDouble;
      XDataWebDataSetPerfCat.FieldByName('Hpcc_Employment_Care').AsFloat      := ed_PersMassEinstellungenPflege.Text.ToDouble;
      XDataWebDataSetPerfCat.FieldByName('Hpcc_Unemployment_Med').AsFloat     := ed_PersMassEntlassungArzt.Text.ToDouble;
      XDataWebDataSetPerfCat.FieldByName('Hpcc_Unemployment_Care').AsFloat    := ed_PersMassEntlassungPflege.Text.ToDouble;
      XDataWebDataSetPerfCat.FieldByName('Hpcc_Training_Med').AsFloat         := ed_PersMassTrainingArzt.Text.ToDouble;
      XDataWebDataSetPerfCat.FieldByName('Hpcc_Training_Care').AsFloat        := ed_PersMassTrainingPflege.Text.ToDouble;

      XDataWebDataSetPerfCat.FieldByName('Hpcc_Extra_Cost_Med').AsFloat       := ed_PersMassNebenkostenArzt.Text.ToDouble;
      XDataWebDataSetPerfCat.FieldByName('Hpcc_Extra_Cost_Care').AsFloat      := ed_PersMassNebenkostenPflege.Text.ToDouble;
      XDataWebDataSetPerfCat.FieldByName('Hpcc_Extra_Cost_Institute').AsFloat := ed_PersMassNebenkostenInstitut.Text.ToDouble;

    end;
    XDataWebDataSetPerfCat.Post;
    XDataWebDataSetPerfCat.ApplyUpdates;
  except
    wxBaseWriteLog.Write('Exception raised in TPrjFormsDecisionData.SaveGridPG1LeistungsKategorien',slDebug);
    result := false;
  end;
end;

function TPrjFormsDecisionData.DrawGridPG2LeistKategorien: Boolean;
begin
  Result := true;
  try
    lb_LeistKatAnzahlAlt.Caption  := 'Anzahl alt';
    lb_LeistKatUmwandlung.Caption := 'Umwandlung';
    lb_LeistKatErwAbbau.Caption   := 'Erweiteter Abbau';
    lb_LeistKatAnzahlNeu.Caption  := 'Anzahl neu';
    lb_LeistKatZuschlag.Caption   := 'Zuschlag EUR / Tag';

    lb_LeistKatStat1.Caption      := 'Wahlleistung 1';
    lb_LeistKatStat2.Caption      := 'Wahlleistung 2';
    lb_LeistKatStat3.Caption      := 'Normal';
    lb_LeistKatStatSumme.Caption  := 'Summe';

    if not XDataWebDataSetPerfCat.IsEmpty then
    begin
      // Wahlleistung 1
      // Anzahl alt
      ed_LeistKatWahlLeist1AnzAltZi.Text    := Str_F_to_Str(XDataWebDataSetPerfCat.FieldByName('Hpcc_Optional_Service1_Room_Old').AsFloat, 5, 0);
      ed_LeistKatWahlLeist1AnzAltBt.Text    := Str_F_to_Str(XDataWebDataSetPerfCat.FieldByName('Hpcc_Optional_Service1_Bed_Old').AsFloat, 5, 0);
      // Umwandlung
      ed_LeistKatWahlLeist1Umwandlung.Text  := Str_F_to_Str(XDataWebDataSetPerfCat.FieldByName('Hpcc_Optional_Service1_Change_Room').AsFloat, 5, 0);
      // Erweiterter Abbau
      ed_LeistKatWahlLeist1ErwAbbau.Text    := Str_F_to_Str(XDataWebDataSetPerfCat.FieldByName('Hpcc_Optional_Service1_Dismantling_Room').AsFloat, 5, 0);
      // Anzahl neu
      ed_LeistKatWahlLeist1AnzNeuZi.Text    := Str_F_to_Str(XDataWebDataSetPerfCat.FieldByName('Hpcc_Optional_Service1_Room_New').AsFloat, 5, 0);
      ed_LeistKatWahlLeist1AnzNeuBt.Text    := Str_F_to_Str(XDataWebDataSetPerfCat.FieldByName('Hpcc_Optional_Service1_Bed_New').AsFloat, 5, 0);
      // Zuschlag pro Tag
      ed_LeistKatWahlLeist1Zuschlag.Text    := Str_F_to_Str(XDataWebDataSetPerfCat.FieldByName('Hpcc_Optional_Service1_Surcharge').AsFloat, 5, 0);

      // Wahlleistung 2
      // Anzahl alt
      ed_LeistKatWahlLeist2AnzAltZi.Text    := Str_F_to_Str(XDataWebDataSetPerfCat.FieldByName('Hpcc_Optional_Service2_Room_Old').AsFloat, 5, 0);
      ed_LeistKatWahlLeist2AnzAltBt.Text    := Str_F_to_Str(XDataWebDataSetPerfCat.FieldByName('Hpcc_Optional_Service2_Bed_Old').AsFloat, 5, 0);
      // Umwandlung
      ed_LeistKatWahlLeist2Umwandlung.Text  := Str_F_to_Str(XDataWebDataSetPerfCat.FieldByName('Hpcc_Optional_Service2_Change_Room').AsFloat, 5, 0);
      // Erweiterter Abbau
      ed_LeistKatWahlLeist2ErwAbbau.Text    := Str_F_to_Str(XDataWebDataSetPerfCat.FieldByName('Hpcc_Optional_Service2_Dismantling_Room').AsFloat, 5, 0);
      // Anzahl neu
      ed_LeistKatWahlLeist2AnzNeuZi.Text    := Str_F_to_Str(XDataWebDataSetPerfCat.FieldByName('Hpcc_Optional_Service2_Room_New').AsFloat, 5, 0);
      ed_LeistKatWahlLeist2AnzNeuBt.Text    := Str_F_to_Str(XDataWebDataSetPerfCat.FieldByName('Hpcc_Optional_Service2_Bed_New').AsFloat, 5, 0);
      // Zuschlag pro Tag
      ed_LeistKatWahlLeist2Zuschlag.Text    := Str_F_to_Str(XDataWebDataSetPerfCat.FieldByName('Hpcc_Optional_Service2_Surcharge').AsFloat, 5, 0);

      // Normal
      // Anzahl alt
      // Anzahl alt
      ed_LeistKatNormalAnzAltZi.Text    := Str_F_to_Str(XDataWebDataSetPerfCat.FieldByName('Hpcc_Normal_Room_Old').AsFloat, 5, 0);
      ed_LeistKatNormalAnzAltBt.Text    := Str_F_to_Str(XDataWebDataSetPerfCat.FieldByName('Hpcc_Normal_Bed_Old').AsFloat, 5, 0);
      // Umwandlung
      ed_LeistKatNormalUmwandlung.Text  := Str_F_to_Str(XDataWebDataSetPerfCat.FieldByName('Hpcc_Normal_Change_Room').AsFloat, 5, 0);
      // Erweiterter Abbau
      ed_LeistKatNormalErwAbbau.Text    := Str_F_to_Str(XDataWebDataSetPerfCat.FieldByName('Hpcc_Normal_Dismantling_Room').AsFloat, 5, 0);
      // Anzahl neu
      ed_LeistKatNormalAnzNeuZi.Text    := Str_F_to_Str(XDataWebDataSetPerfCat.FieldByName('Hpcc_Normal_Room_New').AsFloat, 5, 0);
      ed_LeistKatNormalAnzNeuBt.Text    := Str_F_to_Str(XDataWebDataSetPerfCat.FieldByName('Hpcc_Normal_Bed_New').AsFloat, 5, 0);
      // Zuschlag pro Tag
      ed_LeistKatNormalZuschlag.Text    := Str_F_to_Str(XDataWebDataSetPerfCat.FieldByName('Hpcc_Normal_Surcharge').AsFloat, 5, 0);

    end;
  except
    wxBaseWriteLog.Write('Exception raised in TPrjFormsDecisionData.DrawGridPG2LeistKategorien',slDebug);
    result := false;
  end;
end;

function TPrjFormsDecisionData.DrawGridPG2LeistKategorienRedraw: Boolean;
var LIdx : integer;
begin
  try
    // Summen rechnen
    ed_LeistSummeAnzAltZi.Text    := Str_F_to_Str( ed_LeistKatWahlLeist1AnzAltZi.Text.toDouble +
                                                   ed_LeistKatWahlLeist2AnzAltZi.Text.toDouble +
                                                   ed_LeistKatNormalAnzAltZi.Text.toDouble, 5, 0);

    ed_LeistSummeAnzAltBt.Text    := Str_F_to_Str( ed_LeistKatWahlLeist1AnzAltBt.Text.toDouble +
                                                   ed_LeistKatWahlLeist2AnzAltBt.Text.toDouble +
                                                   ed_LeistKatNormalAnzAltBt.Text.toDouble, 5, 0);

    ed_LeistSummeUmwandlung.Text  := Str_F_to_Str( ed_LeistKatWahlLeist1Umwandlung.Text.toDouble +
                                                   ed_LeistKatWahlLeist2Umwandlung.Text.toDouble +
                                                   ed_LeistKatNormalUmwandlung.Text.toDouble, 5, 0);

    ed_LeistSummeErwAbbau.Text    := Str_F_to_Str( ed_LeistKatWahlLeist1ErwAbbau.Text.toDouble +
                                                   ed_LeistKatWahlLeist2ErwAbbau.Text.toDouble +
                                                   ed_LeistKatNormalErwAbbau.Text.toDouble, 5, 0);

    ed_LeistSummeAnzNeuZi.Text    := Str_F_to_Str( ed_LeistKatWahlLeist1AnzNeuZi.Text.toDouble +
                                                   ed_LeistKatWahlLeist2AnzNeuZi.Text.toDouble +
                                                   ed_LeistKatNormalAnzNeuZi.Text.toDouble, 5, 0);

    ed_LeistSummeAnzNeuBt.Text    := Str_F_to_Str( ed_LeistKatWahlLeist1AnzNeuBt.Text.toDouble +
                                                   ed_LeistKatWahlLeist2AnzNeuBt.Text.toDouble +
                                                   ed_LeistKatNormalAnzNeuBt.Text.toDouble, 5, 0);
  except
    wxBaseWriteLog.Write('Exception raised in TPrjFormsDecisionData.DrawGridPG2LeistKategorienRedraw',slDebug);
    result := false;
  end;
end;

function TPrjFormsDecisionData.DrawGridPG2LeistPlanungRedraw: Boolean;
begin
  Result := true;
  edLeistPlSumStat1.Text  := Str_F_To_Str(StrToFloat(edLeistPlWahl1Stat1.Text) + StrToFloat(edLeistPlWahl2Stat1.Text) + StrToFloat(edLeistPlNormStat1.Text), 8, 0);
  edLeistPlSumStat2.Text  := Str_F_To_Str(StrToFloat(edLeistPlWahl1Stat2.Text) + StrToFloat(edLeistPlWahl2Stat2.Text) + StrToFloat(edLeistPlNormStat2.Text), 8, 0);
  edLeistPlSumStat3.Text  := Str_F_To_Str(StrToFloat(edLeistPlWahl1Stat3.Text) + StrToFloat(edLeistPlWahl2Stat3.Text) + StrToFloat(edLeistPlNormStat3.Text), 8, 0);
  edLeistPlSumStat4.Text  := Str_F_To_Str(StrToFloat(edLeistPlWahl1Stat4.Text) + StrToFloat(edLeistPlWahl2Stat4.Text) + StrToFloat(edLeistPlNormStat4.Text), 8, 0);
  edLeistPlSumStat5.Text  := Str_F_To_Str(StrToFloat(edLeistPlWahl1Stat5.Text) + StrToFloat(edLeistPlWahl2Stat5.Text) + StrToFloat(edLeistPlNormStat5.Text), 8, 0);
  edLeistPlSumStat6.Text  := Str_F_To_Str(StrToFloat(edLeistPlWahl1Stat6.Text) + StrToFloat(edLeistPlWahl2Stat6.Text) + StrToFloat(edLeistPlNormStat6.Text), 8, 0);

  edLeistPlWahl1Summe.Text := Str_F_To_Str(StrToFloat(edLeistPlWahl1Stat1.Text) + StrToFloat(edLeistPlWahl1Stat2.Text) + StrToFloat(edLeistPlWahl1Stat3.Text) +
                                           StrToFloat(edLeistPlWahl1Stat4.Text) + StrToFloat(edLeistPlWahl1Stat5.Text) + StrToFloat(edLeistPlWahl1Stat6.Text), 8, 0);

  edLeistPlWahl2Summe.Text := Str_F_To_Str(StrToFloat(edLeistPlWahl2Stat1.Text) + StrToFloat(edLeistPlWahl2Stat2.Text) + StrToFloat(edLeistPlWahl2Stat3.Text) +
                                           StrToFloat(edLeistPlWahl2Stat4.Text) + StrToFloat(edLeistPlWahl2Stat5.Text) + StrToFloat(edLeistPlWahl2Stat6.Text), 8, 0);

  edLeistPlNormSumme.Text := Str_F_To_Str(StrToFloat(edLeistPlNormStat1.Text) + StrToFloat(edLeistPlNormStat2.Text) + StrToFloat(edLeistPlNormStat3.Text) +
                                          StrToFloat(edLeistPlNormStat4.Text) + StrToFloat(edLeistPlNormStat5.Text) + StrToFloat(edLeistPlNormStat6.Text), 8, 0);

  edLeistPlSumSumme.Text  := Str_F_To_Str(StrToFloat(edLeistPlSumStat1.Text) + StrToFloat(edLeistPlSumStat2.Text) + StrToFloat(edLeistPlSumStat3.Text) +
                                          StrToFloat(edLeistPlSumStat4.Text) + StrToFloat(edLeistPlSumStat5.Text) + StrToFloat(edLeistPlSumStat6.Text), 8, 0);

  edLeistSumFaelleAbtl.Text := edLeistPlSumSumme.Text;

end;


function TPrjFormsDecisionData.SaveGridPG2PersonalMassnahmen: Boolean;
begin
  Result := true;
  try
    if not (XDataWebDataSetPerfCat.State in [dsEdit]) then
      XDataWebDataSetPerfCat.Edit;
    if XDataWebDataSetPerfCat.State in [dsEdit] then
    begin
      XDataWebDataSetPerfCat.FieldByName('Hpcc_Employment_Med').AsFloat       := ed_PersMassEinstellungenArzt.Text.ToDouble;
      XDataWebDataSetPerfCat.FieldByName('Hpcc_Employment_Care').AsFloat      := ed_PersMassEinstellungenPflege.Text.ToDouble;
      XDataWebDataSetPerfCat.FieldByName('Hpcc_Unemployment_Med').AsFloat     := ed_PersMassEntlassungArzt.Text.ToDouble;
      XDataWebDataSetPerfCat.FieldByName('Hpcc_Unemployment_Care').AsFloat    := ed_PersMassEntlassungPflege.Text.ToDouble;
      XDataWebDataSetPerfCat.FieldByName('Hpcc_Training_Med').AsFloat         := ed_PersMassTrainingArzt.Text.ToDouble;
      XDataWebDataSetPerfCat.FieldByName('Hpcc_Training_Care').AsFloat        := ed_PersMassTrainingPflege.Text.ToDouble;

      XDataWebDataSetPerfCat.FieldByName('Hpcc_Extra_Cost_Med').AsFloat       := ed_PersMassNebenkostenArzt.Text.ToDouble;
      XDataWebDataSetPerfCat.FieldByName('Hpcc_Extra_Cost_Care').AsFloat      := ed_PersMassNebenkostenPflege.Text.ToDouble;
      XDataWebDataSetPerfCat.FieldByName('Hpcc_Extra_Cost_Institute').AsFloat := ed_PersMassNebenkostenInstitut.Text.ToDouble;

      XDataWebDataSetPerfCat.Post;
    end;
    XDataWebDataSetPerfCat.ApplyUpdates;
  except
    wxBaseWriteLog.Write('Exception raised in TPrjFormsDecisionData.SaveGridPG2PersonalMassnahmen',slDebug);
    result := false;
  end;
end;

function TPrjFormsDecisionData.DrawGridPG2PersonalMassnahmen: Boolean;
begin
  Result := true;
  try
    lb_MassHead.Caption                     := 'Personalmaßnahmen';
    lb_MassArztHead.Caption                 := 'Ärztliches Fachpersonal';
    lb_MassPflegeHead.Caption               := 'Pflege';
    lb_PersMassEinstellung.Caption          := 'Einstellungen';
    lb_PersMassEntlassung.Caption           := 'Entlassungen';
    lb_PersMassTraining.Caption             := 'Training';
    lb_PersMassNebenkosten.Caption          := 'Personal Nebenkosten';
    lb_PersMassEinstellungEinh.Caption      := '(Anzahl)';
    lb_PersMassEntlassungEinh.Caption       := '(Anzahl)';
    lb_PersMassTrainingEinh.Caption         := '(Tage pro Mitarbeiter)';
    lb_PersMassNebenkostenEinh.Caption      := '(%)';
    lb_PersMassNebenkostenInstitut.Caption  := 'Personal Nebenkosten der Institute';

    if not XDataWebDataSetPerfCat.IsEmpty then
    begin
      ed_PersMassEinstellungenArzt.Text   := Str_F_to_Str(XDataWebDataSetPerfCat.FieldByName('Hpcc_Employment_Med').AsFloat, 5, 0);
      ed_PersMassEinstellungenPflege.Text := Str_F_to_Str(XDataWebDataSetPerfCat.FieldByName('Hpcc_Employment_Care').AsFloat, 5, 0);

      ed_PersMassEntlassungArzt.Text      := Str_F_to_Str(XDataWebDataSetPerfCat.FieldByName('Hpcc_Unemployment_Med').AsFloat, 5, 0);
      ed_PersMassEntlassungPflege.Text    := Str_F_to_Str(XDataWebDataSetPerfCat.FieldByName('Hpcc_Unemployment_Care').AsFloat, 5, 0);

      ed_PersMassTrainingArzt.Text        := Str_F_to_Str(XDataWebDataSetPerfCat.FieldByName('Hpcc_Training_Med').AsFloat, 5, 0);
      ed_PersMassTrainingPflege.Text      := Str_F_to_Str(XDataWebDataSetPerfCat.FieldByName('Hpcc_Training_Care').AsFloat, 5, 0);

      ed_PersMassNebenkostenArzt.Text     := Str_F_to_Str(XDataWebDataSetPerfCat.FieldByName('Hpcc_Extra_Cost_Med').AsFloat, 5, 0);
      ed_PersMassNebenkostenPflege.Text   := Str_F_to_Str(XDataWebDataSetPerfCat.FieldByName('Hpcc_Extra_Cost_Care').AsFloat, 5, 0);

      ed_PersMassNebenkostenInstitut.Text := Str_F_to_Str(XDataWebDataSetPerfCat.FieldByName('Hpcc_Extra_Cost_Institute').AsFloat, 5, 0);
    end;
  except
    wxBaseWriteLog.Write('Exception raised in TPrjFormsDecisionData.DrawGridPG2PersonalMassnahmen',slDebug);
    result := false;
  end;
end;

procedure TPrjFormsDecisionData.edLeistPlWahl1Stat1Exit(Sender: TObject);
begin
  inherited;
  Self.DrawGridPG2LeistPlanungRedraw;
end;

procedure TPrjFormsDecisionData.ed_LeistKatWahlLeist1AnzAltZiExit(Sender: TObject);
begin
  Self.DrawGridPG2LeistKategorienRedraw;
end;

function TPrjFormsDecisionData.Init: Boolean;
begin
  try
    FFirstRun     := true;
    FPreCalcMode  := pctSave;
    WaitMessage.Show;

    spedAbteilung.MinValue  := 1;
    spedAbteilung.MaxValue  := 3;
    spedAbteilung.Value     := 1;


    spedKrankenhaus.Value     := DataModule.HBMDefaultData.AktuellesUnternehmen;
    spedKrankenhaus.Enabled   := DataModule.TokenInformation.isSpielleiter;
    spedKrankenhaus.MaxValue  := DataModule.HBMDefaultData.MaxAnzUnternehmen;
    spedKrankenhaus.MinValue  := DataModule.HBMDefaultData.MinAnzUnternehmen;

    spedPeriode.Value     := DataModule.HBMDefaultData.AktuellePeriode;
    spedPeriode.Enabled   := DataModule.TokenInformation.isSpielleiter;
    spedPeriode.MaxValue  := 9;
    spedPeriode.MinValue  := 0;

    pgcEntscheidungen.ActivePageIndex := 0;

    await(SetupData);

    {$IFDEF APPISTLN}
    DataModule.HBMDefaultData.Vorkalkulation        := HBMMainT.XDataWebDataSetModul.FieldByName('Upmd_Period_Precalc_Allowed').AsInteger;
    DataModule.HBMDefaultData.LaundryOutsourced     := HBMMainT.XDataWebDataSetModul.FieldByName('Upmd_Period_Outsourcing_Cleaning').AsInteger;
    DataModule.HBMDefaultData.CodierCaseManagement  := HBMMainT.XDataWebDataSetModul.FieldByName('Upmd_Period_Case_Management').AsInteger;
    DataModule.HBMDefaultData.WertPapiere           := HBMMainT.XDataWebDataSetModul.FieldByName('Upmd_Period_Securities').AsInteger;
    DataModule.HBMDefaultData.ErtragAuschuettung    := HBMMainT.XDataWebDataSetModul.FieldByName('Upmd_Period_Income_Distribution').AsInteger;
    DataModule.HBMDefaultData.KreditTilgung         := HBMMainT.XDataWebDataSetModul.FieldByName('Upmd_Period_Credit_Repay').AsInteger;
    DataModule.HBMDefaultData.FinanzSachanlagen     := HBMMainT.XDataWebDataSetModul.FieldByName('Upmd_Period_Fixed_Assets').AsInteger;
    {$ELSE}
    DataModule.HBMDefaultData.Vorkalkulation        := PrjFormsMain.XDataWebDataSetModul.FieldByName('Upmd_Period_Precalc_Allowed').AsInteger;
    DataModule.HBMDefaultData.LaundryOutsourced     := PrjFormsMain.XDataWebDataSetModul.FieldByName('Upmd_Period_Outsourcing_Cleaning').AsInteger;
    DataModule.HBMDefaultData.CodierCaseManagement  := PrjFormsMain.XDataWebDataSetModul.FieldByName('Upmd_Period_Case_Management').AsInteger;
    DataModule.HBMDefaultData.WertPapiere           := PrjFormsMain.XDataWebDataSetModul.FieldByName('Upmd_Period_Securities').AsInteger;
    DataModule.HBMDefaultData.ErtragAuschuettung    := PrjFormsMain.XDataWebDataSetModul.FieldByName('Upmd_Period_Income_Distribution').AsInteger;
    DataModule.HBMDefaultData.KreditTilgung         := PrjFormsMain.XDataWebDataSetModul.FieldByName('Upmd_Period_Credit_Repay').AsInteger;
    DataModule.HBMDefaultData.FinanzSachanlagen     := PrjFormsMain.XDataWebDataSetModul.FieldByName('Upmd_Period_Fixed_Assets').AsInteger;
    {$ENDIF}

    DataModule.HBMDefaultData.AktuelleAbteilung := spedAbteilung.Value;
    RFE_AbteilungName.Text := Abteilungen.FindAssignment(spedAbteilung.Value).FContent;
    spedAbteilung.OnChange := Self.spedAbteilungChanged;


    {$IFDEF APPISADMIN}
    Self.UnsetReadOnlyFlag(false);
    {$ENDIF}
    Self.UnsetReadOnlyFlag(false);


    WaitMessage.Hide;
  except
    result := false;
    wxBaseWriteLog.Write('Exception raised in TPrjFormsDecisionData.Init',slDebug);
    WaitMessage.Hide;
  end;
end;

function TPrjFormsDecisionData.ReInit: Boolean;
var LModalResult : TModalResult;
begin
  try

    FFirstRun := true;

    spedAbteilung.OnChange    := nil;
    spedKrankenhaus.OnChange  := nil;
    spedPeriode.OnChange      := nil;

    DataModule.HBMDefaultData.AktuellePeriode       := spedPeriode.Value ;
    DataModule.HBMDefaultData.AktuellesUnternehmen  := spedKrankenhaus.Value;

    LModalResult := await(TModalResult, WebMessageDlg.ShowDialog(cInterMediateSvaeMsg, mtConfirmation, [mbYes,mbNo]));
    if LModalResult = mrYes then
    begin
      await(SaveData);
    end;
    WaitMessage.Show;

    await(SetupData);

    RFE_AbteilungName.Text      := Abteilungen.FindAssignment(spedAbteilung.Value).FContent;
    lb_LeistKatStation.Caption  := Abteilungen.FindAssignment(spedAbteilung.Value).FContent;

    {$IFDEF APPISTLN}
    DataModule.HBMDefaultData.Vorkalkulation        := HBMMainT.XDataWebDataSetModul.FieldByName('Upmd_Period_Precalc_Allowed').AsInteger;
    DataModule.HBMDefaultData.LaundryOutsourced     := HBMMainT.XDataWebDataSetModul.FieldByName('Upmd_Period_Outsourcing_Cleaning').AsInteger;
    DataModule.HBMDefaultData.CodierCaseManagement  := HBMMainT.XDataWebDataSetModul.FieldByName('Upmd_Period_Case_Management').AsInteger;
    DataModule.HBMDefaultData.WertPapiere           := HBMMainT.XDataWebDataSetModul.FieldByName('Upmd_Period_Securities').AsInteger;
    DataModule.HBMDefaultData.ErtragAuschuettung    := HBMMainT.XDataWebDataSetModul.FieldByName('Upmd_Period_Income_Distribution').AsInteger;
    DataModule.HBMDefaultData.KreditTilgung         := HBMMainT.XDataWebDataSetModul.FieldByName('Upmd_Period_Credit_Repay').AsInteger;
    DataModule.HBMDefaultData.FinanzSachanlagen     := HBMMainT.XDataWebDataSetModul.FieldByName('Upmd_Period_Fixed_Assets').AsInteger;
    {$ELSE}
    DataModule.HBMDefaultData.Vorkalkulation        := PrjFormsMain.XDataWebDataSetModul.FieldByName('Upmd_Period_Precalc_Allowed').AsInteger;
    DataModule.HBMDefaultData.LaundryOutsourced     := PrjFormsMain.XDataWebDataSetModul.FieldByName('Upmd_Period_Outsourcing_Cleaning').AsInteger;
    DataModule.HBMDefaultData.CodierCaseManagement  := PrjFormsMain.XDataWebDataSetModul.FieldByName('Upmd_Period_Case_Management').AsInteger;
    DataModule.HBMDefaultData.WertPapiere           := PrjFormsMain.XDataWebDataSetModul.FieldByName('Upmd_Period_Securities').AsInteger;
    DataModule.HBMDefaultData.ErtragAuschuettung    := PrjFormsMain.XDataWebDataSetModul.FieldByName('Upmd_Period_Income_Distribution').AsInteger;
    DataModule.HBMDefaultData.KreditTilgung         := PrjFormsMain.XDataWebDataSetModul.FieldByName('Upmd_Period_Credit_Repay').AsInteger;
    DataModule.HBMDefaultData.FinanzSachanlagen     := PrjFormsMain.XDataWebDataSetModul.FieldByName('Upmd_Period_Fixed_Assets').AsInteger;
    {$ENDIF}

    spedAbteilung.OnChange    := Self.spedAbteilungChanged;
    spedKrankenhaus.OnChange  := Self.spedKrankenhausChange;
    spedPeriode.OnChange      := Self.spedPeriodeChange;

    WaitMessage.Hide;
  except
    result := false;
    wxBaseWriteLog.Write('Exception raised in TPrjFormsDecisionData.ReInit',slDebug);
    WaitMessage.Hide;

  end;
end;

function TPrjFormsDecisionData.InteractiveSaveLockData(AQuickSave: Boolean = false): Boolean;
var LModalResult : TModalResult;
begin

  if DataModule.TokenInformation.isTeilnehmer then
  begin
    LModalResult := await(TModalResult, WebMessageDlg.ShowDialog(cEDataSaveLockMsg, mtConfirmation, [mbYes,mbNo]));
  end else
  begin
    LModalResult := await(TModalResult, WebMessageDlg.ShowDialog(cEDataSaveLockMsg, mtConfirmation, [mbYes,mbNo]));

  end;


  if LModalResult = mrYes then
  begin
    try
      Result := await(SaveData);
    except
      result := false;
    end;
  end else
  begin
    result := false;
  end;
  DataChanged := result;
  if not AQuickSave then
    close;
end;

procedure TPrjFormsDecisionData.RFE_KrdKurzExit(Sender: TObject);
var LValue : double;
var LFormatSettings : TFormatSettings;
begin
  LFormatSettings.DateSeparator     := '-';
  LFormatSettings.DecimalSeparator  := ',';
  LFormatSettings.ThousandSeparator := '.';

  LFormatSettings.ShortTimeFormat   := 'hh:nn:ss.zzz';
  LFormatSettings.ShortDateFormat   := 'dd.mm.yyyy';

  if TryStrToFloat( (Sender as TDBEdit).Text, LValue) then
  begin
    (Sender as TDBEdit).Text := FormatFloat(cFloatMask2Decimals, LValue, LFormatSettings);
  end;
end;

function TPrjFormsDecisionData.SaveData: Boolean;
begin
  Result := true;
  try
    SaveGridPG1Leistungsplanung;
    SaveGridPG1LeistungsKategorien;

    if XDataWebDataSetPerfPlan.State in [dsEdit] then
    begin
      XDataWebDataSetPerfPlan.Post;
      XDataWebDataSetPerfPlan.ApplyUpdates;
      XDataWebDataSetPerfPlan.Edit;
    end;
    if XDataWebDataSetPerfCat.State in [dsEdit] then
    begin
      XDataWebDataSetPerfCat.Post;
      XDataWebDataSetPerfCat.ApplyUpdates;
      XDataWebDataSetPerfCat.Edit;
    end;
    if XDataWebDataSetPerfMisc.State in [dsEdit] then
    begin
      XDataWebDataSetPerfMisc.Post;
      XDataWebDataSetPerfMisc.ApplyUpdates;
      XDataWebDataSetPerfMisc.Edit;
    end;
  except
    wxBaseWriteLog.Write('Exception raised in TPrjFormsDecisionData.SaveData while saving desicion data',slDebug);
    result := false;
  end;
end;

function TPrjFormsDecisionData.SetUpPage1(AFirstRun: Boolean = false): Boolean;
begin
  Result := true;
  try
    if FFirstRun then
    begin
      await(DrawGridPG1Leistungsplanung);
      FFirstRun := false;
    end;

    cbxOutsourceWaescherei.Enabled  := DataModule.HBMDefaultData.LaundryOutsourced <= DataModule.HBMDefaultData.AktuellePeriode;
    cb_CodD.Enabled                 := DataModule.HBMDefaultData.CodierCaseManagement <= DataModule.HBMDefaultData.AktuellePeriode;

  except
    wxBaseWriteLog.Write('Exception raised in TPrjFormsDecisionData.SetUpPage1 while setting up data',slDebug);
    Result := false;
  end;
end;

function TPrjFormsDecisionData.SetUpPage2(AFirstRun: Boolean = false): Boolean;
begin
  Result := true;
  try
    if FFirstRun then
    begin
      await(DrawGridPG2LeistKategorien);
      await(DrawGridPG2LeistKategorienRedraw);
      await(DrawGridPG2PersonalMassnahmen);
      FFirstRun := false;
    end;

    RFE_AbteilungName.Text      := Abteilungen.FindAssignment(DataModule.HBMDefaultData.AktuelleAbteilung).FContent;
    lb_LeistKatStation.Caption  := Abteilungen.FindAssignment(spedAbteilung.Value).FContent;


    if Self.spedAbteilung.Value = 1 then
    begin
      LA3_Abt2.Caption  := Abteilungen.FindAssignment(2).FContent;
      LA3_Abt3.Caption  := Abteilungen.FindAssignment(3).FContent;
    end else if Self.spedAbteilung.Value = 2 then
    begin
      LA3_Abt2.Caption := Abteilungen.FindAssignment(1).FContent;
      LA3_Abt3.Caption := Abteilungen.FindAssignment(3).FContent;
    end else if Self.spedAbteilung.Value = 3 then
    begin
      LA3_Abt2.Caption := Abteilungen.FindAssignment(1).FContent;
      LA3_Abt3.Caption := Abteilungen.FindAssignment(2).FContent;
    end;

    La5_Abt1.Caption := Abteilungen.FindAssignment(1).FContent;
    La5_Abt2.Caption := Abteilungen.FindAssignment(2).FContent;
    La5_Abt3.Caption := Abteilungen.FindAssignment(3).FContent;
  except
    wxBaseWriteLog.Write('Exception raised in TPrjFormsDecisionData.SetUpPage2 while setting up data',slDebug);
    Result := false;
  end;
end;

procedure TPrjFormsDecisionData.spedAbteilungChanged(Sender: TObject);
begin
  DataModule.HBMDefaultData.AktuelleAbteilung := Round(spedAbteilung.Value);
  Self.ReInit;
end;

procedure TPrjFormsDecisionData.spedKrankenhausChange(Sender: TObject);
begin
  if DataModule.TokenInformation.isSpielleiter then
  begin
    DataModule.HBMDefaultData.AktuellesUnternehmen := Round(spedKrankenhaus.Value);
    Self.ReInit;
  end;
end;

procedure TPrjFormsDecisionData.spedPeriodeChange(Sender: TObject);
begin
  if DataModule.TokenInformation.isSpielleiter then
  begin
    DataModule.HBMDefaultData.AktuellePeriode := Round(spedPeriode.Value);
    Self.ReInit;
  end;
//  Self.SetUpPage3();
end;

procedure TPrjFormsDecisionData.webBtnSaveClick(Sender: TObject);
begin
  FPreCalcMode := pctSave;
end;

procedure TPrjFormsDecisionData.btnSaveAndLockClick(Sender: TObject);
begin
  FPreCalcMode := pctSaveAndLock;
  InteractiveSaveLockData;
end;

function TPrjFormsDecisionData.strGridPersonalMassnahmenGesperrt(aCol, aRow: Integer): Boolean;
begin
  result := not (((aRow > 0) and (aRow < 5) and (aCol > 1)) or ((aRow = 6) and (aCol = 2)));
end;

procedure TPrjFormsDecisionData.pgcEntscheidungenChange(Sender: TObject);
begin
  if pgcEntscheidungen.ActivePageIndex = 0 then
  begin
    spedAbteilung.Enabled   := true;
    spedKrankenhaus.Enabled := true;
    spedPeriode.Enabled     := true;
  end else if pgcEntscheidungen.ActivePageIndex = 1 then
  begin
    spedAbteilung.Enabled   := true;
    spedKrankenhaus.Enabled := true;
    spedPeriode.Enabled     := true;
  end else if pgcEntscheidungen.ActivePageIndex = 2 then
  begin
    spedAbteilung.Enabled   := false;
    spedKrankenhaus.Enabled := true;
    spedPeriode.Enabled     := true;
  end;
  if DataModule.TokenInformation.isTeilnehmer then
  begin
    spedKrankenhaus.Enabled := false;
    spedPeriode.Enabled     := false;
  end;
  ToggleGUI;
end;

procedure TPrjFormsDecisionData.strGridLeistungskategorienValidateEdit(Sender: TObject; ACol, ARow: LongInt; var Value: string);
begin
  Value := StripDigits(Value);
end;

procedure TPrjFormsDecisionData.strGridPersonalMassnahmenCanEditCell(Sender: TObject; ACol, ARow: Integer; var CanEdit: Boolean);
begin
  CanEdit := not strGridPersonalMassnahmenGesperrt(ACol, ARow);
end;

procedure TPrjFormsDecisionData.strGridPersonalMassnahmenGetCellEditor(Sender: TObject; ACol, ARow: Integer; var AEditor: TGridCellEditor);
begin
  AEditor := geText;
end;

procedure TPrjFormsDecisionData.strGridPersonalMassnahmenValidateEdit(Sender: TObject; ACol, ARow: LongInt; var Value: string);
begin
  Value := StripDigits(Value);
end;

procedure TPrjFormsDecisionData.ToggleGUI;
begin
  if (not XDataWebDataSetFaelle.IsEmpty) and
     (not XDataWebDataSetPerfPlan.IsEmpty) and
     (not XDataWebDataSetPerfCat.IsEmpty) and
     (not XDataWebDataSetPerfMisc.IsEmpty) then
//     (not XDataWebDataSetKPIData.IsEmpty) then
  begin
    SetupPage1(FFirstRun);
    SetUpPage2(FFirstRun);
//    SetUpPage3(FFirstRun);


    if DataModule.HBMDefaultData.AktuellePeriode < DataModule.HBMDefaultData.Vorkalkulation then
      FDecisionMode := dcmDecision
    else if DataModule.HBMDefaultData.AktuellePeriode >= DataModule.HBMDefaultData.Vorkalkulation then
      FDecisionMode := dcmPlanCalculation
    else
      FDecisionMode := dcmNone;


    btnSaveAndLock.enabled := False;
    btnSave.enabled        := False;

    case FDecisionMode of
      dcmNone             : begin
                              btnSaveAndLock.enabled := False;
                              btnSave.enabled        := False;
                            end;
      dcmDecision        :  begin
                              btnSave.enabled         := False;

                              btnSaveAndLock.Enabled  := not DataModule.HBMDefaultData.TLNIsLocked;
                              btnSaveAndLock.Caption  := 'Speichern und abschließen...';
                              if (DataModule.TokenInformation.isSpielleiter) or (DataModule.TokenInformation.isAdministrator) then
                              begin
                                btnSaveAndLock.Caption  := 'SPL-Daten speichern';
                                btnSaveAndLock.enabled  := true;
                              end;
                            end;
      dcmPlanCalculation :  begin
                              btnSave.enabled         := False;
                              btnSaveAndLock.enabled  := XDataWebDataSetPerfPlan.FieldByName('HPPG_CALCULATION_COUNT').AsInteger <= cMaxClientCalculationCount;
                              btnSaveAndLock.Caption  := 'Speichern und Rechnen..';
//                              btnSave.enabled         := XDataWebDataSetPerfPlan.FieldByName('HPPG_CALCULATION_COUNT').AsInteger <= cMaxClientCalculationCount;
                              if (DataModule.TokenInformation.isSpielleiter) or (DataModule.TokenInformation.isAdministrator) then
                              begin
                                btnSaveAndLock.Caption  := 'SPL-Daten speichern und rechnen';
                                btnSaveAndLock.enabled  := true;
                              end;
                            end;
    end;
  end;

end;

procedure TPrjFormsDecisionData.WebFormCreate(Sender: TObject);
begin
  inherited;
  Self.FormIdentifier := wxFrmDescisionData;
  Self.CallingForm    := wxFrmPeriodenKalkulationTLN;
  Self.FPreCalcMode   := pctSave;
end;

function TPrjFormsDecisionData.SetupData: Boolean;
begin
  Result := true;
  try
    XDataWebDataSetPerfPlan.Cancel;
    XDataWebDataSetPerfCat.Cancel;
    XDataWebDataSetPerfMisc.Cancel;
    XDataWebDataSetFaelle.Cancel;
    XDataWebDataSetKPIData.Cancel;
    XDataWebDataSetPerfPlan.Close;
    XDataWebDataSetPerfCat.Close;
    XDataWebDataSetPerfMisc.Close;
    XDataWebDataSetFaelle.Close;
    XDataWebDataSetKPIData.Close;

    {$IFDEF APPISTLN}
    XDataWebDataSetPerfPlan.Connection    := HBMMainT.XDataWebConnectionMain;
    XDataWebDataSetPerfCat.Connection     := HBMMainT.XDataWebConnectionMain;
    XDataWebDataSetPerfMisc.Connection    := HBMMainT.XDataWebConnectionMain;
    XDataWebDataSetFaelle.Connection      := HBMMainT.XDataWebConnectionMain;
    XDataWebDataSetKPIData.Connection     := HBMMainT.XDataWebConnectionMain;
    {$ELSE}
    XDataWebDataSetPerfPlan.Connection    := PrjFormsMain.XDataWebConnectionMain;
    XDataWebDataSetPerfCat.Connection     := PrjFormsMain.XDataWebConnectionMain;
    XDataWebDataSetPerfMisc.Connection    := PrjFormsMain.XDataWebConnectionMain;
    XDataWebDataSetFaelle.Connection      := PrjFormsMain.XDataWebConnectionMain;
    XDataWebDataSetKPIData.Connection     := PrjFormsMain.XDataWebConnectionMain;
    {$ENDIF}
    XDataWebDataSetPerfPlan.QueryString   := '$filter=(Hppg_Simulation_Id eq ' + DataAccess.AktuelleSimulation.toString + ') AND ' +
//                                             '(Hppg_Period_Id eq ' + Self.spedPeriode.Value.ToString + ') AND ' +
                                             '(Hppg_Period_Id le ' + Self.spedPeriode.Value.ToString + ') AND ' +
                                             '(Hppg_Hospital_Id eq ' + Self.spedKrankenhaus.Value.ToString + ') AND ' +
                                             '(Hppg_Department_Id eq ' + Self.spedAbteilung.Value.ToString + ')&$orderby=Hppg_Drg_Display_Order' ;


    XDataWebDataSetPerfCat.QueryString   := '$filter=(Hpcc_Simulation_Id eq ' + DataAccess.AktuelleSimulation.toString + ') AND ' +
                                            '(Hpcc_Periodic_Id eq ' + Self.spedPeriode.Value.ToString + ') AND ' +
                                            '(Hpcc_Hospital_Id eq ' + Self.spedKrankenhaus.Value.ToString + ') AND ' +
                                            '(Hpcc_Department_Id eq ' + Self.spedAbteilung.Value.ToString + ')&$orderby=Hpcc_Display_Order' ;

    XDataWebDataSetPerfMisc.QueryString  := '$filter=(Hbpm_Simulation_Id eq ' + DataAccess.AktuelleSimulation.toString + ') AND ' +
                                            '(Hbpm_Period_Id eq ' + Self.spedPeriode.Value.ToString + ') AND ' +
                                            '(Hbpm_Hospital_Id eq ' + Self.spedKrankenhaus.Value.ToString + ')';

    XDataWebDataSetFaelle.QueryString   := '$filter=(Mafa_Valid_Period le ' + Self.spedPeriode.Value.ToString + ') AND ' +
                                            '(Mafa_Department_Id eq ' + Self.spedAbteilung.Value.ToString + ')&$orderby=Mafa_order_by' ;

    await(XDataWebDataSetPerfPlan.Load);
    await(XDataWebDataSetPerfCat.Load);
    await(XDataWebDataSetPerfMisc.Load);
    await(XDataWebDataSetFaelle.Load);
  except
    wxBaseWriteLog.Write('Exception occured in modul TPrjFormsDecisionData.SetupData', slError);
    Result := false;
  end;

end;

function TPrjFormsDecisionData.SetUpPage3(AFirstRun: Boolean = false): Boolean;
var LSection        : TTMSFNCWidgetGaugeSection;
var LNeedle         : TTMSFNCWidgetGaugeNeedleItem;
var LSearchOptions  : TLocateOptions;
var LKPIKeyPoint    : integer;
var LIdx            : integer;
begin
  Result := true;
  try
//    LSearchOptions  := [];
//
//    strgKPIData.ColCount  := 4;
//    strgKPIData.FixedCols := 1;
//    strgKPIData.RowCount  := cKPIPoints + 3;
//    strgKPIData.ColWidths[0] := 500;
//    strgKPIData.ColWidths[1] := 100;
//    strgKPIData.ColWidths[2] := 100;
//    strgKPIData.ColWidths[3] := 100;
//    strgKPIData.Cells[1, 0] := 'KH ' + spedKrankenhaus.Value.ToString;
////    strgKPIData.Cells[2, 0] := 'KH ' + spedKrankenhaus.Value.ToString;
////    strgKPIData.Cells[3, 0] := 'Planung';
//
//    strgKPIData.Cells[0, 1] := 'Name';
//    strgKPIData.Cells[1, 1] := 'Ist GJ ' + spedPeriode.Value.ToString;
//    strgKPIData.Cells[2, 1] := 'Abw.';
//    strgKPIData.Cells[3, 1] := 'GJ ' + (spedPeriode.Value + 1).ToString;
//
//    // Hier werden die Gauges dynamisch mit Daten befüllt
//
////    for LKPIKeyPoint := 0 to cKPIPoints do
////    begin
//      while not XDataWebDataSetKPIData.Eof do
//      begin
//
////      if XDataWebDataSetKPIData.Locate('HKPI_POINT_VALUE_INDEX', LKPIKeyPoint, LSearchOptions ) then
////      begin
//        for LIdx := 0 to ComponentCount -1 do
//        begin
////          if (Components[LIdx] is TTMSFNCWidgetGauge) and (TTMSFNCWidgetGauge(Components[LIdx]).Tag = LKPIKeyPoint) then
//          if (Components[LIdx] is TTMSFNCWidgetGauge) and (TTMSFNCWidgetGauge(Components[LIdx]).Tag = XDataWebDataSetKPIData.FieldByName('HKPI_POINT_VALUE_INDEX').AsInteger) then
//          begin
//            strgKPIData.Cells[0, LKPIKeyPoint + 2] := XDataWebDataSetKPIData.FieldByName('HKPI_NAME').AsString;
//            strgKPIData.Cells[1, LKPIKeyPoint + 2] := FormatFloat('#,##0.000', XDataWebDataSetKPIData.FieldByName('HKPI_ACTUAL_VALUE').AsFloat);
//            strgKPIData.Cells[2, LKPIKeyPoint + 2] := FormatFloat('#,##0.000', XDataWebDataSetKPIData.FieldByName('HKPI_DIFFERENCE_VALUE').AsFloat);
//            TTMSFNCWidgetGauge(Components[LIdx]).Value              := XDataWebDataSetKPIData.FieldByName('HKPI_ACTUAL_VALUE').AsFloat;
//            TTMSFNCWidgetGauge(Components[LIdx]).MinimumValue       := XDataWebDataSetKPIData.FieldByName('HKPI_MINIMUM_VALUE').AsFloat;
//            TTMSFNCWidgetGauge(Components[LIdx]).MaximumValue       := XDataWebDataSetKPIData.FieldByName('HKPI_MAXIMUM_VALUE').AsInteger;
//            TTMSFNCWidgetGauge(Components[LIdx]).OuterCircle.Color  := gcDarkslategray;
//            TTMSFNCWidgetGauge(Components[LIdx]).InnerCircle.Color  := gcLightgray;
//            TTMSFNCWidgetGauge(Components[LIdx]).OuterRim.Color     := gcLightgray;
//            TTMSFNCWidgetGauge(Components[LIdx]).Arc.Color          := gcMedGray;
//            TTMSFNCWidgetGauge(Components[LIdx]).Arc.Threshold.Color    := gcDarkslategray;
//            TTMSFNCWidgetGauge(Components[LIdx]).Digit.BackGroundColor  := gcWhite;
//            TTMSFNCWidgetGauge(Components[LIdx]).DialText               := XDataWebDataSetKPIData.FieldByName('HKPI_NAME').AsString;
//            case LKPIKeyPoint of
//              0 : weblblDescriptionKPI1.Caption := XDataWebDataSetKPIData.FieldByName('HKPI_NAME').AsString;
//              1 : weblblDescriptionKPI2.Caption := XDataWebDataSetKPIData.FieldByName('HKPI_NAME').AsString;
//              2 : weblblDescriptionKPI3.Caption := XDataWebDataSetKPIData.FieldByName('HKPI_NAME').AsString;
//              3 : weblblDescriptionKPI4.Caption := XDataWebDataSetKPIData.FieldByName('HKPI_NAME').AsString;
//              4 : weblblDescriptionKPI5.Caption := XDataWebDataSetKPIData.FieldByName('HKPI_NAME').AsString;
//              5 : weblblDescriptionKPI6.Caption := XDataWebDataSetKPIData.FieldByName('HKPI_NAME').AsString;
//              6 : weblblDescriptionKPI7.Caption := XDataWebDataSetKPIData.FieldByName('HKPI_NAME').AsString;
//              7 : weblblDescriptionKPI8.Caption := XDataWebDataSetKPIData.FieldByName('HKPI_NAME').AsString;
//              8 : weblblDescriptionKPI9.Caption := XDataWebDataSetKPIData.FieldByName('HKPI_NAME').AsString;
//            end;
//
//            TTMSFNCWidgetGauge(Components[LIdx]).Font.Color             := gcBlack;
//            TTMSFNCWidgetGauge(Components[LIdx]).Font.Size              := 6;
//
//            TTMSFNCWidgetGauge(Components[LIdx]).ValueFont.Size         := 10;
//            TTMSFNCWidgetGauge(Components[LIdx]).ValueFormat            := '0.000';
//            TTMSFNCWidgetGauge(Components[LIdx]).Sections.BeginUpdate;
//            try
//              LSection              := TTMSFNCWidgetGauge(Components[LIdx]).Sections.Add;
//              LSection.StartValue   := XDataWebDataSetKPIData.FieldByName('HKPI_RED_FROM_VALUE').AsFloat;
//              LSection.EndValue     := XDataWebDataSetKPIData.FieldByName('HKPI_RED_TO_VALUE').AsFloat;
//              LSection.Color        := gcRed;
//              LSection.SectionType  := stBorder;
//              LSection              := TTMSFNCWidgetGauge(Components[LIdx]).Sections.Add;
//              LSection.StartValue   := XDataWebDataSetKPIData.FieldByName('HKPI_YELLOW_FROM_VALUE').AsFloat;
//              LSection.EndValue     := XDataWebDataSetKPIData.FieldByName('HKPI_YELLOW_TO_VALUE').AsFloat;
//              LSection.Color        := gcYellow;
//              LSection.SectionType  := stBorder;
//              LSection              := TTMSFNCWidgetGauge(Components[LIdx]).Sections.Add;
//              LSection.StartValue   := XDataWebDataSetKPIData.FieldByName('HKPI_GREEN_FROM_VALUE').AsFloat;
//              LSection.EndValue     := XDataWebDataSetKPIData.FieldByName('HKPI_GREEN_TO_VALUE').AsFloat;
//              LSection.Color        := gcGreen;
//              LSection.SectionType  := stBorder;
//            finally
//              TTMSFNCWidgetGauge(Components[LIdx]).Sections.EndUpdate;
//            end;
//            LNeedle               := TTMSFNCWidgetGauge(Components[LIdx]).ExtraNeedles.Add;
//            LNeedle.ShineColor    := gcRed;
//            LNeedle.ShineColorTo  := gcOrangeRed;
//            LNeedle.Value         := XDataWebDataSetKPIData.FieldByName('HKPI_SETPOINT_VALUE').AsFloat;
//          end;
//        end;
//        XDataWebDataSetKPIData.Next;
//      end;
////    end;
  except
    wxBaseWriteLog.Write('Exception raised in TPrjFormsDecisionData.SetUpPage3 while setting up data',slDebug);
    Result := false;
  end;
end;

function TPrjFormsDecisionData.UnsetReadOnlyFlag(AFlag: Boolean): Boolean;
begin
  Result := true;
  ed_LeistKatWahlLeist1AnzAltZi.ReadOnly    := AFlag;
  ed_LeistKatWahlLeist2AnzAltZi.ReadOnly    := AFlag;
  ed_LeistKatNormalAnzAltZi.ReadOnly        := AFlag;
  ed_LeistKatWahlLeist1AnzAltBt.ReadOnly    := AFlag;
  ed_LeistKatWahlLeist2AnzAltBt.ReadOnly    := AFlag;
  ed_LeistKatNormalAnzAltBt.ReadOnly        := AFlag;
  ed_LeistKatWahlLeist1Umwandlung.ReadOnly  := AFlag;
  ed_LeistKatWahlLeist2Umwandlung.ReadOnly  := AFlag;
  ed_LeistKatNormalUmwandlung.ReadOnly      := AFlag;
  ed_LeistKatWahlLeist1ErwAbbau.ReadOnly    := AFlag;
  ed_LeistKatWahlLeist2ErwAbbau.ReadOnly    := AFlag;
  ed_LeistKatNormalErwAbbau.ReadOnly        := AFlag;
  ed_LeistKatWahlLeist1AnzNeuZi.ReadOnly    := AFlag;
  ed_LeistKatWahlLeist2AnzNeuZi.ReadOnly    := AFlag;
  ed_LeistKatNormalAnzNeuZi.ReadOnly        := AFlag;
  ed_LeistKatWahlLeist1AnzNeuBt.ReadOnly    := AFlag;
  ed_LeistKatWahlLeist2AnzNeuBt.ReadOnly    := AFlag;
  ed_LeistKatWahlLeist1Zuschlag.ReadOnly    := AFlag;
  ed_LeistKatWahlLeist2Zuschlag.ReadOnly    := AFlag;
  ed_LeistKatNormalZuschlag.ReadOnly        := AFlag;
  ed_LeistKatNormalAnzNeuBt.ReadOnly        := AFlag;
end;

procedure TPrjFormsDecisionData.XDataWebDataSetFaelleAfterOpen(DataSet: TDataSet);
begin
  if XDataWebDataSetFaelle.Active then
  begin
    ToggleGUI;
  end;
end;

procedure TPrjFormsDecisionData.XDataWebDataSetKPIDataAfterOpen(DataSet: TDataSet);
begin
  if not XDataWebDataSetKPIData.IsEmpty then
  begin
//    XDataWebDataSetKPIData.Edit;
//    Self.SetUpPage3();
    ToggleGUI;
  end else
  begin
    wxBaseWriteLog.Write('no records found for Table [' + XDataWebDataSetKPIData.EntitySetName + ']', slDebug);
  end;
end;

procedure TPrjFormsDecisionData.XDataWebDataSetKPIDataEditError(DataSet: TDataSet; E: EDatabaseError; var Action: TDataAction);
begin
  wxBaseWriteLog.Write('Error occures on Table [' + XDataWebDataSetKPIData.EntitySetName + '] while editing : ' + e.Message, slDebug);
end;

procedure TPrjFormsDecisionData.XDataWebDataSetPerfCatAfterOpen(DataSet: TDataSet);
begin
  if not XDataWebDataSetPerfCat.IsEmpty then
  begin
    XDataWebDataSetPerfCat.Edit;
    ToggleGUI;
  end else
  begin
    wxBaseWriteLog.Write('no records found for Table [' + XDataWebDataSetPerfCat.EntitySetName + ']', slDebug);
  end;
end;

procedure TPrjFormsDecisionData.XDataWebDataSetPerfCatEditError(DataSet: TDataSet; E: EDatabaseError; var Action: TDataAction);
begin
  wxBaseWriteLog.Write('Error occures on Table [' + XDataWebDataSetPerfCat.EntitySetName + '] while editing : ' + e.Message, slDebug);
end;

procedure TPrjFormsDecisionData.XDataWebDataSetPerfMiscAfterOpen(DataSet: TDataSet);
begin
  if not XDataWebDataSetPerfMisc.IsEmpty then
  begin
    XDataWebDataSetPerfMisc.Edit;
    ToggleGUI;
  end else
  begin
    wxBaseWriteLog.Write('no records found for Table [' + XDataWebDataSetPerfMisc.EntitySetName + ']', slDebug);
  end;
end;

procedure TPrjFormsDecisionData.XDataWebDataSetPerfPlanAfterOpen(DataSet: TDataSet);
begin
  if not XDataWebDataSetPerfPlan.IsEmpty then
  begin
    XDataWebDataSetPerfPlan.Edit;
    console.log('TLN is lockd = ' + XDataWebDataSetPerfPlan.FieldByName('HPPG_TLN_ISLOCKED').AsInteger.ToString);
    DataModule.HBMDefaultData.TLNIsLocked := XDataWebDataSetPerfPlan.FieldByName('HPPG_TLN_ISLOCKED').AsInteger = 1;
    ToggleGUI;
  end else
  begin
    wxBaseWriteLog.Write('no records found for Table  [' + XDataWebDataSetPerfPlan.EntitySetName + ']', slDebug);
  end;
end;

procedure TPrjFormsDecisionData.XDataWebDataSetPerfPlanEditError(DataSet: TDataSet; E: EDatabaseError; var Action: TDataAction);
begin
  wxBaseWriteLog.Write('Error occures on Table [' + XDataWebDataSetPerfPlan.EntitySetName + '] while editing : ' + e.Message, slDebug);
end;

procedure TPrjFormsDecisionData.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pgcEntscheidungen := TPageControl.Create('decisionDataTabControl');
  pgcSheetFaelleInstitute := TTabSheet.Create('SheetFaelleInstitute');
  pnInstitutsEntscheidungen := TPanel.Create('pnOutsourcingAlternativen');
  lblOutsourcingAlternativen := TLabel.Create('outsourcingHeadline');
  lblLaundryAktiv := TLabel.Create('outsourcingCheckboxLabel');
  cbxOutsourceWaescherei := TDBCheckBox.Create('outsourcingCheckbox');
  pnLeistungsPlanung := TPanel.Create('pnLeistungsPlanung');
  WebLabel16 := TLabel.Create('leistungsplanungHeadline');
  WebLabel11 := TLabel.Create('ed_LeistPlStationenHead');
  WebLabel12 := TLabel.Create('ed_LeistPlWahlleistungEinsHead');
  WebLabel14 := TLabel.Create('edLeistPlWahl2Head');
  WebLabel15 := TLabel.Create('edLeistPlNormHead');
  WebLabel21 := TLabel.Create('edLeistPlSumHead');
  WebLabel22 := TLabel.Create('edLeistSumFaelleAbtlHead');
  ed_LeistPlAbteilung := TEdit.Create('ed_LeistPlAbteilung');
  ed_LeistPlStation1 := TEdit.Create('ed_LeistPlStation1');
  ed_LeistPlStation2 := TEdit.Create('ed_LeistPlStation2');
  ed_LeistPlStation3 := TEdit.Create('ed_LeistPlStation3');
  ed_LeistPlStation5 := TEdit.Create('ed_LeistPlStation5');
  ed_LeistPlStation4 := TEdit.Create('ed_LeistPlStation4');
  ed_LeistPlStation6 := TEdit.Create('ed_LeistPlStation6');
  ed_LeistPlStationSumme := TEdit.Create('ed_LeistPlStationSumme');
  edLeistPlWahl1Stat1 := TEdit.Create('edLeistPlWahl1Stat1');
  edLeistPlWahl1Stat2 := TEdit.Create('edLeistPlWahl1Stat2');
  edLeistPlWahl1Stat3 := TEdit.Create('edLeistPlWahl1Stat3');
  edLeistPlWahl1Stat5 := TEdit.Create('edLeistPlWahl1Stat5');
  edLeistPlWahl1Stat4 := TEdit.Create('edLeistPlWahl1Stat4');
  edLeistPlWahl1Stat6 := TEdit.Create('edLeistPlWahl1Stat6');
  edLeistPlWahl1Summe := TEdit.Create('edLeistPlWahl1Summe');
  edLeistPlWahl2Stat1 := TEdit.Create('edLeistPlWahl2Stat1');
  edLeistPlWahl2Stat2 := TEdit.Create('edLeistPlWahl2Stat2');
  edLeistPlWahl2Stat3 := TEdit.Create('edLeistPlWahl2Stat3');
  edLeistPlWahl2Stat5 := TEdit.Create('edLeistPlWahl2Stat5');
  edLeistPlWahl2Stat4 := TEdit.Create('edLeistPlWahl2Stat4');
  edLeistPlWahl2Stat6 := TEdit.Create('edLeistPlWahl2Stat6');
  edLeistPlWahl2Summe := TEdit.Create('edLeistPlWahl2Summe');
  edLeistPlNormStat1 := TEdit.Create('edLeistPlNormStat1');
  edLeistPlNormStat2 := TEdit.Create('edLeistPlNormStat2');
  edLeistPlNormStat3 := TEdit.Create('edLeistPlNormStat3');
  edLeistPlNormStat5 := TEdit.Create('edLeistPlNormStat5');
  edLeistPlNormStat4 := TEdit.Create('edLeistPlNormStat4');
  edLeistPlNormStat6 := TEdit.Create('edLeistPlNormStat6');
  edLeistPlNormSumme := TEdit.Create('edLeistPlNormSumme');
  edLeistPlSumStat1 := TEdit.Create('edLeistPlSumStat1');
  edLeistPlSumStat2 := TEdit.Create('edLeistPlSumStat2');
  edLeistPlSumStat3 := TEdit.Create('edLeistPlSumStat3');
  edLeistPlSumStat5 := TEdit.Create('edLeistPlSumStat5');
  edLeistPlSumStat4 := TEdit.Create('edLeistPlSumStat4');
  edLeistPlSumStat6 := TEdit.Create('edLeistPlSumStat6');
  edLeistPlSumSumme := TEdit.Create('edLeistPlSumSumme');
  edLeistSumFaelleAbtl := TEdit.Create('edLeistSumFaelleAbtl');
  pnKodierdienst := TPanel.Create('pnKodierdienst');
  lblCaseManagementAktiv := TLabel.Create('checkboxKodierdienstLabel');
  lblCaseManagement := TLabel.Create('kodierdienstHeadline');
  cb_CodD := TDBCheckBox.Create('checkboxKodierdienst');
  pgcSheetStationenPersonal := TTabSheet.Create('SheetStationenPersonal');
  pnLeistungsKategorie := TPanel.Create('pnLeistungsKategorie');
  WebLabel18 := TLabel.Create('nutzungBettenStationenHeadline');
  lb_LeistKatStation := TLabel.Create('lb_LeistKatStation');
  lb_LeistKatAnzahlAlt := TLabel.Create('lb_LeistKatAnzahlAlt');
  lb_LeistKatUmwandlung := TLabel.Create('lb_LeistKatUmwandlung');
  lb_LeistKatErwAbbau := TLabel.Create('lb_LeistKatErwAbbau');
  lb_LeistKatAnzahlNeu := TLabel.Create('lb_LeistKatAnzahlNeu');
  lb_LeistKatZuschlag := TLabel.Create('lb_LeistKatZuschlag');
  lb_LeistKatStat1 := TLabel.Create('lb_LeistKatStat1');
  lb_LeistKatStat2 := TLabel.Create('lb_LeistKatStat2');
  lb_LeistKatStat3 := TLabel.Create('lb_LeistKatStat3');
  lb_LeistKatStatSumme := TLabel.Create('lb_LeistKatStatSumme');
  ed_LeistKatWahlLeist1AnzAltZi := TEdit.Create('ed_LeistKatWahlLeist1AnzAltZi');
  ed_LeistKatWahlLeist2AnzAltZi := TEdit.Create('ed_LeistKatWahlLeist2AnzAltZi');
  ed_LeistKatNormalAnzAltZi := TEdit.Create('ed_LeistKatNormalAnzAltZi');
  ed_LeistSummeAnzAltZi := TEdit.Create('ed_LeistSummeAnzAltZi');
  ed_LeistKatWahlLeist1AnzAltBt := TEdit.Create('ed_LeistKatWahlLeist1AnzAltBt');
  ed_LeistKatWahlLeist2AnzAltBt := TEdit.Create('ed_LeistKatWahlLeist2AnzAltBt');
  ed_LeistKatNormalAnzAltBt := TEdit.Create('ed_LeistKatNormalAnzAltBt');
  ed_LeistSummeAnzAltBt := TEdit.Create('ed_LeistSummeAnzAltBt');
  ed_LeistKatWahlLeist1Umwandlung := TEdit.Create('ed_LeistKatWahlLeist1Umwandlung');
  ed_LeistKatWahlLeist2Umwandlung := TEdit.Create('ed_LeistKatWahlLeist2Umwandlung');
  ed_LeistKatNormalUmwandlung := TEdit.Create('ed_LeistKatNormalUmwandlung');
  ed_LeistSummeUmwandlung := TEdit.Create('ed_LeistSummeUmwandlung');
  ed_LeistKatWahlLeist1ErwAbbau := TEdit.Create('ed_LeistKatWahlLeist1ErwAbbau');
  ed_LeistKatWahlLeist2ErwAbbau := TEdit.Create('ed_LeistKatWahlLeist2ErwAbbau');
  ed_LeistKatNormalErwAbbau := TEdit.Create('ed_LeistKatNormalErwAbbau');
  ed_LeistSummeErwAbbau := TEdit.Create('ed_LeistSummeErwAbbau');
  ed_LeistKatWahlLeist1AnzNeuZi := TEdit.Create('ed_LeistKatWahlLeist1AnzNeuZi');
  ed_LeistKatWahlLeist2AnzNeuZi := TEdit.Create('ed_LeistKatWahlLeist2AnzNeuZi');
  ed_LeistKatNormalAnzNeuZi := TEdit.Create('ed_LeistKatNormalAnzNeuZi');
  ed_LeistSummeAnzNeuZi := TEdit.Create('ed_LeistSummeAnzNeuZi');
  ed_LeistKatWahlLeist1AnzNeuBt := TEdit.Create('ed_LeistKatWahlLeist1AnzNeuBt');
  ed_LeistKatWahlLeist2AnzNeuBt := TEdit.Create('ed_LeistKatWahlLeist2AnzNeuBt');
  ed_LeistKatNormalAnzNeuBt := TEdit.Create('ed_LeistKatNormalAnzNeuBt');
  ed_LeistSummeAnzNeuBt := TEdit.Create('ed_LeistSummeAnzNeuBt');
  ed_LeistKatWahlLeist1Zuschlag := TEdit.Create('ed_LeistKatWahlLeist1Zuschlag');
  ed_LeistKatWahlLeist2Zuschlag := TEdit.Create('ed_LeistKatWahlLeist2Zuschlag');
  ed_LeistKatNormalZuschlag := TEdit.Create('ed_LeistKatNormalZuschlag');
  pnPersonal := TPanel.Create('pnPersonal');
  WebLabel19 := TLabel.Create('personalMassnahmenHeadline');
  lb_MassHead := TLabel.Create('lb_MassHead');
  lb_MassArztHead := TLabel.Create('lb_MassArztHead');
  lb_MassPflegeHead := TLabel.Create('lb_MassPflegeHead');
  lb_PersMassEinstellung := TLabel.Create('lb_PersMassEinstellung');
  lb_PersMassEntlassung := TLabel.Create('lb_PersMassEntlassung');
  lb_PersMassTraining := TLabel.Create('lb_PersMassTraining');
  lb_PersMassNebenkosten := TLabel.Create('lb_PersMassNebenkosten');
  lb_PersMassEinstellungEinh := TLabel.Create('lb_PersMassEinstellungEinh');
  lb_PersMassEntlassungEinh := TLabel.Create('lb_PersMassEntlassungEinh');
  lb_PersMassTrainingEinh := TLabel.Create('lb_PersMassTrainingEinh');
  lb_PersMassNebenkostenEinh := TLabel.Create('lb_PersMassNebenkostenEinh');
  lb_PersMassNebenkostenInstitut := TLabel.Create('lb_PersMassNebenkostenInstitut');
  ed_PersMassEinstellungenArzt := TEdit.Create('ed_PersMassEinstellungenArzt');
  ed_PersMassEntlassungArzt := TEdit.Create('ed_PersMassEntlassungArzt');
  ed_PersMassTrainingArzt := TEdit.Create('ed_PersMassTrainingArzt');
  ed_PersMassNebenkostenArzt := TEdit.Create('ed_PersMassNebenkostenArzt');
  ed_PersMassEinstellungenPflege := TEdit.Create('ed_PersMassEinstellungenPflege');
  ed_PersMassEntlassungPflege := TEdit.Create('ed_PersMassEntlassungPflege');
  ed_PersMassTrainingPflege := TEdit.Create('ed_PersMassTrainingPflege');
  ed_PersMassNebenkostenPflege := TEdit.Create('ed_PersMassNebenkostenPflege');
  ed_PersMassNebenkostenInstitut := TEdit.Create('ed_PersMassNebenkostenInstitut');
  pnVersetzungMitarbeiter := TPanel.Create('pnVersetzungMitarbeiter');
  La3_Abt2 := TLabel.Create('abteilungEinsLabel');
  La3_Abt3 := TLabel.Create('abteilungZweiLabel');
  WebLabel20 := TLabel.Create('versetzungMitarbeiterHeadline');
  LF3_NachA1 := TDBEdit.Create('abteilungEinsInput');
  LF3_NachA2 := TDBEdit.Create('abteilungZweiInput');
  RFE_AbteilungName := TEdit.Create('abteilungOriginInput');
  pgcSheetFinanzen := TTabSheet.Create('SheetFinanzen');
  WebLabel4 := TLabel.Create('finanzmittelHeadline');
  WebLabel7 := TLabel.Create('generelleEntscheidungenHeadline');
  pnFinanzen := TPanel.Create('pnFinanzen');
  lblStation1 := TLabel.Create('finanzenHeadline');
  WebLabel2 := TLabel.Create('kurzfristigLabel');
  WebLabel3 := TLabel.Create('mittelfristigLabel');
  RFE_KrdKurz := TDBEdit.Create('kurzfristigInput');
  RFE_KrdLang := TDBEdit.Create('mittelfristigInput');
  pnFinanzGenerell := TPanel.Create('pnFinanzenGenerell');
  WebLabel8 := TLabel.Create('finanzenGenerellHeadline');
  La5_Abt1 := TLabel.Create('finanzenAbteilungEinsLabel');
  La5_Abt2 := TLabel.Create('finanzenAbteilungZweiLabel');
  La5_Abt3 := TLabel.Create('finanzenAbteilungDreiLabel');
  RFE_Imag1 := TDBEdit.Create('finanzenAbteilungEinsInput');
  RFE_Imag2 := TDBEdit.Create('finanzenAbteilungZweiInput');
  RFE_Imag3 := TDBEdit.Create('finanzenAbteilungDreiInput');
  pnUeberschuss := TPanel.Create('pnUeberschuss');
  WebLabel1 := TLabel.Create('ueberschussHeadline');
  WebLabel5 := TLabel.Create('ausschuettungLabel');
  WebLabel6 := TLabel.Create('wertpapiereLabel');
  RFE_Dividen := TDBEdit.Create('ausschuettungInput');
  RFE_WpKauf := TDBEdit.Create('wertpapiereInput');
  pnRationalisierung := TPanel.Create('pnRationalisierung');
  WebLabel10 := TLabel.Create('patientenmanagementLabel');
  WebLabel13 := TLabel.Create('rationalisierungLabel');
  WebLabel17 := TLabel.Create('trainingLabel');
  WebLabel9 := TLabel.Create('managementHeadline');
  RFE_Patie := TDBEdit.Create('patientenmanagementInput');
  RFE_Ratio := TDBEdit.Create('rationalisierungInput');
  RFE_Train := TDBEdit.Create('trainingInput');
  pgcSheetKPI := TTabSheet.Create('SheetKPI');
  pnKPIData := TPanel.Create('pnKPIData');
  weblabKPIHeadline := TLabel.Create('KPIHeadline');
  pnLeftNavigation := TPanel.Create('PanelNAVDefault');
  lblPeriode := TLabel.Create('LabelNAVPeriode');
  lblAbteilung := TLabel.Create('LabelNAVAbteilung');
  lblKrankenhaus := TLabel.Create('LabelNAVKrankenhaus');
  btnClose := TButton.Create('btnNAVBack');
  btnSave := TButton.Create('btnNAVSave');
  spedPeriode := TSpinEdit.Create('SpinEdNAVPeriode');
  btnPrint := TButton.Create('btnNAVPrint');
  btnCancel := TButton.Create('btnNAVCancel');
  brnHelp := TButton.Create('btnNAVHelp');
  spedAbteilung := TSpinEdit.Create('SpinEdNAVAbteilung');
  spedKrankenhaus := TSpinEdit.Create('SpinEdNAVKrankenhaus');
  btnSaveAndLock := TButton.Create('btnNAVSaveLock');
  WebMessageDlg := TMessageDlg.Create(Self);
  XDataWebDataSetPerfPlan := TXDataWebDataSet.Create(Self);
  PerfPlanDataSource := TDataSource.Create(Self);
  XDataWebConnection1 := TXDataWebConnection.Create(Self);
  XDataWebDataSetPerfCat := TXDataWebDataSet.Create(Self);
  PerfCatWebDataSource := TDataSource.Create(Self);
  XDataWebDataSetPerfMisc := TXDataWebDataSet.Create(Self);
  PerfMiscWebDataSource := TDataSource.Create(Self);
  XDataWebDataSetFaelle := TXDataWebDataSet.Create(Self);
  FaelleDataSource := TDataSource.Create(Self);
  XDataWebDataSetKPIData := TXDataWebDataSet.Create(Self);
  KPIDataWebDataSource := TDataSource.Create(Self);

  WaitMessage.BeforeLoadDFMValues;
  pgcEntscheidungen.BeforeLoadDFMValues;
  pgcSheetFaelleInstitute.BeforeLoadDFMValues;
  pnInstitutsEntscheidungen.BeforeLoadDFMValues;
  lblOutsourcingAlternativen.BeforeLoadDFMValues;
  lblLaundryAktiv.BeforeLoadDFMValues;
  cbxOutsourceWaescherei.BeforeLoadDFMValues;
  pnLeistungsPlanung.BeforeLoadDFMValues;
  WebLabel16.BeforeLoadDFMValues;
  WebLabel11.BeforeLoadDFMValues;
  WebLabel12.BeforeLoadDFMValues;
  WebLabel14.BeforeLoadDFMValues;
  WebLabel15.BeforeLoadDFMValues;
  WebLabel21.BeforeLoadDFMValues;
  WebLabel22.BeforeLoadDFMValues;
  ed_LeistPlAbteilung.BeforeLoadDFMValues;
  ed_LeistPlStation1.BeforeLoadDFMValues;
  ed_LeistPlStation2.BeforeLoadDFMValues;
  ed_LeistPlStation3.BeforeLoadDFMValues;
  ed_LeistPlStation5.BeforeLoadDFMValues;
  ed_LeistPlStation4.BeforeLoadDFMValues;
  ed_LeistPlStation6.BeforeLoadDFMValues;
  ed_LeistPlStationSumme.BeforeLoadDFMValues;
  edLeistPlWahl1Stat1.BeforeLoadDFMValues;
  edLeistPlWahl1Stat2.BeforeLoadDFMValues;
  edLeistPlWahl1Stat3.BeforeLoadDFMValues;
  edLeistPlWahl1Stat5.BeforeLoadDFMValues;
  edLeistPlWahl1Stat4.BeforeLoadDFMValues;
  edLeistPlWahl1Stat6.BeforeLoadDFMValues;
  edLeistPlWahl1Summe.BeforeLoadDFMValues;
  edLeistPlWahl2Stat1.BeforeLoadDFMValues;
  edLeistPlWahl2Stat2.BeforeLoadDFMValues;
  edLeistPlWahl2Stat3.BeforeLoadDFMValues;
  edLeistPlWahl2Stat5.BeforeLoadDFMValues;
  edLeistPlWahl2Stat4.BeforeLoadDFMValues;
  edLeistPlWahl2Stat6.BeforeLoadDFMValues;
  edLeistPlWahl2Summe.BeforeLoadDFMValues;
  edLeistPlNormStat1.BeforeLoadDFMValues;
  edLeistPlNormStat2.BeforeLoadDFMValues;
  edLeistPlNormStat3.BeforeLoadDFMValues;
  edLeistPlNormStat5.BeforeLoadDFMValues;
  edLeistPlNormStat4.BeforeLoadDFMValues;
  edLeistPlNormStat6.BeforeLoadDFMValues;
  edLeistPlNormSumme.BeforeLoadDFMValues;
  edLeistPlSumStat1.BeforeLoadDFMValues;
  edLeistPlSumStat2.BeforeLoadDFMValues;
  edLeistPlSumStat3.BeforeLoadDFMValues;
  edLeistPlSumStat5.BeforeLoadDFMValues;
  edLeistPlSumStat4.BeforeLoadDFMValues;
  edLeistPlSumStat6.BeforeLoadDFMValues;
  edLeistPlSumSumme.BeforeLoadDFMValues;
  edLeistSumFaelleAbtl.BeforeLoadDFMValues;
  pnKodierdienst.BeforeLoadDFMValues;
  lblCaseManagementAktiv.BeforeLoadDFMValues;
  lblCaseManagement.BeforeLoadDFMValues;
  cb_CodD.BeforeLoadDFMValues;
  pgcSheetStationenPersonal.BeforeLoadDFMValues;
  pnLeistungsKategorie.BeforeLoadDFMValues;
  WebLabel18.BeforeLoadDFMValues;
  lb_LeistKatStation.BeforeLoadDFMValues;
  lb_LeistKatAnzahlAlt.BeforeLoadDFMValues;
  lb_LeistKatUmwandlung.BeforeLoadDFMValues;
  lb_LeistKatErwAbbau.BeforeLoadDFMValues;
  lb_LeistKatAnzahlNeu.BeforeLoadDFMValues;
  lb_LeistKatZuschlag.BeforeLoadDFMValues;
  lb_LeistKatStat1.BeforeLoadDFMValues;
  lb_LeistKatStat2.BeforeLoadDFMValues;
  lb_LeistKatStat3.BeforeLoadDFMValues;
  lb_LeistKatStatSumme.BeforeLoadDFMValues;
  ed_LeistKatWahlLeist1AnzAltZi.BeforeLoadDFMValues;
  ed_LeistKatWahlLeist2AnzAltZi.BeforeLoadDFMValues;
  ed_LeistKatNormalAnzAltZi.BeforeLoadDFMValues;
  ed_LeistSummeAnzAltZi.BeforeLoadDFMValues;
  ed_LeistKatWahlLeist1AnzAltBt.BeforeLoadDFMValues;
  ed_LeistKatWahlLeist2AnzAltBt.BeforeLoadDFMValues;
  ed_LeistKatNormalAnzAltBt.BeforeLoadDFMValues;
  ed_LeistSummeAnzAltBt.BeforeLoadDFMValues;
  ed_LeistKatWahlLeist1Umwandlung.BeforeLoadDFMValues;
  ed_LeistKatWahlLeist2Umwandlung.BeforeLoadDFMValues;
  ed_LeistKatNormalUmwandlung.BeforeLoadDFMValues;
  ed_LeistSummeUmwandlung.BeforeLoadDFMValues;
  ed_LeistKatWahlLeist1ErwAbbau.BeforeLoadDFMValues;
  ed_LeistKatWahlLeist2ErwAbbau.BeforeLoadDFMValues;
  ed_LeistKatNormalErwAbbau.BeforeLoadDFMValues;
  ed_LeistSummeErwAbbau.BeforeLoadDFMValues;
  ed_LeistKatWahlLeist1AnzNeuZi.BeforeLoadDFMValues;
  ed_LeistKatWahlLeist2AnzNeuZi.BeforeLoadDFMValues;
  ed_LeistKatNormalAnzNeuZi.BeforeLoadDFMValues;
  ed_LeistSummeAnzNeuZi.BeforeLoadDFMValues;
  ed_LeistKatWahlLeist1AnzNeuBt.BeforeLoadDFMValues;
  ed_LeistKatWahlLeist2AnzNeuBt.BeforeLoadDFMValues;
  ed_LeistKatNormalAnzNeuBt.BeforeLoadDFMValues;
  ed_LeistSummeAnzNeuBt.BeforeLoadDFMValues;
  ed_LeistKatWahlLeist1Zuschlag.BeforeLoadDFMValues;
  ed_LeistKatWahlLeist2Zuschlag.BeforeLoadDFMValues;
  ed_LeistKatNormalZuschlag.BeforeLoadDFMValues;
  pnPersonal.BeforeLoadDFMValues;
  WebLabel19.BeforeLoadDFMValues;
  lb_MassHead.BeforeLoadDFMValues;
  lb_MassArztHead.BeforeLoadDFMValues;
  lb_MassPflegeHead.BeforeLoadDFMValues;
  lb_PersMassEinstellung.BeforeLoadDFMValues;
  lb_PersMassEntlassung.BeforeLoadDFMValues;
  lb_PersMassTraining.BeforeLoadDFMValues;
  lb_PersMassNebenkosten.BeforeLoadDFMValues;
  lb_PersMassEinstellungEinh.BeforeLoadDFMValues;
  lb_PersMassEntlassungEinh.BeforeLoadDFMValues;
  lb_PersMassTrainingEinh.BeforeLoadDFMValues;
  lb_PersMassNebenkostenEinh.BeforeLoadDFMValues;
  lb_PersMassNebenkostenInstitut.BeforeLoadDFMValues;
  ed_PersMassEinstellungenArzt.BeforeLoadDFMValues;
  ed_PersMassEntlassungArzt.BeforeLoadDFMValues;
  ed_PersMassTrainingArzt.BeforeLoadDFMValues;
  ed_PersMassNebenkostenArzt.BeforeLoadDFMValues;
  ed_PersMassEinstellungenPflege.BeforeLoadDFMValues;
  ed_PersMassEntlassungPflege.BeforeLoadDFMValues;
  ed_PersMassTrainingPflege.BeforeLoadDFMValues;
  ed_PersMassNebenkostenPflege.BeforeLoadDFMValues;
  ed_PersMassNebenkostenInstitut.BeforeLoadDFMValues;
  pnVersetzungMitarbeiter.BeforeLoadDFMValues;
  La3_Abt2.BeforeLoadDFMValues;
  La3_Abt3.BeforeLoadDFMValues;
  WebLabel20.BeforeLoadDFMValues;
  LF3_NachA1.BeforeLoadDFMValues;
  LF3_NachA2.BeforeLoadDFMValues;
  RFE_AbteilungName.BeforeLoadDFMValues;
  pgcSheetFinanzen.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  WebLabel7.BeforeLoadDFMValues;
  pnFinanzen.BeforeLoadDFMValues;
  lblStation1.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  RFE_KrdKurz.BeforeLoadDFMValues;
  RFE_KrdLang.BeforeLoadDFMValues;
  pnFinanzGenerell.BeforeLoadDFMValues;
  WebLabel8.BeforeLoadDFMValues;
  La5_Abt1.BeforeLoadDFMValues;
  La5_Abt2.BeforeLoadDFMValues;
  La5_Abt3.BeforeLoadDFMValues;
  RFE_Imag1.BeforeLoadDFMValues;
  RFE_Imag2.BeforeLoadDFMValues;
  RFE_Imag3.BeforeLoadDFMValues;
  pnUeberschuss.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WebLabel5.BeforeLoadDFMValues;
  WebLabel6.BeforeLoadDFMValues;
  RFE_Dividen.BeforeLoadDFMValues;
  RFE_WpKauf.BeforeLoadDFMValues;
  pnRationalisierung.BeforeLoadDFMValues;
  WebLabel10.BeforeLoadDFMValues;
  WebLabel13.BeforeLoadDFMValues;
  WebLabel17.BeforeLoadDFMValues;
  WebLabel9.BeforeLoadDFMValues;
  RFE_Patie.BeforeLoadDFMValues;
  RFE_Ratio.BeforeLoadDFMValues;
  RFE_Train.BeforeLoadDFMValues;
  pgcSheetKPI.BeforeLoadDFMValues;
  pnKPIData.BeforeLoadDFMValues;
  weblabKPIHeadline.BeforeLoadDFMValues;
  pnLeftNavigation.BeforeLoadDFMValues;
  lblPeriode.BeforeLoadDFMValues;
  lblAbteilung.BeforeLoadDFMValues;
  lblKrankenhaus.BeforeLoadDFMValues;
  btnClose.BeforeLoadDFMValues;
  btnSave.BeforeLoadDFMValues;
  spedPeriode.BeforeLoadDFMValues;
  btnPrint.BeforeLoadDFMValues;
  btnCancel.BeforeLoadDFMValues;
  brnHelp.BeforeLoadDFMValues;
  spedAbteilung.BeforeLoadDFMValues;
  spedKrankenhaus.BeforeLoadDFMValues;
  btnSaveAndLock.BeforeLoadDFMValues;
  WebMessageDlg.BeforeLoadDFMValues;
  XDataWebDataSetPerfPlan.BeforeLoadDFMValues;
  PerfPlanDataSource.BeforeLoadDFMValues;
  XDataWebConnection1.BeforeLoadDFMValues;
  XDataWebDataSetPerfCat.BeforeLoadDFMValues;
  PerfCatWebDataSource.BeforeLoadDFMValues;
  XDataWebDataSetPerfMisc.BeforeLoadDFMValues;
  PerfMiscWebDataSource.BeforeLoadDFMValues;
  XDataWebDataSetFaelle.BeforeLoadDFMValues;
  FaelleDataSource.BeforeLoadDFMValues;
  XDataWebDataSetKPIData.BeforeLoadDFMValues;
  KPIDataWebDataSource.BeforeLoadDFMValues;
  try
    Width := 1933;
    Height := 1345;
    ElementClassName := '!bg-base-100';
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    WaitMessage.Picture.LoadFromFile('PrjFormDecisionData.WaitMessage.Picture.gif');
    pgcEntscheidungen.SetParentComponent(Self);
    pgcEntscheidungen.Name := 'pgcEntscheidungen';
    pgcEntscheidungen.Left := 8;
    pgcEntscheidungen.Top := 8;
    pgcEntscheidungen.Width := 1600;
    pgcEntscheidungen.Height := 1167;
    pgcEntscheidungen.ElementClassName := 'tabs tabs-box justify-start order-first rounded-none';
    pgcEntscheidungen.HeightStyle := ssAuto;
    pgcEntscheidungen.WidthStyle := ssAuto;
    pgcEntscheidungen.ChildOrder := 4;
    pgcEntscheidungen.ElementTabClassName := 'tabs ';
    pgcEntscheidungen.ElementTabActiveClassName := 'tab-active tab';
    pgcEntscheidungen.ElementTabItemClassName := 'tab px-2';
    pgcEntscheidungen.ElementFont := efCSS;
    pgcEntscheidungen.TabIndex := 3;
    pgcEntscheidungen.TabOrder := 0;
    SetEvent(pgcEntscheidungen, Self, 'OnChange', 'pgcEntscheidungenChange');
    pgcSheetFaelleInstitute.SetParentComponent(pgcEntscheidungen);
    pgcSheetFaelleInstitute.Name := 'pgcSheetFaelleInstitute';
    pgcSheetFaelleInstitute.Left := 0;
    pgcSheetFaelleInstitute.Top := 20;
    pgcSheetFaelleInstitute.Width := 1600;
    pgcSheetFaelleInstitute.Height := 1147;
    pgcSheetFaelleInstitute.HeightStyle := ssAuto;
    pgcSheetFaelleInstitute.WidthStyle := ssAuto;
    pgcSheetFaelleInstitute.Caption := 'F'#228'lle / Institute';
    pgcSheetFaelleInstitute.ElementFont := efCSS;
    pgcSheetFaelleInstitute.ElementPosition := epRelative;
    pnInstitutsEntscheidungen.SetParentComponent(pgcSheetFaelleInstitute);
    pnInstitutsEntscheidungen.Name := 'pnInstitutsEntscheidungen';
    pnInstitutsEntscheidungen.Left := 32;
    pnInstitutsEntscheidungen.Top := 464;
    pnInstitutsEntscheidungen.Width := 1319;
    pnInstitutsEntscheidungen.Height := 150;
    pnInstitutsEntscheidungen.HeightStyle := ssAuto;
    pnInstitutsEntscheidungen.WidthStyle := ssAuto;
    pnInstitutsEntscheidungen.ChildOrder := 2;
    pnInstitutsEntscheidungen.ElementFont := efCSS;
    pnInstitutsEntscheidungen.ElementPosition := epRelative;
    pnInstitutsEntscheidungen.TabOrder := 0;
    lblOutsourcingAlternativen.SetParentComponent(pnInstitutsEntscheidungen);
    lblOutsourcingAlternativen.Name := 'lblOutsourcingAlternativen';
    lblOutsourcingAlternativen.Left := 58;
    lblOutsourcingAlternativen.Top := 24;
    lblOutsourcingAlternativen.Width := 158;
    lblOutsourcingAlternativen.Height := 18;
    lblOutsourcingAlternativen.Caption := 'Outsourcing Alternativen';
    lblOutsourcingAlternativen.ElementFont := efCSS;
    lblOutsourcingAlternativen.HeightStyle := ssAuto;
    lblOutsourcingAlternativen.HeightPercent := 100.00000000000000000;
    lblOutsourcingAlternativen.HTMLType := tH3;
    lblOutsourcingAlternativen.WidthPercent := 100.00000000000000000;
    lblLaundryAktiv.SetParentComponent(pnInstitutsEntscheidungen);
    lblLaundryAktiv.Name := 'lblLaundryAktiv';
    lblLaundryAktiv.Left := 162;
    lblLaundryAktiv.Top := 65;
    lblLaundryAktiv.Width := 124;
    lblLaundryAktiv.Height := 29;
    lblLaundryAktiv.Caption := 'W'#228'scherei';
    lblLaundryAktiv.ElementFont := efCSS;
    lblLaundryAktiv.ElementPosition := epRelative;
    lblLaundryAktiv.Font.Charset := DEFAULT_CHARSET;
    lblLaundryAktiv.Font.Color := clWindowText;
    lblLaundryAktiv.Font.Height := -24;
    lblLaundryAktiv.Font.Name := 'Tahoma';
    lblLaundryAktiv.Font.Style := [fsBold];
    lblLaundryAktiv.HeightStyle := ssAuto;
    lblLaundryAktiv.HeightPercent := 100.00000000000000000;
    lblLaundryAktiv.ParentFont := False;
    lblLaundryAktiv.WidthStyle := ssAuto;
    lblLaundryAktiv.WidthPercent := 100.00000000000000000;
    cbxOutsourceWaescherei.SetParentComponent(pnInstitutsEntscheidungen);
    cbxOutsourceWaescherei.Name := 'cbxOutsourceWaescherei';
    cbxOutsourceWaescherei.Left := 72;
    cbxOutsourceWaescherei.Top := 72;
    cbxOutsourceWaescherei.Width := 113;
    cbxOutsourceWaescherei.Height := 22;
    cbxOutsourceWaescherei.ElementClassName := 'mr-4 toggle toggle-primary toggle-xl bg-base-300 border-2';
    cbxOutsourceWaescherei.ElementFont := efCSS;
    cbxOutsourceWaescherei.ElementPosition := epIgnore;
    cbxOutsourceWaescherei.HeightStyle := ssAuto;
    cbxOutsourceWaescherei.HeightPercent := 100.00000000000000000;
    cbxOutsourceWaescherei.WidthStyle := ssAuto;
    cbxOutsourceWaescherei.WidthPercent := 100.00000000000000000;
    cbxOutsourceWaescherei.DataField := 'Hbpm_Coding_Alternativ';
    cbxOutsourceWaescherei.DataSource := PerfMiscWebDataSource;
    cbxOutsourceWaescherei.ValueChecked := '1';
    cbxOutsourceWaescherei.ValueUnChecked := '0';
    pnLeistungsPlanung.SetParentComponent(pgcSheetFaelleInstitute);
    pnLeistungsPlanung.Name := 'pnLeistungsPlanung';
    pnLeistungsPlanung.Left := 0;
    pnLeistungsPlanung.Top := 0;
    pnLeistungsPlanung.Width := 1600;
    pnLeistungsPlanung.Height := 441;
    pnLeistungsPlanung.HeightStyle := ssAuto;
    pnLeistungsPlanung.WidthStyle := ssAuto;
    pnLeistungsPlanung.Align := alTop;
    pnLeistungsPlanung.ChildOrder := 1;
    pnLeistungsPlanung.ElementFont := efCSS;
    pnLeistungsPlanung.ElementPosition := epRelative;
    pnLeistungsPlanung.ShowCaption := False;
    pnLeistungsPlanung.TabOrder := 1;
    WebLabel16.SetParentComponent(pnLeistungsPlanung);
    WebLabel16.Name := 'WebLabel16';
    WebLabel16.Left := 151;
    WebLabel16.Top := 54;
    WebLabel16.Width := 110;
    WebLabel16.Height := 18;
    WebLabel16.Caption := 'Leistungsplanung';
    WebLabel16.ElementFont := efCSS;
    WebLabel16.ElementPosition := epRelative;
    WebLabel16.HeightStyle := ssAuto;
    WebLabel16.HeightPercent := 100.00000000000000000;
    WebLabel16.HTMLType := tH3;
    WebLabel16.WidthPercent := 100.00000000000000000;
    WebLabel11.SetParentComponent(pnLeistungsPlanung);
    WebLabel11.Name := 'WebLabel11';
    WebLabel11.Left := 32;
    WebLabel11.Top := 132;
    WebLabel11.Width := 60;
    WebLabel11.Height := 18;
    WebLabel11.Caption := 'Stationen';
    WebLabel11.HeightPercent := 100.00000000000000000;
    WebLabel11.WidthPercent := 100.00000000000000000;
    WebLabel12.SetParentComponent(pnLeistungsPlanung);
    WebLabel12.Name := 'WebLabel12';
    WebLabel12.Left := 32;
    WebLabel12.Top := 190;
    WebLabel12.Width := 93;
    WebLabel12.Height := 18;
    WebLabel12.Caption := 'Wahlleistung 1';
    WebLabel12.HeightPercent := 100.00000000000000000;
    WebLabel12.WidthPercent := 100.00000000000000000;
    WebLabel14.SetParentComponent(pnLeistungsPlanung);
    WebLabel14.Name := 'WebLabel14';
    WebLabel14.Left := 32;
    WebLabel14.Top := 214;
    WebLabel14.Width := 93;
    WebLabel14.Height := 18;
    WebLabel14.Caption := 'Wahlleistung 2';
    WebLabel14.HeightPercent := 100.00000000000000000;
    WebLabel14.WidthPercent := 100.00000000000000000;
    WebLabel15.SetParentComponent(pnLeistungsPlanung);
    WebLabel15.Name := 'WebLabel15';
    WebLabel15.Left := 32;
    WebLabel15.Top := 238;
    WebLabel15.Width := 46;
    WebLabel15.Height := 18;
    WebLabel15.Caption := 'Normal';
    WebLabel15.HeightPercent := 100.00000000000000000;
    WebLabel15.WidthPercent := 100.00000000000000000;
    WebLabel21.SetParentComponent(pnLeistungsPlanung);
    WebLabel21.Name := 'WebLabel21';
    WebLabel21.Left := 32;
    WebLabel21.Top := 268;
    WebLabel21.Width := 50;
    WebLabel21.Height := 18;
    WebLabel21.Caption := 'Summe';
    WebLabel21.HeightPercent := 100.00000000000000000;
    WebLabel21.WidthPercent := 100.00000000000000000;
    WebLabel22.SetParentComponent(pnLeistungsPlanung);
    WebLabel22.Name := 'WebLabel22';
    WebLabel22.Left := 32;
    WebLabel22.Top := 326;
    WebLabel22.Width := 157;
    WebLabel22.Height := 18;
    WebLabel22.Caption := 'Summe F'#228'lle / Abteilung';
    WebLabel22.HeightPercent := 100.00000000000000000;
    WebLabel22.WidthPercent := 100.00000000000000000;
    ed_LeistPlAbteilung.SetParentComponent(pnLeistungsPlanung);
    ed_LeistPlAbteilung.Name := 'ed_LeistPlAbteilung';
    ed_LeistPlAbteilung.Left := 151;
    ed_LeistPlAbteilung.Top := 78;
    ed_LeistPlAbteilung.Width := 219;
    ed_LeistPlAbteilung.Height := 22;
    ed_LeistPlAbteilung.ChildOrder := 4;
    ed_LeistPlAbteilung.ElementFont := efCSS;
    ed_LeistPlAbteilung.ElementPosition := epIgnore;
    ed_LeistPlAbteilung.Font.Charset := DEFAULT_CHARSET;
    ed_LeistPlAbteilung.Font.Color := clWindowText;
    ed_LeistPlAbteilung.Font.Height := -17;
    ed_LeistPlAbteilung.Font.Name := 'Tahoma';
    ed_LeistPlAbteilung.Font.Style := [];
    ed_LeistPlAbteilung.HeightStyle := ssAuto;
    ed_LeistPlAbteilung.HeightPercent := 100.00000000000000000;
    ed_LeistPlAbteilung.ParentFont := False;
    ed_LeistPlAbteilung.Text := 'ed_LeistPlAbteilung';
    ed_LeistPlAbteilung.WidthStyle := ssAuto;
    ed_LeistPlAbteilung.WidthPercent := 100.00000000000000000;
    ed_LeistPlStation1.SetParentComponent(pnLeistungsPlanung);
    ed_LeistPlStation1.Name := 'ed_LeistPlStation1';
    ed_LeistPlStation1.Left := 154;
    ed_LeistPlStation1.Top := 133;
    ed_LeistPlStation1.Width := 180;
    ed_LeistPlStation1.Height := 22;
    ed_LeistPlStation1.ChildOrder := 4;
    ed_LeistPlStation1.ElementFont := efCSS;
    ed_LeistPlStation1.ElementPosition := epIgnore;
    ed_LeistPlStation1.Font.Charset := DEFAULT_CHARSET;
    ed_LeistPlStation1.Font.Color := clWindowText;
    ed_LeistPlStation1.Font.Height := -17;
    ed_LeistPlStation1.Font.Name := 'Tahoma';
    ed_LeistPlStation1.Font.Style := [];
    ed_LeistPlStation1.HeightStyle := ssAuto;
    ed_LeistPlStation1.HeightPercent := 100.00000000000000000;
    ed_LeistPlStation1.ParentFont := False;
    ed_LeistPlStation1.Text := 'ed_LeistPlStation1';
    ed_LeistPlStation1.WidthStyle := ssAuto;
    ed_LeistPlStation1.WidthPercent := 100.00000000000000000;
    ed_LeistPlStation2.SetParentComponent(pnLeistungsPlanung);
    ed_LeistPlStation2.Name := 'ed_LeistPlStation2';
    ed_LeistPlStation2.Left := 340;
    ed_LeistPlStation2.Top := 133;
    ed_LeistPlStation2.Width := 180;
    ed_LeistPlStation2.Height := 22;
    ed_LeistPlStation2.ChildOrder := 4;
    ed_LeistPlStation2.ElementFont := efCSS;
    ed_LeistPlStation2.ElementPosition := epIgnore;
    ed_LeistPlStation2.Font.Charset := DEFAULT_CHARSET;
    ed_LeistPlStation2.Font.Color := clWindowText;
    ed_LeistPlStation2.Font.Height := -17;
    ed_LeistPlStation2.Font.Name := 'Tahoma';
    ed_LeistPlStation2.Font.Style := [];
    ed_LeistPlStation2.HeightStyle := ssAuto;
    ed_LeistPlStation2.HeightPercent := 100.00000000000000000;
    ed_LeistPlStation2.ParentFont := False;
    ed_LeistPlStation2.Text := 'ed_LeistPlStation2';
    ed_LeistPlStation2.WidthStyle := ssAuto;
    ed_LeistPlStation2.WidthPercent := 100.00000000000000000;
    ed_LeistPlStation3.SetParentComponent(pnLeistungsPlanung);
    ed_LeistPlStation3.Name := 'ed_LeistPlStation3';
    ed_LeistPlStation3.Left := 526;
    ed_LeistPlStation3.Top := 133;
    ed_LeistPlStation3.Width := 180;
    ed_LeistPlStation3.Height := 22;
    ed_LeistPlStation3.ChildOrder := 4;
    ed_LeistPlStation3.ElementFont := efCSS;
    ed_LeistPlStation3.ElementPosition := epIgnore;
    ed_LeistPlStation3.Font.Charset := DEFAULT_CHARSET;
    ed_LeistPlStation3.Font.Color := clWindowText;
    ed_LeistPlStation3.Font.Height := -17;
    ed_LeistPlStation3.Font.Name := 'Tahoma';
    ed_LeistPlStation3.Font.Style := [];
    ed_LeistPlStation3.HeightStyle := ssAuto;
    ed_LeistPlStation3.HeightPercent := 100.00000000000000000;
    ed_LeistPlStation3.ParentFont := False;
    ed_LeistPlStation3.Text := 'ed_LeistPlStation3';
    ed_LeistPlStation3.WidthStyle := ssAuto;
    ed_LeistPlStation3.WidthPercent := 100.00000000000000000;
    ed_LeistPlStation5.SetParentComponent(pnLeistungsPlanung);
    ed_LeistPlStation5.Name := 'ed_LeistPlStation5';
    ed_LeistPlStation5.Left := 898;
    ed_LeistPlStation5.Top := 135;
    ed_LeistPlStation5.Width := 180;
    ed_LeistPlStation5.Height := 22;
    ed_LeistPlStation5.ChildOrder := 4;
    ed_LeistPlStation5.ElementFont := efCSS;
    ed_LeistPlStation5.ElementPosition := epIgnore;
    ed_LeistPlStation5.Font.Charset := DEFAULT_CHARSET;
    ed_LeistPlStation5.Font.Color := clWindowText;
    ed_LeistPlStation5.Font.Height := -17;
    ed_LeistPlStation5.Font.Name := 'Tahoma';
    ed_LeistPlStation5.Font.Style := [];
    ed_LeistPlStation5.HeightStyle := ssAuto;
    ed_LeistPlStation5.HeightPercent := 100.00000000000000000;
    ed_LeistPlStation5.ParentFont := False;
    ed_LeistPlStation5.Text := 'ed_LeistPlStation5';
    ed_LeistPlStation5.WidthStyle := ssAuto;
    ed_LeistPlStation5.WidthPercent := 100.00000000000000000;
    ed_LeistPlStation4.SetParentComponent(pnLeistungsPlanung);
    ed_LeistPlStation4.Name := 'ed_LeistPlStation4';
    ed_LeistPlStation4.Left := 712;
    ed_LeistPlStation4.Top := 135;
    ed_LeistPlStation4.Width := 180;
    ed_LeistPlStation4.Height := 22;
    ed_LeistPlStation4.ChildOrder := 4;
    ed_LeistPlStation4.ElementFont := efCSS;
    ed_LeistPlStation4.ElementPosition := epIgnore;
    ed_LeistPlStation4.Font.Charset := DEFAULT_CHARSET;
    ed_LeistPlStation4.Font.Color := clWindowText;
    ed_LeistPlStation4.Font.Height := -17;
    ed_LeistPlStation4.Font.Name := 'Tahoma';
    ed_LeistPlStation4.Font.Style := [];
    ed_LeistPlStation4.HeightStyle := ssAuto;
    ed_LeistPlStation4.HeightPercent := 100.00000000000000000;
    ed_LeistPlStation4.ParentFont := False;
    ed_LeistPlStation4.Text := 'ed_LeistPlStation4';
    ed_LeistPlStation4.WidthStyle := ssAuto;
    ed_LeistPlStation4.WidthPercent := 100.00000000000000000;
    ed_LeistPlStation6.SetParentComponent(pnLeistungsPlanung);
    ed_LeistPlStation6.Name := 'ed_LeistPlStation6';
    ed_LeistPlStation6.Left := 1084;
    ed_LeistPlStation6.Top := 135;
    ed_LeistPlStation6.Width := 180;
    ed_LeistPlStation6.Height := 22;
    ed_LeistPlStation6.ChildOrder := 4;
    ed_LeistPlStation6.ElementFont := efCSS;
    ed_LeistPlStation6.ElementPosition := epIgnore;
    ed_LeistPlStation6.Font.Charset := DEFAULT_CHARSET;
    ed_LeistPlStation6.Font.Color := clWindowText;
    ed_LeistPlStation6.Font.Height := -17;
    ed_LeistPlStation6.Font.Name := 'Tahoma';
    ed_LeistPlStation6.Font.Style := [];
    ed_LeistPlStation6.HeightStyle := ssAuto;
    ed_LeistPlStation6.HeightPercent := 100.00000000000000000;
    ed_LeistPlStation6.ParentFont := False;
    ed_LeistPlStation6.Text := 'ed_LeistPlStation6';
    ed_LeistPlStation6.WidthStyle := ssAuto;
    ed_LeistPlStation6.WidthPercent := 100.00000000000000000;
    ed_LeistPlStationSumme.SetParentComponent(pnLeistungsPlanung);
    ed_LeistPlStationSumme.Name := 'ed_LeistPlStationSumme';
    ed_LeistPlStationSumme.Left := 1300;
    ed_LeistPlStationSumme.Top := 133;
    ed_LeistPlStationSumme.Width := 180;
    ed_LeistPlStationSumme.Height := 22;
    ed_LeistPlStationSumme.ChildOrder := 4;
    ed_LeistPlStationSumme.ElementFont := efCSS;
    ed_LeistPlStationSumme.ElementPosition := epIgnore;
    ed_LeistPlStationSumme.Font.Charset := DEFAULT_CHARSET;
    ed_LeistPlStationSumme.Font.Color := clWindowText;
    ed_LeistPlStationSumme.Font.Height := -17;
    ed_LeistPlStationSumme.Font.Name := 'Tahoma';
    ed_LeistPlStationSumme.Font.Style := [];
    ed_LeistPlStationSumme.HeightStyle := ssAuto;
    ed_LeistPlStationSumme.HeightPercent := 100.00000000000000000;
    ed_LeistPlStationSumme.ParentFont := False;
    ed_LeistPlStationSumme.ReadOnly := True;
    ed_LeistPlStationSumme.Text := 'ed_LeistPlStationSumme';
    ed_LeistPlStationSumme.WidthStyle := ssAuto;
    ed_LeistPlStationSumme.WidthPercent := 100.00000000000000000;
    edLeistPlWahl1Stat1.SetParentComponent(pnLeistungsPlanung);
    edLeistPlWahl1Stat1.Name := 'edLeistPlWahl1Stat1';
    edLeistPlWahl1Stat1.Left := 151;
    edLeistPlWahl1Stat1.Top := 185;
    edLeistPlWahl1Stat1.Width := 180;
    edLeistPlWahl1Stat1.Height := 22;
    edLeistPlWahl1Stat1.ChildOrder := 4;
    edLeistPlWahl1Stat1.ElementFont := efCSS;
    edLeistPlWahl1Stat1.ElementPosition := epIgnore;
    edLeistPlWahl1Stat1.Font.Charset := DEFAULT_CHARSET;
    edLeistPlWahl1Stat1.Font.Color := clWindowText;
    edLeistPlWahl1Stat1.Font.Height := -17;
    edLeistPlWahl1Stat1.Font.Name := 'Tahoma';
    edLeistPlWahl1Stat1.Font.Style := [];
    edLeistPlWahl1Stat1.HeightStyle := ssAuto;
    edLeistPlWahl1Stat1.HeightPercent := 100.00000000000000000;
    edLeistPlWahl1Stat1.ParentFont := False;
    edLeistPlWahl1Stat1.Text := 'edLeistPlWahl1Stat1';
    edLeistPlWahl1Stat1.WidthStyle := ssAuto;
    edLeistPlWahl1Stat1.WidthPercent := 100.00000000000000000;
    SetEvent(edLeistPlWahl1Stat1, Self, 'OnExit', 'edLeistPlWahl1Stat1Exit');
    edLeistPlWahl1Stat2.SetParentComponent(pnLeistungsPlanung);
    edLeistPlWahl1Stat2.Name := 'edLeistPlWahl1Stat2';
    edLeistPlWahl1Stat2.Left := 337;
    edLeistPlWahl1Stat2.Top := 185;
    edLeistPlWahl1Stat2.Width := 180;
    edLeistPlWahl1Stat2.Height := 22;
    edLeistPlWahl1Stat2.ChildOrder := 4;
    edLeistPlWahl1Stat2.ElementFont := efCSS;
    edLeistPlWahl1Stat2.ElementPosition := epIgnore;
    edLeistPlWahl1Stat2.Font.Charset := DEFAULT_CHARSET;
    edLeistPlWahl1Stat2.Font.Color := clWindowText;
    edLeistPlWahl1Stat2.Font.Height := -17;
    edLeistPlWahl1Stat2.Font.Name := 'Tahoma';
    edLeistPlWahl1Stat2.Font.Style := [];
    edLeistPlWahl1Stat2.HeightStyle := ssAuto;
    edLeistPlWahl1Stat2.HeightPercent := 100.00000000000000000;
    edLeistPlWahl1Stat2.ParentFont := False;
    edLeistPlWahl1Stat2.Text := 'edLeistPlWahl1Stat2';
    edLeistPlWahl1Stat2.WidthStyle := ssAuto;
    edLeistPlWahl1Stat2.WidthPercent := 100.00000000000000000;
    SetEvent(edLeistPlWahl1Stat2, Self, 'OnExit', 'edLeistPlWahl1Stat1Exit');
    edLeistPlWahl1Stat3.SetParentComponent(pnLeistungsPlanung);
    edLeistPlWahl1Stat3.Name := 'edLeistPlWahl1Stat3';
    edLeistPlWahl1Stat3.Left := 523;
    edLeistPlWahl1Stat3.Top := 185;
    edLeistPlWahl1Stat3.Width := 180;
    edLeistPlWahl1Stat3.Height := 22;
    edLeistPlWahl1Stat3.ChildOrder := 4;
    edLeistPlWahl1Stat3.ElementFont := efCSS;
    edLeistPlWahl1Stat3.ElementPosition := epIgnore;
    edLeistPlWahl1Stat3.Font.Charset := DEFAULT_CHARSET;
    edLeistPlWahl1Stat3.Font.Color := clWindowText;
    edLeistPlWahl1Stat3.Font.Height := -17;
    edLeistPlWahl1Stat3.Font.Name := 'Tahoma';
    edLeistPlWahl1Stat3.Font.Style := [];
    edLeistPlWahl1Stat3.HeightStyle := ssAuto;
    edLeistPlWahl1Stat3.HeightPercent := 100.00000000000000000;
    edLeistPlWahl1Stat3.ParentFont := False;
    edLeistPlWahl1Stat3.Text := 'edLeistPlWahl1Stat3';
    edLeistPlWahl1Stat3.WidthStyle := ssAuto;
    edLeistPlWahl1Stat3.WidthPercent := 100.00000000000000000;
    SetEvent(edLeistPlWahl1Stat3, Self, 'OnExit', 'edLeistPlWahl1Stat1Exit');
    edLeistPlWahl1Stat5.SetParentComponent(pnLeistungsPlanung);
    edLeistPlWahl1Stat5.Name := 'edLeistPlWahl1Stat5';
    edLeistPlWahl1Stat5.Left := 895;
    edLeistPlWahl1Stat5.Top := 187;
    edLeistPlWahl1Stat5.Width := 180;
    edLeistPlWahl1Stat5.Height := 22;
    edLeistPlWahl1Stat5.ChildOrder := 4;
    edLeistPlWahl1Stat5.ElementFont := efCSS;
    edLeistPlWahl1Stat5.ElementPosition := epIgnore;
    edLeistPlWahl1Stat5.Font.Charset := DEFAULT_CHARSET;
    edLeistPlWahl1Stat5.Font.Color := clWindowText;
    edLeistPlWahl1Stat5.Font.Height := -17;
    edLeistPlWahl1Stat5.Font.Name := 'Tahoma';
    edLeistPlWahl1Stat5.Font.Style := [];
    edLeistPlWahl1Stat5.HeightStyle := ssAuto;
    edLeistPlWahl1Stat5.HeightPercent := 100.00000000000000000;
    edLeistPlWahl1Stat5.ParentFont := False;
    edLeistPlWahl1Stat5.Text := 'edLeistPlWahl1Stat5';
    edLeistPlWahl1Stat5.WidthStyle := ssAuto;
    edLeistPlWahl1Stat5.WidthPercent := 100.00000000000000000;
    SetEvent(edLeistPlWahl1Stat5, Self, 'OnExit', 'edLeistPlWahl1Stat1Exit');
    edLeistPlWahl1Stat4.SetParentComponent(pnLeistungsPlanung);
    edLeistPlWahl1Stat4.Name := 'edLeistPlWahl1Stat4';
    edLeistPlWahl1Stat4.Left := 709;
    edLeistPlWahl1Stat4.Top := 187;
    edLeistPlWahl1Stat4.Width := 180;
    edLeistPlWahl1Stat4.Height := 22;
    edLeistPlWahl1Stat4.ChildOrder := 4;
    edLeistPlWahl1Stat4.ElementFont := efCSS;
    edLeistPlWahl1Stat4.ElementPosition := epIgnore;
    edLeistPlWahl1Stat4.Font.Charset := DEFAULT_CHARSET;
    edLeistPlWahl1Stat4.Font.Color := clWindowText;
    edLeistPlWahl1Stat4.Font.Height := -17;
    edLeistPlWahl1Stat4.Font.Name := 'Tahoma';
    edLeistPlWahl1Stat4.Font.Style := [];
    edLeistPlWahl1Stat4.HeightStyle := ssAuto;
    edLeistPlWahl1Stat4.HeightPercent := 100.00000000000000000;
    edLeistPlWahl1Stat4.ParentFont := False;
    edLeistPlWahl1Stat4.Text := 'edLeistPlWahl1Stat4';
    edLeistPlWahl1Stat4.WidthStyle := ssAuto;
    edLeistPlWahl1Stat4.WidthPercent := 100.00000000000000000;
    SetEvent(edLeistPlWahl1Stat4, Self, 'OnExit', 'edLeistPlWahl1Stat1Exit');
    edLeistPlWahl1Stat6.SetParentComponent(pnLeistungsPlanung);
    edLeistPlWahl1Stat6.Name := 'edLeistPlWahl1Stat6';
    edLeistPlWahl1Stat6.Left := 1081;
    edLeistPlWahl1Stat6.Top := 187;
    edLeistPlWahl1Stat6.Width := 180;
    edLeistPlWahl1Stat6.Height := 22;
    edLeistPlWahl1Stat6.ChildOrder := 4;
    edLeistPlWahl1Stat6.ElementFont := efCSS;
    edLeistPlWahl1Stat6.ElementPosition := epIgnore;
    edLeistPlWahl1Stat6.Font.Charset := DEFAULT_CHARSET;
    edLeistPlWahl1Stat6.Font.Color := clWindowText;
    edLeistPlWahl1Stat6.Font.Height := -17;
    edLeistPlWahl1Stat6.Font.Name := 'Tahoma';
    edLeistPlWahl1Stat6.Font.Style := [];
    edLeistPlWahl1Stat6.HeightStyle := ssAuto;
    edLeistPlWahl1Stat6.HeightPercent := 100.00000000000000000;
    edLeistPlWahl1Stat6.ParentFont := False;
    edLeistPlWahl1Stat6.Text := 'edLeistPlWahl1Stat6';
    edLeistPlWahl1Stat6.WidthStyle := ssAuto;
    edLeistPlWahl1Stat6.WidthPercent := 100.00000000000000000;
    SetEvent(edLeistPlWahl1Stat6, Self, 'OnExit', 'edLeistPlWahl1Stat1Exit');
    edLeistPlWahl1Summe.SetParentComponent(pnLeistungsPlanung);
    edLeistPlWahl1Summe.Name := 'edLeistPlWahl1Summe';
    edLeistPlWahl1Summe.Left := 1297;
    edLeistPlWahl1Summe.Top := 185;
    edLeistPlWahl1Summe.Width := 180;
    edLeistPlWahl1Summe.Height := 22;
    edLeistPlWahl1Summe.ChildOrder := 4;
    edLeistPlWahl1Summe.ElementFont := efCSS;
    edLeistPlWahl1Summe.ElementPosition := epIgnore;
    edLeistPlWahl1Summe.Font.Charset := DEFAULT_CHARSET;
    edLeistPlWahl1Summe.Font.Color := clWindowText;
    edLeistPlWahl1Summe.Font.Height := -17;
    edLeistPlWahl1Summe.Font.Name := 'Tahoma';
    edLeistPlWahl1Summe.Font.Style := [];
    edLeistPlWahl1Summe.HeightStyle := ssAuto;
    edLeistPlWahl1Summe.HeightPercent := 100.00000000000000000;
    edLeistPlWahl1Summe.ParentFont := False;
    edLeistPlWahl1Summe.ReadOnly := True;
    edLeistPlWahl1Summe.Text := 'edLeistPlWahl1Summe';
    edLeistPlWahl1Summe.WidthStyle := ssAuto;
    edLeistPlWahl1Summe.WidthPercent := 100.00000000000000000;
    edLeistPlWahl2Stat1.SetParentComponent(pnLeistungsPlanung);
    edLeistPlWahl2Stat1.Name := 'edLeistPlWahl2Stat1';
    edLeistPlWahl2Stat1.Left := 151;
    edLeistPlWahl2Stat1.Top := 213;
    edLeistPlWahl2Stat1.Width := 180;
    edLeistPlWahl2Stat1.Height := 22;
    edLeistPlWahl2Stat1.ChildOrder := 4;
    edLeistPlWahl2Stat1.ElementFont := efCSS;
    edLeistPlWahl2Stat1.ElementPosition := epIgnore;
    edLeistPlWahl2Stat1.Font.Charset := DEFAULT_CHARSET;
    edLeistPlWahl2Stat1.Font.Color := clWindowText;
    edLeistPlWahl2Stat1.Font.Height := -17;
    edLeistPlWahl2Stat1.Font.Name := 'Tahoma';
    edLeistPlWahl2Stat1.Font.Style := [];
    edLeistPlWahl2Stat1.HeightStyle := ssAuto;
    edLeistPlWahl2Stat1.HeightPercent := 100.00000000000000000;
    edLeistPlWahl2Stat1.ParentFont := False;
    edLeistPlWahl2Stat1.Text := 'edLeistPlWahl2Stat1';
    edLeistPlWahl2Stat1.WidthStyle := ssAuto;
    edLeistPlWahl2Stat1.WidthPercent := 100.00000000000000000;
    SetEvent(edLeistPlWahl2Stat1, Self, 'OnExit', 'edLeistPlWahl1Stat1Exit');
    edLeistPlWahl2Stat2.SetParentComponent(pnLeistungsPlanung);
    edLeistPlWahl2Stat2.Name := 'edLeistPlWahl2Stat2';
    edLeistPlWahl2Stat2.Left := 337;
    edLeistPlWahl2Stat2.Top := 213;
    edLeistPlWahl2Stat2.Width := 180;
    edLeistPlWahl2Stat2.Height := 22;
    edLeistPlWahl2Stat2.ChildOrder := 4;
    edLeistPlWahl2Stat2.ElementFont := efCSS;
    edLeistPlWahl2Stat2.ElementPosition := epIgnore;
    edLeistPlWahl2Stat2.Font.Charset := DEFAULT_CHARSET;
    edLeistPlWahl2Stat2.Font.Color := clWindowText;
    edLeistPlWahl2Stat2.Font.Height := -17;
    edLeistPlWahl2Stat2.Font.Name := 'Tahoma';
    edLeistPlWahl2Stat2.Font.Style := [];
    edLeistPlWahl2Stat2.HeightStyle := ssAuto;
    edLeistPlWahl2Stat2.HeightPercent := 100.00000000000000000;
    edLeistPlWahl2Stat2.ParentFont := False;
    edLeistPlWahl2Stat2.Text := 'edLeistPlWahl2Stat2';
    edLeistPlWahl2Stat2.WidthStyle := ssAuto;
    edLeistPlWahl2Stat2.WidthPercent := 100.00000000000000000;
    SetEvent(edLeistPlWahl2Stat2, Self, 'OnExit', 'edLeistPlWahl1Stat1Exit');
    edLeistPlWahl2Stat3.SetParentComponent(pnLeistungsPlanung);
    edLeistPlWahl2Stat3.Name := 'edLeistPlWahl2Stat3';
    edLeistPlWahl2Stat3.Left := 523;
    edLeistPlWahl2Stat3.Top := 213;
    edLeistPlWahl2Stat3.Width := 180;
    edLeistPlWahl2Stat3.Height := 22;
    edLeistPlWahl2Stat3.ChildOrder := 4;
    edLeistPlWahl2Stat3.ElementFont := efCSS;
    edLeistPlWahl2Stat3.ElementPosition := epIgnore;
    edLeistPlWahl2Stat3.Font.Charset := DEFAULT_CHARSET;
    edLeistPlWahl2Stat3.Font.Color := clWindowText;
    edLeistPlWahl2Stat3.Font.Height := -17;
    edLeistPlWahl2Stat3.Font.Name := 'Tahoma';
    edLeistPlWahl2Stat3.Font.Style := [];
    edLeistPlWahl2Stat3.HeightStyle := ssAuto;
    edLeistPlWahl2Stat3.HeightPercent := 100.00000000000000000;
    edLeistPlWahl2Stat3.ParentFont := False;
    edLeistPlWahl2Stat3.Text := 'edLeistPlWahl2Stat3';
    edLeistPlWahl2Stat3.WidthStyle := ssAuto;
    edLeistPlWahl2Stat3.WidthPercent := 100.00000000000000000;
    SetEvent(edLeistPlWahl2Stat3, Self, 'OnExit', 'edLeistPlWahl1Stat1Exit');
    edLeistPlWahl2Stat5.SetParentComponent(pnLeistungsPlanung);
    edLeistPlWahl2Stat5.Name := 'edLeistPlWahl2Stat5';
    edLeistPlWahl2Stat5.Left := 895;
    edLeistPlWahl2Stat5.Top := 215;
    edLeistPlWahl2Stat5.Width := 180;
    edLeistPlWahl2Stat5.Height := 22;
    edLeistPlWahl2Stat5.ChildOrder := 4;
    edLeistPlWahl2Stat5.ElementFont := efCSS;
    edLeistPlWahl2Stat5.ElementPosition := epIgnore;
    edLeistPlWahl2Stat5.Font.Charset := DEFAULT_CHARSET;
    edLeistPlWahl2Stat5.Font.Color := clWindowText;
    edLeistPlWahl2Stat5.Font.Height := -17;
    edLeistPlWahl2Stat5.Font.Name := 'Tahoma';
    edLeistPlWahl2Stat5.Font.Style := [];
    edLeistPlWahl2Stat5.HeightStyle := ssAuto;
    edLeistPlWahl2Stat5.HeightPercent := 100.00000000000000000;
    edLeistPlWahl2Stat5.ParentFont := False;
    edLeistPlWahl2Stat5.Text := 'edLeistPlWahl2Stat5';
    edLeistPlWahl2Stat5.WidthStyle := ssAuto;
    edLeistPlWahl2Stat5.WidthPercent := 100.00000000000000000;
    SetEvent(edLeistPlWahl2Stat5, Self, 'OnExit', 'edLeistPlWahl1Stat1Exit');
    edLeistPlWahl2Stat4.SetParentComponent(pnLeistungsPlanung);
    edLeistPlWahl2Stat4.Name := 'edLeistPlWahl2Stat4';
    edLeistPlWahl2Stat4.Left := 709;
    edLeistPlWahl2Stat4.Top := 215;
    edLeistPlWahl2Stat4.Width := 180;
    edLeistPlWahl2Stat4.Height := 22;
    edLeistPlWahl2Stat4.ChildOrder := 4;
    edLeistPlWahl2Stat4.ElementFont := efCSS;
    edLeistPlWahl2Stat4.ElementPosition := epIgnore;
    edLeistPlWahl2Stat4.Font.Charset := DEFAULT_CHARSET;
    edLeistPlWahl2Stat4.Font.Color := clWindowText;
    edLeistPlWahl2Stat4.Font.Height := -17;
    edLeistPlWahl2Stat4.Font.Name := 'Tahoma';
    edLeistPlWahl2Stat4.Font.Style := [];
    edLeistPlWahl2Stat4.HeightStyle := ssAuto;
    edLeistPlWahl2Stat4.HeightPercent := 100.00000000000000000;
    edLeistPlWahl2Stat4.ParentFont := False;
    edLeistPlWahl2Stat4.Text := 'edLeistPlWahl2Stat4';
    edLeistPlWahl2Stat4.WidthStyle := ssAuto;
    edLeistPlWahl2Stat4.WidthPercent := 100.00000000000000000;
    SetEvent(edLeistPlWahl2Stat4, Self, 'OnExit', 'edLeistPlWahl1Stat1Exit');
    edLeistPlWahl2Stat6.SetParentComponent(pnLeistungsPlanung);
    edLeistPlWahl2Stat6.Name := 'edLeistPlWahl2Stat6';
    edLeistPlWahl2Stat6.Left := 1081;
    edLeistPlWahl2Stat6.Top := 215;
    edLeistPlWahl2Stat6.Width := 180;
    edLeistPlWahl2Stat6.Height := 22;
    edLeistPlWahl2Stat6.ChildOrder := 4;
    edLeistPlWahl2Stat6.ElementFont := efCSS;
    edLeistPlWahl2Stat6.ElementPosition := epIgnore;
    edLeistPlWahl2Stat6.Font.Charset := DEFAULT_CHARSET;
    edLeistPlWahl2Stat6.Font.Color := clWindowText;
    edLeistPlWahl2Stat6.Font.Height := -17;
    edLeistPlWahl2Stat6.Font.Name := 'Tahoma';
    edLeistPlWahl2Stat6.Font.Style := [];
    edLeistPlWahl2Stat6.HeightStyle := ssAuto;
    edLeistPlWahl2Stat6.HeightPercent := 100.00000000000000000;
    edLeistPlWahl2Stat6.ParentFont := False;
    edLeistPlWahl2Stat6.Text := 'edLeistPlWahl2Stat6';
    edLeistPlWahl2Stat6.WidthStyle := ssAuto;
    edLeistPlWahl2Stat6.WidthPercent := 100.00000000000000000;
    SetEvent(edLeistPlWahl2Stat6, Self, 'OnExit', 'edLeistPlWahl1Stat1Exit');
    edLeistPlWahl2Summe.SetParentComponent(pnLeistungsPlanung);
    edLeistPlWahl2Summe.Name := 'edLeistPlWahl2Summe';
    edLeistPlWahl2Summe.Left := 1297;
    edLeistPlWahl2Summe.Top := 213;
    edLeistPlWahl2Summe.Width := 180;
    edLeistPlWahl2Summe.Height := 22;
    edLeistPlWahl2Summe.ChildOrder := 4;
    edLeistPlWahl2Summe.ElementFont := efCSS;
    edLeistPlWahl2Summe.ElementPosition := epIgnore;
    edLeistPlWahl2Summe.Font.Charset := DEFAULT_CHARSET;
    edLeistPlWahl2Summe.Font.Color := clWindowText;
    edLeistPlWahl2Summe.Font.Height := -17;
    edLeistPlWahl2Summe.Font.Name := 'Tahoma';
    edLeistPlWahl2Summe.Font.Style := [];
    edLeistPlWahl2Summe.HeightStyle := ssAuto;
    edLeistPlWahl2Summe.HeightPercent := 100.00000000000000000;
    edLeistPlWahl2Summe.ParentFont := False;
    edLeistPlWahl2Summe.ReadOnly := True;
    edLeistPlWahl2Summe.Text := 'edLeistPlWahl2Summe';
    edLeistPlWahl2Summe.WidthStyle := ssAuto;
    edLeistPlWahl2Summe.WidthPercent := 100.00000000000000000;
    edLeistPlNormStat1.SetParentComponent(pnLeistungsPlanung);
    edLeistPlNormStat1.Name := 'edLeistPlNormStat1';
    edLeistPlNormStat1.Left := 151;
    edLeistPlNormStat1.Top := 241;
    edLeistPlNormStat1.Width := 180;
    edLeistPlNormStat1.Height := 22;
    edLeistPlNormStat1.ChildOrder := 4;
    edLeistPlNormStat1.ElementFont := efCSS;
    edLeistPlNormStat1.ElementPosition := epIgnore;
    edLeistPlNormStat1.Font.Charset := DEFAULT_CHARSET;
    edLeistPlNormStat1.Font.Color := clWindowText;
    edLeistPlNormStat1.Font.Height := -17;
    edLeistPlNormStat1.Font.Name := 'Tahoma';
    edLeistPlNormStat1.Font.Style := [];
    edLeistPlNormStat1.HeightStyle := ssAuto;
    edLeistPlNormStat1.HeightPercent := 100.00000000000000000;
    edLeistPlNormStat1.ParentFont := False;
    edLeistPlNormStat1.Text := 'edLeistPlNormStat1';
    edLeistPlNormStat1.WidthStyle := ssAuto;
    edLeistPlNormStat1.WidthPercent := 100.00000000000000000;
    SetEvent(edLeistPlNormStat1, Self, 'OnExit', 'edLeistPlWahl1Stat1Exit');
    edLeistPlNormStat2.SetParentComponent(pnLeistungsPlanung);
    edLeistPlNormStat2.Name := 'edLeistPlNormStat2';
    edLeistPlNormStat2.Left := 337;
    edLeistPlNormStat2.Top := 241;
    edLeistPlNormStat2.Width := 180;
    edLeistPlNormStat2.Height := 22;
    edLeistPlNormStat2.ChildOrder := 4;
    edLeistPlNormStat2.ElementFont := efCSS;
    edLeistPlNormStat2.ElementPosition := epIgnore;
    edLeistPlNormStat2.Font.Charset := DEFAULT_CHARSET;
    edLeistPlNormStat2.Font.Color := clWindowText;
    edLeistPlNormStat2.Font.Height := -17;
    edLeistPlNormStat2.Font.Name := 'Tahoma';
    edLeistPlNormStat2.Font.Style := [];
    edLeistPlNormStat2.HeightStyle := ssAuto;
    edLeistPlNormStat2.HeightPercent := 100.00000000000000000;
    edLeistPlNormStat2.ParentFont := False;
    edLeistPlNormStat2.Text := 'edLeistPlNormStat2';
    edLeistPlNormStat2.WidthStyle := ssAuto;
    edLeistPlNormStat2.WidthPercent := 100.00000000000000000;
    SetEvent(edLeistPlNormStat2, Self, 'OnExit', 'edLeistPlWahl1Stat1Exit');
    edLeistPlNormStat3.SetParentComponent(pnLeistungsPlanung);
    edLeistPlNormStat3.Name := 'edLeistPlNormStat3';
    edLeistPlNormStat3.Left := 523;
    edLeistPlNormStat3.Top := 241;
    edLeistPlNormStat3.Width := 180;
    edLeistPlNormStat3.Height := 22;
    edLeistPlNormStat3.ChildOrder := 4;
    edLeistPlNormStat3.ElementFont := efCSS;
    edLeistPlNormStat3.ElementPosition := epIgnore;
    edLeistPlNormStat3.Font.Charset := DEFAULT_CHARSET;
    edLeistPlNormStat3.Font.Color := clWindowText;
    edLeistPlNormStat3.Font.Height := -17;
    edLeistPlNormStat3.Font.Name := 'Tahoma';
    edLeistPlNormStat3.Font.Style := [];
    edLeistPlNormStat3.HeightStyle := ssAuto;
    edLeistPlNormStat3.HeightPercent := 100.00000000000000000;
    edLeistPlNormStat3.ParentFont := False;
    edLeistPlNormStat3.Text := 'edLeistPlNormStat3';
    edLeistPlNormStat3.WidthStyle := ssAuto;
    edLeistPlNormStat3.WidthPercent := 100.00000000000000000;
    SetEvent(edLeistPlNormStat3, Self, 'OnExit', 'edLeistPlWahl1Stat1Exit');
    edLeistPlNormStat5.SetParentComponent(pnLeistungsPlanung);
    edLeistPlNormStat5.Name := 'edLeistPlNormStat5';
    edLeistPlNormStat5.Left := 895;
    edLeistPlNormStat5.Top := 243;
    edLeistPlNormStat5.Width := 180;
    edLeistPlNormStat5.Height := 22;
    edLeistPlNormStat5.ChildOrder := 4;
    edLeistPlNormStat5.ElementFont := efCSS;
    edLeistPlNormStat5.ElementPosition := epIgnore;
    edLeistPlNormStat5.Font.Charset := DEFAULT_CHARSET;
    edLeistPlNormStat5.Font.Color := clWindowText;
    edLeistPlNormStat5.Font.Height := -17;
    edLeistPlNormStat5.Font.Name := 'Tahoma';
    edLeistPlNormStat5.Font.Style := [];
    edLeistPlNormStat5.HeightStyle := ssAuto;
    edLeistPlNormStat5.HeightPercent := 100.00000000000000000;
    edLeistPlNormStat5.ParentFont := False;
    edLeistPlNormStat5.Text := 'edLeistPlNormStat5';
    edLeistPlNormStat5.WidthStyle := ssAuto;
    edLeistPlNormStat5.WidthPercent := 100.00000000000000000;
    SetEvent(edLeistPlNormStat5, Self, 'OnExit', 'edLeistPlWahl1Stat1Exit');
    edLeistPlNormStat4.SetParentComponent(pnLeistungsPlanung);
    edLeistPlNormStat4.Name := 'edLeistPlNormStat4';
    edLeistPlNormStat4.Left := 709;
    edLeistPlNormStat4.Top := 243;
    edLeistPlNormStat4.Width := 180;
    edLeistPlNormStat4.Height := 22;
    edLeistPlNormStat4.ChildOrder := 4;
    edLeistPlNormStat4.ElementFont := efCSS;
    edLeistPlNormStat4.ElementPosition := epIgnore;
    edLeistPlNormStat4.Font.Charset := DEFAULT_CHARSET;
    edLeistPlNormStat4.Font.Color := clWindowText;
    edLeistPlNormStat4.Font.Height := -17;
    edLeistPlNormStat4.Font.Name := 'Tahoma';
    edLeistPlNormStat4.Font.Style := [];
    edLeistPlNormStat4.HeightStyle := ssAuto;
    edLeistPlNormStat4.HeightPercent := 100.00000000000000000;
    edLeistPlNormStat4.ParentFont := False;
    edLeistPlNormStat4.Text := 'edLeistPlNormStat4';
    edLeistPlNormStat4.WidthStyle := ssAuto;
    edLeistPlNormStat4.WidthPercent := 100.00000000000000000;
    SetEvent(edLeistPlNormStat4, Self, 'OnExit', 'edLeistPlWahl1Stat1Exit');
    edLeistPlNormStat6.SetParentComponent(pnLeistungsPlanung);
    edLeistPlNormStat6.Name := 'edLeistPlNormStat6';
    edLeistPlNormStat6.Left := 1081;
    edLeistPlNormStat6.Top := 243;
    edLeistPlNormStat6.Width := 180;
    edLeistPlNormStat6.Height := 22;
    edLeistPlNormStat6.ChildOrder := 4;
    edLeistPlNormStat6.ElementFont := efCSS;
    edLeistPlNormStat6.ElementPosition := epIgnore;
    edLeistPlNormStat6.Font.Charset := DEFAULT_CHARSET;
    edLeistPlNormStat6.Font.Color := clWindowText;
    edLeistPlNormStat6.Font.Height := -17;
    edLeistPlNormStat6.Font.Name := 'Tahoma';
    edLeistPlNormStat6.Font.Style := [];
    edLeistPlNormStat6.HeightStyle := ssAuto;
    edLeistPlNormStat6.HeightPercent := 100.00000000000000000;
    edLeistPlNormStat6.ParentFont := False;
    edLeistPlNormStat6.Text := 'edLeistPlNormStat6';
    edLeistPlNormStat6.WidthStyle := ssAuto;
    edLeistPlNormStat6.WidthPercent := 100.00000000000000000;
    SetEvent(edLeistPlNormStat6, Self, 'OnExit', 'edLeistPlWahl1Stat1Exit');
    edLeistPlNormSumme.SetParentComponent(pnLeistungsPlanung);
    edLeistPlNormSumme.Name := 'edLeistPlNormSumme';
    edLeistPlNormSumme.Left := 1297;
    edLeistPlNormSumme.Top := 241;
    edLeistPlNormSumme.Width := 180;
    edLeistPlNormSumme.Height := 22;
    edLeistPlNormSumme.ChildOrder := 4;
    edLeistPlNormSumme.ElementFont := efCSS;
    edLeistPlNormSumme.ElementPosition := epIgnore;
    edLeistPlNormSumme.Font.Charset := DEFAULT_CHARSET;
    edLeistPlNormSumme.Font.Color := clWindowText;
    edLeistPlNormSumme.Font.Height := -17;
    edLeistPlNormSumme.Font.Name := 'Tahoma';
    edLeistPlNormSumme.Font.Style := [];
    edLeistPlNormSumme.HeightStyle := ssAuto;
    edLeistPlNormSumme.HeightPercent := 100.00000000000000000;
    edLeistPlNormSumme.ParentFont := False;
    edLeistPlNormSumme.ReadOnly := True;
    edLeistPlNormSumme.Text := 'edLeistPlNormSumme';
    edLeistPlNormSumme.WidthStyle := ssAuto;
    edLeistPlNormSumme.WidthPercent := 100.00000000000000000;
    edLeistPlSumStat1.SetParentComponent(pnLeistungsPlanung);
    edLeistPlSumStat1.Name := 'edLeistPlSumStat1';
    edLeistPlSumStat1.Left := 151;
    edLeistPlSumStat1.Top := 269;
    edLeistPlSumStat1.Width := 180;
    edLeistPlSumStat1.Height := 22;
    edLeistPlSumStat1.ChildOrder := 4;
    edLeistPlSumStat1.ElementFont := efCSS;
    edLeistPlSumStat1.ElementPosition := epIgnore;
    edLeistPlSumStat1.Font.Charset := DEFAULT_CHARSET;
    edLeistPlSumStat1.Font.Color := clWindowText;
    edLeistPlSumStat1.Font.Height := -17;
    edLeistPlSumStat1.Font.Name := 'Tahoma';
    edLeistPlSumStat1.Font.Style := [];
    edLeistPlSumStat1.HeightStyle := ssAuto;
    edLeistPlSumStat1.HeightPercent := 100.00000000000000000;
    edLeistPlSumStat1.ParentFont := False;
    edLeistPlSumStat1.ReadOnly := True;
    edLeistPlSumStat1.Text := 'edLeistPlSumStat1';
    edLeistPlSumStat1.WidthStyle := ssAuto;
    edLeistPlSumStat1.WidthPercent := 100.00000000000000000;
    SetEvent(edLeistPlSumStat1, Self, 'OnExit', 'edLeistPlWahl1Stat1Exit');
    edLeistPlSumStat2.SetParentComponent(pnLeistungsPlanung);
    edLeistPlSumStat2.Name := 'edLeistPlSumStat2';
    edLeistPlSumStat2.Left := 337;
    edLeistPlSumStat2.Top := 269;
    edLeistPlSumStat2.Width := 180;
    edLeistPlSumStat2.Height := 22;
    edLeistPlSumStat2.ChildOrder := 4;
    edLeistPlSumStat2.ElementFont := efCSS;
    edLeistPlSumStat2.ElementPosition := epIgnore;
    edLeistPlSumStat2.Font.Charset := DEFAULT_CHARSET;
    edLeistPlSumStat2.Font.Color := clWindowText;
    edLeistPlSumStat2.Font.Height := -17;
    edLeistPlSumStat2.Font.Name := 'Tahoma';
    edLeistPlSumStat2.Font.Style := [];
    edLeistPlSumStat2.HeightStyle := ssAuto;
    edLeistPlSumStat2.HeightPercent := 100.00000000000000000;
    edLeistPlSumStat2.ParentFont := False;
    edLeistPlSumStat2.ReadOnly := True;
    edLeistPlSumStat2.Text := 'edLeistPlSumStat2';
    edLeistPlSumStat2.WidthStyle := ssAuto;
    edLeistPlSumStat2.WidthPercent := 100.00000000000000000;
    SetEvent(edLeistPlSumStat2, Self, 'OnExit', 'edLeistPlWahl1Stat1Exit');
    edLeistPlSumStat3.SetParentComponent(pnLeistungsPlanung);
    edLeistPlSumStat3.Name := 'edLeistPlSumStat3';
    edLeistPlSumStat3.Left := 523;
    edLeistPlSumStat3.Top := 269;
    edLeistPlSumStat3.Width := 180;
    edLeistPlSumStat3.Height := 22;
    edLeistPlSumStat3.ChildOrder := 4;
    edLeistPlSumStat3.ElementFont := efCSS;
    edLeistPlSumStat3.ElementPosition := epIgnore;
    edLeistPlSumStat3.Font.Charset := DEFAULT_CHARSET;
    edLeistPlSumStat3.Font.Color := clWindowText;
    edLeistPlSumStat3.Font.Height := -17;
    edLeistPlSumStat3.Font.Name := 'Tahoma';
    edLeistPlSumStat3.Font.Style := [];
    edLeistPlSumStat3.HeightStyle := ssAuto;
    edLeistPlSumStat3.HeightPercent := 100.00000000000000000;
    edLeistPlSumStat3.ParentFont := False;
    edLeistPlSumStat3.ReadOnly := True;
    edLeistPlSumStat3.Text := 'edLeistPlSumStat3';
    edLeistPlSumStat3.WidthStyle := ssAuto;
    edLeistPlSumStat3.WidthPercent := 100.00000000000000000;
    SetEvent(edLeistPlSumStat3, Self, 'OnExit', 'edLeistPlWahl1Stat1Exit');
    edLeistPlSumStat5.SetParentComponent(pnLeistungsPlanung);
    edLeistPlSumStat5.Name := 'edLeistPlSumStat5';
    edLeistPlSumStat5.Left := 895;
    edLeistPlSumStat5.Top := 271;
    edLeistPlSumStat5.Width := 180;
    edLeistPlSumStat5.Height := 22;
    edLeistPlSumStat5.ChildOrder := 4;
    edLeistPlSumStat5.ElementFont := efCSS;
    edLeistPlSumStat5.ElementPosition := epIgnore;
    edLeistPlSumStat5.Font.Charset := DEFAULT_CHARSET;
    edLeistPlSumStat5.Font.Color := clWindowText;
    edLeistPlSumStat5.Font.Height := -17;
    edLeistPlSumStat5.Font.Name := 'Tahoma';
    edLeistPlSumStat5.Font.Style := [];
    edLeistPlSumStat5.HeightStyle := ssAuto;
    edLeistPlSumStat5.HeightPercent := 100.00000000000000000;
    edLeistPlSumStat5.ParentFont := False;
    edLeistPlSumStat5.ReadOnly := True;
    edLeistPlSumStat5.Text := 'edLeistPlSumStat5';
    edLeistPlSumStat5.WidthStyle := ssAuto;
    edLeistPlSumStat5.WidthPercent := 100.00000000000000000;
    SetEvent(edLeistPlSumStat5, Self, 'OnExit', 'edLeistPlWahl1Stat1Exit');
    edLeistPlSumStat4.SetParentComponent(pnLeistungsPlanung);
    edLeistPlSumStat4.Name := 'edLeistPlSumStat4';
    edLeistPlSumStat4.Left := 709;
    edLeistPlSumStat4.Top := 271;
    edLeistPlSumStat4.Width := 180;
    edLeistPlSumStat4.Height := 22;
    edLeistPlSumStat4.ChildOrder := 4;
    edLeistPlSumStat4.ElementFont := efCSS;
    edLeistPlSumStat4.ElementPosition := epIgnore;
    edLeistPlSumStat4.Font.Charset := DEFAULT_CHARSET;
    edLeistPlSumStat4.Font.Color := clWindowText;
    edLeistPlSumStat4.Font.Height := -17;
    edLeistPlSumStat4.Font.Name := 'Tahoma';
    edLeistPlSumStat4.Font.Style := [];
    edLeistPlSumStat4.HeightStyle := ssAuto;
    edLeistPlSumStat4.HeightPercent := 100.00000000000000000;
    edLeistPlSumStat4.ParentFont := False;
    edLeistPlSumStat4.ReadOnly := True;
    edLeistPlSumStat4.Text := 'edLeistPlSumStat4';
    edLeistPlSumStat4.WidthStyle := ssAuto;
    edLeistPlSumStat4.WidthPercent := 100.00000000000000000;
    SetEvent(edLeistPlSumStat4, Self, 'OnExit', 'edLeistPlWahl1Stat1Exit');
    edLeistPlSumStat6.SetParentComponent(pnLeistungsPlanung);
    edLeistPlSumStat6.Name := 'edLeistPlSumStat6';
    edLeistPlSumStat6.Left := 1081;
    edLeistPlSumStat6.Top := 271;
    edLeistPlSumStat6.Width := 180;
    edLeistPlSumStat6.Height := 22;
    edLeistPlSumStat6.ChildOrder := 4;
    edLeistPlSumStat6.ElementFont := efCSS;
    edLeistPlSumStat6.ElementPosition := epIgnore;
    edLeistPlSumStat6.Font.Charset := DEFAULT_CHARSET;
    edLeistPlSumStat6.Font.Color := clWindowText;
    edLeistPlSumStat6.Font.Height := -17;
    edLeistPlSumStat6.Font.Name := 'Tahoma';
    edLeistPlSumStat6.Font.Style := [];
    edLeistPlSumStat6.HeightStyle := ssAuto;
    edLeistPlSumStat6.HeightPercent := 100.00000000000000000;
    edLeistPlSumStat6.ParentFont := False;
    edLeistPlSumStat6.ReadOnly := True;
    edLeistPlSumStat6.Text := 'edLeistPlSumStat6';
    edLeistPlSumStat6.WidthStyle := ssAuto;
    edLeistPlSumStat6.WidthPercent := 100.00000000000000000;
    SetEvent(edLeistPlSumStat6, Self, 'OnExit', 'edLeistPlWahl1Stat1Exit');
    edLeistPlSumSumme.SetParentComponent(pnLeistungsPlanung);
    edLeistPlSumSumme.Name := 'edLeistPlSumSumme';
    edLeistPlSumSumme.Left := 1297;
    edLeistPlSumSumme.Top := 269;
    edLeistPlSumSumme.Width := 180;
    edLeistPlSumSumme.Height := 22;
    edLeistPlSumSumme.ChildOrder := 4;
    edLeistPlSumSumme.ElementFont := efCSS;
    edLeistPlSumSumme.ElementPosition := epIgnore;
    edLeistPlSumSumme.Font.Charset := DEFAULT_CHARSET;
    edLeistPlSumSumme.Font.Color := clWindowText;
    edLeistPlSumSumme.Font.Height := -17;
    edLeistPlSumSumme.Font.Name := 'Tahoma';
    edLeistPlSumSumme.Font.Style := [];
    edLeistPlSumSumme.HeightStyle := ssAuto;
    edLeistPlSumSumme.HeightPercent := 100.00000000000000000;
    edLeistPlSumSumme.ParentFont := False;
    edLeistPlSumSumme.ReadOnly := True;
    edLeistPlSumSumme.Text := 'edLeistPlSumSumme';
    edLeistPlSumSumme.WidthStyle := ssAuto;
    edLeistPlSumSumme.WidthPercent := 100.00000000000000000;
    edLeistSumFaelleAbtl.SetParentComponent(pnLeistungsPlanung);
    edLeistSumFaelleAbtl.Name := 'edLeistSumFaelleAbtl';
    edLeistSumFaelleAbtl.Left := 604;
    edLeistSumFaelleAbtl.Top := 339;
    edLeistSumFaelleAbtl.Width := 180;
    edLeistSumFaelleAbtl.Height := 22;
    edLeistSumFaelleAbtl.ChildOrder := 4;
    edLeistSumFaelleAbtl.ElementFont := efCSS;
    edLeistSumFaelleAbtl.ElementPosition := epIgnore;
    edLeistSumFaelleAbtl.Font.Charset := DEFAULT_CHARSET;
    edLeistSumFaelleAbtl.Font.Color := clWindowText;
    edLeistSumFaelleAbtl.Font.Height := -17;
    edLeistSumFaelleAbtl.Font.Name := 'Tahoma';
    edLeistSumFaelleAbtl.Font.Style := [];
    edLeistSumFaelleAbtl.HeightStyle := ssAuto;
    edLeistSumFaelleAbtl.HeightPercent := 100.00000000000000000;
    edLeistSumFaelleAbtl.ParentFont := False;
    edLeistSumFaelleAbtl.ReadOnly := True;
    edLeistSumFaelleAbtl.Text := 'edLeistSumFaelleAbtl';
    edLeistSumFaelleAbtl.WidthStyle := ssAuto;
    edLeistSumFaelleAbtl.WidthPercent := 100.00000000000000000;
    pnKodierdienst.SetParentComponent(pgcSheetFaelleInstitute);
    pnKodierdienst.Name := 'pnKodierdienst';
    pnKodierdienst.Left := 27;
    pnKodierdienst.Top := 659;
    pnKodierdienst.Width := 1319;
    pnKodierdienst.Height := 150;
    pnKodierdienst.ElementClassName := 'card';
    pnKodierdienst.HeightStyle := ssAuto;
    pnKodierdienst.WidthStyle := ssAuto;
    pnKodierdienst.ChildOrder := 2;
    pnKodierdienst.ElementFont := efCSS;
    pnKodierdienst.ElementPosition := epRelative;
    pnKodierdienst.TabOrder := 2;
    lblCaseManagementAktiv.SetParentComponent(pnKodierdienst);
    lblCaseManagementAktiv.Name := 'lblCaseManagementAktiv';
    lblCaseManagementAktiv.Left := 137;
    lblCaseManagementAktiv.Top := 65;
    lblCaseManagementAktiv.Width := 277;
    lblCaseManagementAktiv.Height := 29;
    lblCaseManagementAktiv.Caption := 'Kodierdienst aktivieren';
    lblCaseManagementAktiv.ElementFont := efCSS;
    lblCaseManagementAktiv.ElementPosition := epRelative;
    lblCaseManagementAktiv.Font.Charset := DEFAULT_CHARSET;
    lblCaseManagementAktiv.Font.Color := clWindowText;
    lblCaseManagementAktiv.Font.Height := -24;
    lblCaseManagementAktiv.Font.Name := 'Tahoma';
    lblCaseManagementAktiv.Font.Style := [fsBold];
    lblCaseManagementAktiv.HeightStyle := ssAuto;
    lblCaseManagementAktiv.HeightPercent := 100.00000000000000000;
    lblCaseManagementAktiv.ParentFont := False;
    lblCaseManagementAktiv.WidthStyle := ssAuto;
    lblCaseManagementAktiv.WidthPercent := 100.00000000000000000;
    lblCaseManagement.SetParentComponent(pnKodierdienst);
    lblCaseManagement.Name := 'lblCaseManagement';
    lblCaseManagement.Left := 48;
    lblCaseManagement.Top := 28;
    lblCaseManagement.Width := 78;
    lblCaseManagement.Height := 18;
    lblCaseManagement.Caption := 'Kodierdienst';
    lblCaseManagement.ElementFont := efCSS;
    lblCaseManagement.HeightStyle := ssAuto;
    lblCaseManagement.HeightPercent := 100.00000000000000000;
    lblCaseManagement.HTMLType := tH3;
    lblCaseManagement.WidthPercent := 100.00000000000000000;
    cb_CodD.SetParentComponent(pnKodierdienst);
    cb_CodD.Name := 'cb_CodD';
    cb_CodD.Left := 48;
    cb_CodD.Top := 72;
    cb_CodD.Width := 43;
    cb_CodD.Height := 22;
    cb_CodD.ChildOrder := 21;
    cb_CodD.ElementClassName := 'mr-4 toggle toggle-primary toggle-xl bg-base-300 border-2';
    cb_CodD.ElementFont := efCSS;
    cb_CodD.ElementPosition := epRelative;
    cb_CodD.Font.Charset := DEFAULT_CHARSET;
    cb_CodD.Font.Color := clWindowText;
    cb_CodD.Font.Height := -24;
    cb_CodD.Font.Name := 'Tahoma';
    cb_CodD.Font.Style := [fsBold];
    cb_CodD.HeightStyle := ssAuto;
    cb_CodD.HeightPercent := 100.00000000000000000;
    cb_CodD.ParentFont := False;
    cb_CodD.WidthStyle := ssAuto;
    cb_CodD.WidthPercent := 100.00000000000000000;
    cb_CodD.DataField := 'Hbpm_Coding';
    cb_CodD.DataSource := PerfMiscWebDataSource;
    cb_CodD.ValueChecked := '1';
    cb_CodD.ValueUnChecked := '0';
    pgcSheetStationenPersonal.SetParentComponent(pgcEntscheidungen);
    pgcSheetStationenPersonal.Name := 'pgcSheetStationenPersonal';
    pgcSheetStationenPersonal.Left := 0;
    pgcSheetStationenPersonal.Top := 20;
    pgcSheetStationenPersonal.Width := 1600;
    pgcSheetStationenPersonal.Height := 1147;
    pgcSheetStationenPersonal.Caption := 'Stationen / Personal';
    pgcSheetStationenPersonal.ChildOrder := 1;
    pgcSheetStationenPersonal.ElementFont := efCSS;
    pnLeistungsKategorie.SetParentComponent(pgcSheetStationenPersonal);
    pnLeistungsKategorie.Name := 'pnLeistungsKategorie';
    pnLeistungsKategorie.Left := 0;
    pnLeistungsKategorie.Top := 0;
    pnLeistungsKategorie.Width := 1600;
    pnLeistungsKategorie.Height := 417;
    pnLeistungsKategorie.HeightStyle := ssAuto;
    pnLeistungsKategorie.WidthStyle := ssAuto;
    pnLeistungsKategorie.Align := alTop;
    pnLeistungsKategorie.Caption := 'pnLeistungsKategorie';
    pnLeistungsKategorie.ChildOrder := 1;
    pnLeistungsKategorie.ElementFont := efCSS;
    pnLeistungsKategorie.ElementPosition := epRelative;
    pnLeistungsKategorie.ShowCaption := False;
    pnLeistungsKategorie.TabOrder := 0;
    WebLabel18.SetParentComponent(pnLeistungsKategorie);
    WebLabel18.Name := 'WebLabel18';
    WebLabel18.Left := 50;
    WebLabel18.Top := 16;
    WebLabel18.Width := 296;
    WebLabel18.Height := 18;
    WebLabel18.Caption := 'Nutzung der Betten nach Leistungskategorien';
    WebLabel18.ElementFont := efCSS;
    WebLabel18.ElementPosition := epRelative;
    WebLabel18.HeightStyle := ssAuto;
    WebLabel18.HeightPercent := 100.00000000000000000;
    WebLabel18.HTMLType := tH3;
    WebLabel18.WidthPercent := 100.00000000000000000;
    lb_LeistKatStation.SetParentComponent(pnLeistungsKategorie);
    lb_LeistKatStation.Name := 'lb_LeistKatStation';
    lb_LeistKatStation.Left := 550;
    lb_LeistKatStation.Top := 70;
    lb_LeistKatStation.Width := 113;
    lb_LeistKatStation.Height := 18;
    lb_LeistKatStation.Caption := 'lb_LeistKatStation';
    lb_LeistKatStation.HeightPercent := 100.00000000000000000;
    lb_LeistKatStation.WidthPercent := 100.00000000000000000;
    lb_LeistKatAnzahlAlt.SetParentComponent(pnLeistungsKategorie);
    lb_LeistKatAnzahlAlt.Name := 'lb_LeistKatAnzahlAlt';
    lb_LeistKatAnzahlAlt.Left := 193;
    lb_LeistKatAnzahlAlt.Top := 129;
    lb_LeistKatAnzahlAlt.Width := 127;
    lb_LeistKatAnzahlAlt.Height := 18;
    lb_LeistKatAnzahlAlt.Caption := 'lb_LeistKatAnzahlAlt';
    lb_LeistKatAnzahlAlt.HeightPercent := 100.00000000000000000;
    lb_LeistKatAnzahlAlt.WidthPercent := 100.00000000000000000;
    lb_LeistKatUmwandlung.SetParentComponent(pnLeistungsKategorie);
    lb_LeistKatUmwandlung.Name := 'lb_LeistKatUmwandlung';
    lb_LeistKatUmwandlung.Left := 472;
    lb_LeistKatUmwandlung.Top := 129;
    lb_LeistKatUmwandlung.Width := 152;
    lb_LeistKatUmwandlung.Height := 18;
    lb_LeistKatUmwandlung.Caption := 'lb_LeistKatUmwandlung';
    lb_LeistKatUmwandlung.HeightPercent := 100.00000000000000000;
    lb_LeistKatUmwandlung.WidthPercent := 100.00000000000000000;
    lb_LeistKatErwAbbau.SetParentComponent(pnLeistungsKategorie);
    lb_LeistKatErwAbbau.Name := 'lb_LeistKatErwAbbau';
    lb_LeistKatErwAbbau.Left := 621;
    lb_LeistKatErwAbbau.Top := 129;
    lb_LeistKatErwAbbau.Width := 133;
    lb_LeistKatErwAbbau.Height := 18;
    lb_LeistKatErwAbbau.Caption := 'lb_LeistKatErwAbbau';
    lb_LeistKatErwAbbau.HeightPercent := 100.00000000000000000;
    lb_LeistKatErwAbbau.WidthPercent := 100.00000000000000000;
    lb_LeistKatAnzahlNeu.SetParentComponent(pnLeistungsKategorie);
    lb_LeistKatAnzahlNeu.Name := 'lb_LeistKatAnzahlNeu';
    lb_LeistKatAnzahlNeu.Left := 765;
    lb_LeistKatAnzahlNeu.Top := 129;
    lb_LeistKatAnzahlNeu.Width := 137;
    lb_LeistKatAnzahlNeu.Height := 18;
    lb_LeistKatAnzahlNeu.Caption := 'lb_LeistKatAnzahlNeu';
    lb_LeistKatAnzahlNeu.HeightPercent := 100.00000000000000000;
    lb_LeistKatAnzahlNeu.WidthPercent := 100.00000000000000000;
    lb_LeistKatZuschlag.SetParentComponent(pnLeistungsKategorie);
    lb_LeistKatZuschlag.Name := 'lb_LeistKatZuschlag';
    lb_LeistKatZuschlag.Left := 1045;
    lb_LeistKatZuschlag.Top := 131;
    lb_LeistKatZuschlag.Width := 125;
    lb_LeistKatZuschlag.Height := 18;
    lb_LeistKatZuschlag.Caption := 'lb_LeistKatZuschlag';
    lb_LeistKatZuschlag.HeightPercent := 100.00000000000000000;
    lb_LeistKatZuschlag.WidthPercent := 100.00000000000000000;
    lb_LeistKatStat1.SetParentComponent(pnLeistungsKategorie);
    lb_LeistKatStat1.Name := 'lb_LeistKatStat1';
    lb_LeistKatStat1.Left := 18;
    lb_LeistKatStat1.Top := 179;
    lb_LeistKatStat1.Width := 103;
    lb_LeistKatStat1.Height := 18;
    lb_LeistKatStat1.Caption := 'lb_LeistKatStat1';
    lb_LeistKatStat1.HeightPercent := 100.00000000000000000;
    lb_LeistKatStat1.WidthPercent := 100.00000000000000000;
    lb_LeistKatStat2.SetParentComponent(pnLeistungsKategorie);
    lb_LeistKatStat2.Name := 'lb_LeistKatStat2';
    lb_LeistKatStat2.Left := 15;
    lb_LeistKatStat2.Top := 224;
    lb_LeistKatStat2.Width := 103;
    lb_LeistKatStat2.Height := 18;
    lb_LeistKatStat2.Caption := 'lb_LeistKatStat2';
    lb_LeistKatStat2.HeightPercent := 100.00000000000000000;
    lb_LeistKatStat2.WidthPercent := 100.00000000000000000;
    lb_LeistKatStat3.SetParentComponent(pnLeistungsKategorie);
    lb_LeistKatStat3.Name := 'lb_LeistKatStat3';
    lb_LeistKatStat3.Left := 15;
    lb_LeistKatStat3.Top := 269;
    lb_LeistKatStat3.Width := 103;
    lb_LeistKatStat3.Height := 18;
    lb_LeistKatStat3.Caption := 'lb_LeistKatStat3';
    lb_LeistKatStat3.HeightPercent := 100.00000000000000000;
    lb_LeistKatStat3.WidthPercent := 100.00000000000000000;
    lb_LeistKatStatSumme.SetParentComponent(pnLeistungsKategorie);
    lb_LeistKatStatSumme.Name := 'lb_LeistKatStatSumme';
    lb_LeistKatStatSumme.Left := 18;
    lb_LeistKatStatSumme.Top := 314;
    lb_LeistKatStatSumme.Width := 145;
    lb_LeistKatStatSumme.Height := 18;
    lb_LeistKatStatSumme.Caption := 'lb_LeistKatStatSumme';
    lb_LeistKatStatSumme.HeightPercent := 100.00000000000000000;
    lb_LeistKatStatSumme.WidthPercent := 100.00000000000000000;
    ed_LeistKatWahlLeist1AnzAltZi.SetParentComponent(pnLeistungsKategorie);
    ed_LeistKatWahlLeist1AnzAltZi.Name := 'ed_LeistKatWahlLeist1AnzAltZi';
    ed_LeistKatWahlLeist1AnzAltZi.Left := 189;
    ed_LeistKatWahlLeist1AnzAltZi.Top := 179;
    ed_LeistKatWahlLeist1AnzAltZi.Width := 120;
    ed_LeistKatWahlLeist1AnzAltZi.Height := 22;
    ed_LeistKatWahlLeist1AnzAltZi.ChildOrder := 4;
    ed_LeistKatWahlLeist1AnzAltZi.ElementFont := efCSS;
    ed_LeistKatWahlLeist1AnzAltZi.ElementPosition := epIgnore;
    ed_LeistKatWahlLeist1AnzAltZi.HeightStyle := ssAuto;
    ed_LeistKatWahlLeist1AnzAltZi.HeightPercent := 100.00000000000000000;
    ed_LeistKatWahlLeist1AnzAltZi.ReadOnly := True;
    ed_LeistKatWahlLeist1AnzAltZi.Text := 'ed_LeistKatWahlLeist1AnzAltZi';
    ed_LeistKatWahlLeist1AnzAltZi.WidthStyle := ssAuto;
    ed_LeistKatWahlLeist1AnzAltZi.WidthPercent := 100.00000000000000000;
    SetEvent(ed_LeistKatWahlLeist1AnzAltZi, Self, 'OnExit', 'ed_LeistKatWahlLeist1AnzAltZiExit');
    ed_LeistKatWahlLeist2AnzAltZi.SetParentComponent(pnLeistungsKategorie);
    ed_LeistKatWahlLeist2AnzAltZi.Name := 'ed_LeistKatWahlLeist2AnzAltZi';
    ed_LeistKatWahlLeist2AnzAltZi.Left := 186;
    ed_LeistKatWahlLeist2AnzAltZi.Top := 224;
    ed_LeistKatWahlLeist2AnzAltZi.Width := 120;
    ed_LeistKatWahlLeist2AnzAltZi.Height := 22;
    ed_LeistKatWahlLeist2AnzAltZi.ChildOrder := 4;
    ed_LeistKatWahlLeist2AnzAltZi.ElementFont := efCSS;
    ed_LeistKatWahlLeist2AnzAltZi.ElementPosition := epIgnore;
    ed_LeistKatWahlLeist2AnzAltZi.HeightStyle := ssAuto;
    ed_LeistKatWahlLeist2AnzAltZi.HeightPercent := 100.00000000000000000;
    ed_LeistKatWahlLeist2AnzAltZi.ReadOnly := True;
    ed_LeistKatWahlLeist2AnzAltZi.Text := 'ed_LeistKatWahlLeist2AnzAltZi';
    ed_LeistKatWahlLeist2AnzAltZi.WidthStyle := ssAuto;
    ed_LeistKatWahlLeist2AnzAltZi.WidthPercent := 100.00000000000000000;
    SetEvent(ed_LeistKatWahlLeist2AnzAltZi, Self, 'OnExit', 'ed_LeistKatWahlLeist1AnzAltZiExit');
    ed_LeistKatNormalAnzAltZi.SetParentComponent(pnLeistungsKategorie);
    ed_LeistKatNormalAnzAltZi.Name := 'ed_LeistKatNormalAnzAltZi';
    ed_LeistKatNormalAnzAltZi.Left := 186;
    ed_LeistKatNormalAnzAltZi.Top := 269;
    ed_LeistKatNormalAnzAltZi.Width := 120;
    ed_LeistKatNormalAnzAltZi.Height := 22;
    ed_LeistKatNormalAnzAltZi.ChildOrder := 4;
    ed_LeistKatNormalAnzAltZi.ElementFont := efCSS;
    ed_LeistKatNormalAnzAltZi.ElementPosition := epIgnore;
    ed_LeistKatNormalAnzAltZi.HeightStyle := ssAuto;
    ed_LeistKatNormalAnzAltZi.HeightPercent := 100.00000000000000000;
    ed_LeistKatNormalAnzAltZi.ReadOnly := True;
    ed_LeistKatNormalAnzAltZi.Text := 'ed_LeistKatNormalAnzAltZi';
    ed_LeistKatNormalAnzAltZi.WidthStyle := ssAuto;
    ed_LeistKatNormalAnzAltZi.WidthPercent := 100.00000000000000000;
    SetEvent(ed_LeistKatNormalAnzAltZi, Self, 'OnExit', 'ed_LeistKatWahlLeist1AnzAltZiExit');
    ed_LeistSummeAnzAltZi.SetParentComponent(pnLeistungsKategorie);
    ed_LeistSummeAnzAltZi.Name := 'ed_LeistSummeAnzAltZi';
    ed_LeistSummeAnzAltZi.Left := 186;
    ed_LeistSummeAnzAltZi.Top := 314;
    ed_LeistSummeAnzAltZi.Width := 120;
    ed_LeistSummeAnzAltZi.Height := 22;
    ed_LeistSummeAnzAltZi.ChildOrder := 4;
    ed_LeistSummeAnzAltZi.ElementFont := efCSS;
    ed_LeistSummeAnzAltZi.ElementPosition := epIgnore;
    ed_LeistSummeAnzAltZi.HeightStyle := ssAuto;
    ed_LeistSummeAnzAltZi.HeightPercent := 100.00000000000000000;
    ed_LeistSummeAnzAltZi.ReadOnly := True;
    ed_LeistSummeAnzAltZi.Text := 'ed_LeistSummeAnzAltZi';
    ed_LeistSummeAnzAltZi.WidthStyle := ssAuto;
    ed_LeistSummeAnzAltZi.WidthPercent := 100.00000000000000000;
    ed_LeistKatWahlLeist1AnzAltBt.SetParentComponent(pnLeistungsKategorie);
    ed_LeistKatWahlLeist1AnzAltBt.Name := 'ed_LeistKatWahlLeist1AnzAltBt';
    ed_LeistKatWahlLeist1AnzAltBt.Left := 341;
    ed_LeistKatWahlLeist1AnzAltBt.Top := 179;
    ed_LeistKatWahlLeist1AnzAltBt.Width := 120;
    ed_LeistKatWahlLeist1AnzAltBt.Height := 22;
    ed_LeistKatWahlLeist1AnzAltBt.ChildOrder := 4;
    ed_LeistKatWahlLeist1AnzAltBt.ElementFont := efCSS;
    ed_LeistKatWahlLeist1AnzAltBt.ElementPosition := epIgnore;
    ed_LeistKatWahlLeist1AnzAltBt.HeightStyle := ssAuto;
    ed_LeistKatWahlLeist1AnzAltBt.HeightPercent := 100.00000000000000000;
    ed_LeistKatWahlLeist1AnzAltBt.ReadOnly := True;
    ed_LeistKatWahlLeist1AnzAltBt.Text := 'ed_LeistKatWahlLeist1AnzAltZi';
    ed_LeistKatWahlLeist1AnzAltBt.WidthStyle := ssAuto;
    ed_LeistKatWahlLeist1AnzAltBt.WidthPercent := 100.00000000000000000;
    SetEvent(ed_LeistKatWahlLeist1AnzAltBt, Self, 'OnExit', 'ed_LeistKatWahlLeist1AnzAltZiExit');
    ed_LeistKatWahlLeist2AnzAltBt.SetParentComponent(pnLeistungsKategorie);
    ed_LeistKatWahlLeist2AnzAltBt.Name := 'ed_LeistKatWahlLeist2AnzAltBt';
    ed_LeistKatWahlLeist2AnzAltBt.Left := 338;
    ed_LeistKatWahlLeist2AnzAltBt.Top := 224;
    ed_LeistKatWahlLeist2AnzAltBt.Width := 120;
    ed_LeistKatWahlLeist2AnzAltBt.Height := 22;
    ed_LeistKatWahlLeist2AnzAltBt.ChildOrder := 4;
    ed_LeistKatWahlLeist2AnzAltBt.ElementFont := efCSS;
    ed_LeistKatWahlLeist2AnzAltBt.ElementPosition := epIgnore;
    ed_LeistKatWahlLeist2AnzAltBt.HeightStyle := ssAuto;
    ed_LeistKatWahlLeist2AnzAltBt.HeightPercent := 100.00000000000000000;
    ed_LeistKatWahlLeist2AnzAltBt.ReadOnly := True;
    ed_LeistKatWahlLeist2AnzAltBt.Text := 'ed_LeistKatWahlLeist2AnzAltBt';
    ed_LeistKatWahlLeist2AnzAltBt.WidthStyle := ssAuto;
    ed_LeistKatWahlLeist2AnzAltBt.WidthPercent := 100.00000000000000000;
    SetEvent(ed_LeistKatWahlLeist2AnzAltBt, Self, 'OnExit', 'ed_LeistKatWahlLeist1AnzAltZiExit');
    ed_LeistKatNormalAnzAltBt.SetParentComponent(pnLeistungsKategorie);
    ed_LeistKatNormalAnzAltBt.Name := 'ed_LeistKatNormalAnzAltBt';
    ed_LeistKatNormalAnzAltBt.Left := 338;
    ed_LeistKatNormalAnzAltBt.Top := 269;
    ed_LeistKatNormalAnzAltBt.Width := 120;
    ed_LeistKatNormalAnzAltBt.Height := 22;
    ed_LeistKatNormalAnzAltBt.ChildOrder := 4;
    ed_LeistKatNormalAnzAltBt.ElementFont := efCSS;
    ed_LeistKatNormalAnzAltBt.ElementPosition := epIgnore;
    ed_LeistKatNormalAnzAltBt.HeightStyle := ssAuto;
    ed_LeistKatNormalAnzAltBt.HeightPercent := 100.00000000000000000;
    ed_LeistKatNormalAnzAltBt.ReadOnly := True;
    ed_LeistKatNormalAnzAltBt.Text := 'ed_LeistKatNormalAnzAltBt';
    ed_LeistKatNormalAnzAltBt.WidthStyle := ssAuto;
    ed_LeistKatNormalAnzAltBt.WidthPercent := 100.00000000000000000;
    SetEvent(ed_LeistKatNormalAnzAltBt, Self, 'OnExit', 'ed_LeistKatWahlLeist1AnzAltZiExit');
    ed_LeistSummeAnzAltBt.SetParentComponent(pnLeistungsKategorie);
    ed_LeistSummeAnzAltBt.Name := 'ed_LeistSummeAnzAltBt';
    ed_LeistSummeAnzAltBt.Left := 338;
    ed_LeistSummeAnzAltBt.Top := 314;
    ed_LeistSummeAnzAltBt.Width := 120;
    ed_LeistSummeAnzAltBt.Height := 22;
    ed_LeistSummeAnzAltBt.ChildOrder := 4;
    ed_LeistSummeAnzAltBt.ElementFont := efCSS;
    ed_LeistSummeAnzAltBt.ElementPosition := epIgnore;
    ed_LeistSummeAnzAltBt.HeightStyle := ssAuto;
    ed_LeistSummeAnzAltBt.HeightPercent := 100.00000000000000000;
    ed_LeistSummeAnzAltBt.ReadOnly := True;
    ed_LeistSummeAnzAltBt.Text := 'ed_LeistSummeAnzAltBt';
    ed_LeistSummeAnzAltBt.WidthStyle := ssAuto;
    ed_LeistSummeAnzAltBt.WidthPercent := 100.00000000000000000;
    ed_LeistKatWahlLeist1Umwandlung.SetParentComponent(pnLeistungsKategorie);
    ed_LeistKatWahlLeist1Umwandlung.Name := 'ed_LeistKatWahlLeist1Umwandlung';
    ed_LeistKatWahlLeist1Umwandlung.Left := 475;
    ed_LeistKatWahlLeist1Umwandlung.Top := 179;
    ed_LeistKatWahlLeist1Umwandlung.Width := 120;
    ed_LeistKatWahlLeist1Umwandlung.Height := 22;
    ed_LeistKatWahlLeist1Umwandlung.ChildOrder := 4;
    ed_LeistKatWahlLeist1Umwandlung.ElementFont := efCSS;
    ed_LeistKatWahlLeist1Umwandlung.ElementPosition := epIgnore;
    ed_LeistKatWahlLeist1Umwandlung.HeightStyle := ssAuto;
    ed_LeistKatWahlLeist1Umwandlung.HeightPercent := 100.00000000000000000;
    ed_LeistKatWahlLeist1Umwandlung.Text := 'ed_LeistKatWahlLeist1AnzAltZi';
    ed_LeistKatWahlLeist1Umwandlung.WidthStyle := ssAuto;
    ed_LeistKatWahlLeist1Umwandlung.WidthPercent := 100.00000000000000000;
    SetEvent(ed_LeistKatWahlLeist1Umwandlung, Self, 'OnExit', 'ed_LeistKatWahlLeist1AnzAltZiExit');
    ed_LeistKatWahlLeist2Umwandlung.SetParentComponent(pnLeistungsKategorie);
    ed_LeistKatWahlLeist2Umwandlung.Name := 'ed_LeistKatWahlLeist2Umwandlung';
    ed_LeistKatWahlLeist2Umwandlung.Left := 472;
    ed_LeistKatWahlLeist2Umwandlung.Top := 224;
    ed_LeistKatWahlLeist2Umwandlung.Width := 120;
    ed_LeistKatWahlLeist2Umwandlung.Height := 22;
    ed_LeistKatWahlLeist2Umwandlung.ChildOrder := 4;
    ed_LeistKatWahlLeist2Umwandlung.ElementFont := efCSS;
    ed_LeistKatWahlLeist2Umwandlung.ElementPosition := epIgnore;
    ed_LeistKatWahlLeist2Umwandlung.HeightStyle := ssAuto;
    ed_LeistKatWahlLeist2Umwandlung.HeightPercent := 100.00000000000000000;
    ed_LeistKatWahlLeist2Umwandlung.Text := 'ed_LeistKatWahlLeist2Umwandlung';
    ed_LeistKatWahlLeist2Umwandlung.WidthStyle := ssAuto;
    ed_LeistKatWahlLeist2Umwandlung.WidthPercent := 100.00000000000000000;
    SetEvent(ed_LeistKatWahlLeist2Umwandlung, Self, 'OnExit', 'ed_LeistKatWahlLeist1AnzAltZiExit');
    ed_LeistKatNormalUmwandlung.SetParentComponent(pnLeistungsKategorie);
    ed_LeistKatNormalUmwandlung.Name := 'ed_LeistKatNormalUmwandlung';
    ed_LeistKatNormalUmwandlung.Left := 472;
    ed_LeistKatNormalUmwandlung.Top := 269;
    ed_LeistKatNormalUmwandlung.Width := 120;
    ed_LeistKatNormalUmwandlung.Height := 22;
    ed_LeistKatNormalUmwandlung.ChildOrder := 4;
    ed_LeistKatNormalUmwandlung.ElementFont := efCSS;
    ed_LeistKatNormalUmwandlung.ElementPosition := epIgnore;
    ed_LeistKatNormalUmwandlung.HeightStyle := ssAuto;
    ed_LeistKatNormalUmwandlung.HeightPercent := 100.00000000000000000;
    ed_LeistKatNormalUmwandlung.Text := 'ed_LeistKatNormalUmwandlung';
    ed_LeistKatNormalUmwandlung.WidthStyle := ssAuto;
    ed_LeistKatNormalUmwandlung.WidthPercent := 100.00000000000000000;
    SetEvent(ed_LeistKatNormalUmwandlung, Self, 'OnExit', 'ed_LeistKatWahlLeist1AnzAltZiExit');
    ed_LeistSummeUmwandlung.SetParentComponent(pnLeistungsKategorie);
    ed_LeistSummeUmwandlung.Name := 'ed_LeistSummeUmwandlung';
    ed_LeistSummeUmwandlung.Left := 472;
    ed_LeistSummeUmwandlung.Top := 314;
    ed_LeistSummeUmwandlung.Width := 120;
    ed_LeistSummeUmwandlung.Height := 22;
    ed_LeistSummeUmwandlung.ChildOrder := 4;
    ed_LeistSummeUmwandlung.ElementFont := efCSS;
    ed_LeistSummeUmwandlung.ElementPosition := epIgnore;
    ed_LeistSummeUmwandlung.HeightStyle := ssAuto;
    ed_LeistSummeUmwandlung.HeightPercent := 100.00000000000000000;
    ed_LeistSummeUmwandlung.ReadOnly := True;
    ed_LeistSummeUmwandlung.Text := 'ed_LeistSummeUmwandlung';
    ed_LeistSummeUmwandlung.WidthStyle := ssAuto;
    ed_LeistSummeUmwandlung.WidthPercent := 100.00000000000000000;
    ed_LeistKatWahlLeist1ErwAbbau.SetParentComponent(pnLeistungsKategorie);
    ed_LeistKatWahlLeist1ErwAbbau.Name := 'ed_LeistKatWahlLeist1ErwAbbau';
    ed_LeistKatWahlLeist1ErwAbbau.Left := 621;
    ed_LeistKatWahlLeist1ErwAbbau.Top := 176;
    ed_LeistKatWahlLeist1ErwAbbau.Width := 120;
    ed_LeistKatWahlLeist1ErwAbbau.Height := 22;
    ed_LeistKatWahlLeist1ErwAbbau.ChildOrder := 4;
    ed_LeistKatWahlLeist1ErwAbbau.ElementFont := efCSS;
    ed_LeistKatWahlLeist1ErwAbbau.ElementPosition := epIgnore;
    ed_LeistKatWahlLeist1ErwAbbau.HeightStyle := ssAuto;
    ed_LeistKatWahlLeist1ErwAbbau.HeightPercent := 100.00000000000000000;
    ed_LeistKatWahlLeist1ErwAbbau.Text := 'ed_LeistKatWahlLeist1AnzAltZi';
    ed_LeistKatWahlLeist1ErwAbbau.WidthStyle := ssAuto;
    ed_LeistKatWahlLeist1ErwAbbau.WidthPercent := 100.00000000000000000;
    SetEvent(ed_LeistKatWahlLeist1ErwAbbau, Self, 'OnExit', 'ed_LeistKatWahlLeist1AnzAltZiExit');
    ed_LeistKatWahlLeist2ErwAbbau.SetParentComponent(pnLeistungsKategorie);
    ed_LeistKatWahlLeist2ErwAbbau.Name := 'ed_LeistKatWahlLeist2ErwAbbau';
    ed_LeistKatWahlLeist2ErwAbbau.Left := 618;
    ed_LeistKatWahlLeist2ErwAbbau.Top := 221;
    ed_LeistKatWahlLeist2ErwAbbau.Width := 120;
    ed_LeistKatWahlLeist2ErwAbbau.Height := 22;
    ed_LeistKatWahlLeist2ErwAbbau.ChildOrder := 4;
    ed_LeistKatWahlLeist2ErwAbbau.ElementFont := efCSS;
    ed_LeistKatWahlLeist2ErwAbbau.ElementPosition := epIgnore;
    ed_LeistKatWahlLeist2ErwAbbau.HeightStyle := ssAuto;
    ed_LeistKatWahlLeist2ErwAbbau.HeightPercent := 100.00000000000000000;
    ed_LeistKatWahlLeist2ErwAbbau.Text := 'ed_LeistKatWahlLeist2ErwAbbau';
    ed_LeistKatWahlLeist2ErwAbbau.WidthStyle := ssAuto;
    ed_LeistKatWahlLeist2ErwAbbau.WidthPercent := 100.00000000000000000;
    SetEvent(ed_LeistKatWahlLeist2ErwAbbau, Self, 'OnExit', 'ed_LeistKatWahlLeist1AnzAltZiExit');
    ed_LeistKatNormalErwAbbau.SetParentComponent(pnLeistungsKategorie);
    ed_LeistKatNormalErwAbbau.Name := 'ed_LeistKatNormalErwAbbau';
    ed_LeistKatNormalErwAbbau.Left := 618;
    ed_LeistKatNormalErwAbbau.Top := 266;
    ed_LeistKatNormalErwAbbau.Width := 120;
    ed_LeistKatNormalErwAbbau.Height := 22;
    ed_LeistKatNormalErwAbbau.ChildOrder := 4;
    ed_LeistKatNormalErwAbbau.ElementFont := efCSS;
    ed_LeistKatNormalErwAbbau.ElementPosition := epIgnore;
    ed_LeistKatNormalErwAbbau.HeightStyle := ssAuto;
    ed_LeistKatNormalErwAbbau.HeightPercent := 100.00000000000000000;
    ed_LeistKatNormalErwAbbau.Text := 'ed_LeistKatNormalErwAbbau';
    ed_LeistKatNormalErwAbbau.WidthStyle := ssAuto;
    ed_LeistKatNormalErwAbbau.WidthPercent := 100.00000000000000000;
    SetEvent(ed_LeistKatNormalErwAbbau, Self, 'OnExit', 'ed_LeistKatWahlLeist1AnzAltZiExit');
    ed_LeistSummeErwAbbau.SetParentComponent(pnLeistungsKategorie);
    ed_LeistSummeErwAbbau.Name := 'ed_LeistSummeErwAbbau';
    ed_LeistSummeErwAbbau.Left := 618;
    ed_LeistSummeErwAbbau.Top := 311;
    ed_LeistSummeErwAbbau.Width := 120;
    ed_LeistSummeErwAbbau.Height := 22;
    ed_LeistSummeErwAbbau.ChildOrder := 4;
    ed_LeistSummeErwAbbau.ElementFont := efCSS;
    ed_LeistSummeErwAbbau.ElementPosition := epIgnore;
    ed_LeistSummeErwAbbau.HeightStyle := ssAuto;
    ed_LeistSummeErwAbbau.HeightPercent := 100.00000000000000000;
    ed_LeistSummeErwAbbau.ReadOnly := True;
    ed_LeistSummeErwAbbau.Text := 'ed_LeistSummeErwAbbau';
    ed_LeistSummeErwAbbau.WidthStyle := ssAuto;
    ed_LeistSummeErwAbbau.WidthPercent := 100.00000000000000000;
    ed_LeistKatWahlLeist1AnzNeuZi.SetParentComponent(pnLeistungsKategorie);
    ed_LeistKatWahlLeist1AnzNeuZi.Name := 'ed_LeistKatWahlLeist1AnzNeuZi';
    ed_LeistKatWahlLeist1AnzNeuZi.Left := 765;
    ed_LeistKatWahlLeist1AnzNeuZi.Top := 176;
    ed_LeistKatWahlLeist1AnzNeuZi.Width := 120;
    ed_LeistKatWahlLeist1AnzNeuZi.Height := 22;
    ed_LeistKatWahlLeist1AnzNeuZi.ChildOrder := 4;
    ed_LeistKatWahlLeist1AnzNeuZi.ElementFont := efCSS;
    ed_LeistKatWahlLeist1AnzNeuZi.ElementPosition := epIgnore;
    ed_LeistKatWahlLeist1AnzNeuZi.HeightStyle := ssAuto;
    ed_LeistKatWahlLeist1AnzNeuZi.HeightPercent := 100.00000000000000000;
    ed_LeistKatWahlLeist1AnzNeuZi.ReadOnly := True;
    ed_LeistKatWahlLeist1AnzNeuZi.Text := 'ed_LeistKatWahlLeist1AnzAltZi';
    ed_LeistKatWahlLeist1AnzNeuZi.WidthStyle := ssAuto;
    ed_LeistKatWahlLeist1AnzNeuZi.WidthPercent := 100.00000000000000000;
    SetEvent(ed_LeistKatWahlLeist1AnzNeuZi, Self, 'OnExit', 'ed_LeistKatWahlLeist1AnzAltZiExit');
    ed_LeistKatWahlLeist2AnzNeuZi.SetParentComponent(pnLeistungsKategorie);
    ed_LeistKatWahlLeist2AnzNeuZi.Name := 'ed_LeistKatWahlLeist2AnzNeuZi';
    ed_LeistKatWahlLeist2AnzNeuZi.Left := 762;
    ed_LeistKatWahlLeist2AnzNeuZi.Top := 221;
    ed_LeistKatWahlLeist2AnzNeuZi.Width := 120;
    ed_LeistKatWahlLeist2AnzNeuZi.Height := 22;
    ed_LeistKatWahlLeist2AnzNeuZi.ChildOrder := 4;
    ed_LeistKatWahlLeist2AnzNeuZi.ElementFont := efCSS;
    ed_LeistKatWahlLeist2AnzNeuZi.ElementPosition := epIgnore;
    ed_LeistKatWahlLeist2AnzNeuZi.HeightStyle := ssAuto;
    ed_LeistKatWahlLeist2AnzNeuZi.HeightPercent := 100.00000000000000000;
    ed_LeistKatWahlLeist2AnzNeuZi.ReadOnly := True;
    ed_LeistKatWahlLeist2AnzNeuZi.Text := 'ed_LeistKatWahlLeist2AnzNeuZi';
    ed_LeistKatWahlLeist2AnzNeuZi.WidthStyle := ssAuto;
    ed_LeistKatWahlLeist2AnzNeuZi.WidthPercent := 100.00000000000000000;
    SetEvent(ed_LeistKatWahlLeist2AnzNeuZi, Self, 'OnExit', 'ed_LeistKatWahlLeist1AnzAltZiExit');
    ed_LeistKatNormalAnzNeuZi.SetParentComponent(pnLeistungsKategorie);
    ed_LeistKatNormalAnzNeuZi.Name := 'ed_LeistKatNormalAnzNeuZi';
    ed_LeistKatNormalAnzNeuZi.Left := 762;
    ed_LeistKatNormalAnzNeuZi.Top := 266;
    ed_LeistKatNormalAnzNeuZi.Width := 120;
    ed_LeistKatNormalAnzNeuZi.Height := 22;
    ed_LeistKatNormalAnzNeuZi.ChildOrder := 4;
    ed_LeistKatNormalAnzNeuZi.ElementFont := efCSS;
    ed_LeistKatNormalAnzNeuZi.ElementPosition := epIgnore;
    ed_LeistKatNormalAnzNeuZi.HeightStyle := ssAuto;
    ed_LeistKatNormalAnzNeuZi.HeightPercent := 100.00000000000000000;
    ed_LeistKatNormalAnzNeuZi.ReadOnly := True;
    ed_LeistKatNormalAnzNeuZi.Text := 'ed_LeistKatNormalAnzNeuZi';
    ed_LeistKatNormalAnzNeuZi.WidthStyle := ssAuto;
    ed_LeistKatNormalAnzNeuZi.WidthPercent := 100.00000000000000000;
    SetEvent(ed_LeistKatNormalAnzNeuZi, Self, 'OnExit', 'ed_LeistKatWahlLeist1AnzAltZiExit');
    ed_LeistSummeAnzNeuZi.SetParentComponent(pnLeistungsKategorie);
    ed_LeistSummeAnzNeuZi.Name := 'ed_LeistSummeAnzNeuZi';
    ed_LeistSummeAnzNeuZi.Left := 762;
    ed_LeistSummeAnzNeuZi.Top := 311;
    ed_LeistSummeAnzNeuZi.Width := 120;
    ed_LeistSummeAnzNeuZi.Height := 22;
    ed_LeistSummeAnzNeuZi.ChildOrder := 4;
    ed_LeistSummeAnzNeuZi.ElementFont := efCSS;
    ed_LeistSummeAnzNeuZi.ElementPosition := epIgnore;
    ed_LeistSummeAnzNeuZi.HeightStyle := ssAuto;
    ed_LeistSummeAnzNeuZi.HeightPercent := 100.00000000000000000;
    ed_LeistSummeAnzNeuZi.ReadOnly := True;
    ed_LeistSummeAnzNeuZi.Text := 'ed_LeistSummeAnzNeuZi';
    ed_LeistSummeAnzNeuZi.WidthStyle := ssAuto;
    ed_LeistSummeAnzNeuZi.WidthPercent := 100.00000000000000000;
    ed_LeistKatWahlLeist1AnzNeuBt.SetParentComponent(pnLeistungsKategorie);
    ed_LeistKatWahlLeist1AnzNeuBt.Name := 'ed_LeistKatWahlLeist1AnzNeuBt';
    ed_LeistKatWahlLeist1AnzNeuBt.Left := 907;
    ed_LeistKatWahlLeist1AnzNeuBt.Top := 176;
    ed_LeistKatWahlLeist1AnzNeuBt.Width := 120;
    ed_LeistKatWahlLeist1AnzNeuBt.Height := 22;
    ed_LeistKatWahlLeist1AnzNeuBt.ChildOrder := 4;
    ed_LeistKatWahlLeist1AnzNeuBt.ElementFont := efCSS;
    ed_LeistKatWahlLeist1AnzNeuBt.ElementPosition := epIgnore;
    ed_LeistKatWahlLeist1AnzNeuBt.HeightStyle := ssAuto;
    ed_LeistKatWahlLeist1AnzNeuBt.HeightPercent := 100.00000000000000000;
    ed_LeistKatWahlLeist1AnzNeuBt.ReadOnly := True;
    ed_LeistKatWahlLeist1AnzNeuBt.Text := 'ed_LeistKatWahlLeist1AnzNeuBt';
    ed_LeistKatWahlLeist1AnzNeuBt.WidthStyle := ssAuto;
    ed_LeistKatWahlLeist1AnzNeuBt.WidthPercent := 100.00000000000000000;
    SetEvent(ed_LeistKatWahlLeist1AnzNeuBt, Self, 'OnExit', 'ed_LeistKatWahlLeist1AnzAltZiExit');
    ed_LeistKatWahlLeist2AnzNeuBt.SetParentComponent(pnLeistungsKategorie);
    ed_LeistKatWahlLeist2AnzNeuBt.Name := 'ed_LeistKatWahlLeist2AnzNeuBt';
    ed_LeistKatWahlLeist2AnzNeuBt.Left := 904;
    ed_LeistKatWahlLeist2AnzNeuBt.Top := 215;
    ed_LeistKatWahlLeist2AnzNeuBt.Width := 120;
    ed_LeistKatWahlLeist2AnzNeuBt.Height := 22;
    ed_LeistKatWahlLeist2AnzNeuBt.ChildOrder := 4;
    ed_LeistKatWahlLeist2AnzNeuBt.ElementFont := efCSS;
    ed_LeistKatWahlLeist2AnzNeuBt.ElementPosition := epIgnore;
    ed_LeistKatWahlLeist2AnzNeuBt.HeightStyle := ssAuto;
    ed_LeistKatWahlLeist2AnzNeuBt.HeightPercent := 100.00000000000000000;
    ed_LeistKatWahlLeist2AnzNeuBt.ReadOnly := True;
    ed_LeistKatWahlLeist2AnzNeuBt.Text := 'ed_LeistKatWahlLeist2AnzNeuBt';
    ed_LeistKatWahlLeist2AnzNeuBt.WidthStyle := ssAuto;
    ed_LeistKatWahlLeist2AnzNeuBt.WidthPercent := 100.00000000000000000;
    SetEvent(ed_LeistKatWahlLeist2AnzNeuBt, Self, 'OnExit', 'ed_LeistKatWahlLeist1AnzAltZiExit');
    ed_LeistKatNormalAnzNeuBt.SetParentComponent(pnLeistungsKategorie);
    ed_LeistKatNormalAnzNeuBt.Name := 'ed_LeistKatNormalAnzNeuBt';
    ed_LeistKatNormalAnzNeuBt.Left := 904;
    ed_LeistKatNormalAnzNeuBt.Top := 266;
    ed_LeistKatNormalAnzNeuBt.Width := 120;
    ed_LeistKatNormalAnzNeuBt.Height := 22;
    ed_LeistKatNormalAnzNeuBt.ChildOrder := 4;
    ed_LeistKatNormalAnzNeuBt.ElementFont := efCSS;
    ed_LeistKatNormalAnzNeuBt.ElementPosition := epIgnore;
    ed_LeistKatNormalAnzNeuBt.HeightStyle := ssAuto;
    ed_LeistKatNormalAnzNeuBt.HeightPercent := 100.00000000000000000;
    ed_LeistKatNormalAnzNeuBt.ReadOnly := True;
    ed_LeistKatNormalAnzNeuBt.Text := 'ed_LeistKatNormalAnzNeuBt';
    ed_LeistKatNormalAnzNeuBt.WidthStyle := ssAuto;
    ed_LeistKatNormalAnzNeuBt.WidthPercent := 100.00000000000000000;
    SetEvent(ed_LeistKatNormalAnzNeuBt, Self, 'OnExit', 'ed_LeistKatWahlLeist1AnzAltZiExit');
    ed_LeistSummeAnzNeuBt.SetParentComponent(pnLeistungsKategorie);
    ed_LeistSummeAnzNeuBt.Name := 'ed_LeistSummeAnzNeuBt';
    ed_LeistSummeAnzNeuBt.Left := 904;
    ed_LeistSummeAnzNeuBt.Top := 311;
    ed_LeistSummeAnzNeuBt.Width := 120;
    ed_LeistSummeAnzNeuBt.Height := 22;
    ed_LeistSummeAnzNeuBt.ChildOrder := 4;
    ed_LeistSummeAnzNeuBt.ElementFont := efCSS;
    ed_LeistSummeAnzNeuBt.ElementPosition := epIgnore;
    ed_LeistSummeAnzNeuBt.HeightStyle := ssAuto;
    ed_LeistSummeAnzNeuBt.HeightPercent := 100.00000000000000000;
    ed_LeistSummeAnzNeuBt.ReadOnly := True;
    ed_LeistSummeAnzNeuBt.Text := 'ed_LeistSummeAnzNeuBt';
    ed_LeistSummeAnzNeuBt.WidthStyle := ssAuto;
    ed_LeistSummeAnzNeuBt.WidthPercent := 100.00000000000000000;
    ed_LeistKatWahlLeist1Zuschlag.SetParentComponent(pnLeistungsKategorie);
    ed_LeistKatWahlLeist1Zuschlag.Name := 'ed_LeistKatWahlLeist1Zuschlag';
    ed_LeistKatWahlLeist1Zuschlag.Left := 1045;
    ed_LeistKatWahlLeist1Zuschlag.Top := 179;
    ed_LeistKatWahlLeist1Zuschlag.Width := 120;
    ed_LeistKatWahlLeist1Zuschlag.Height := 22;
    ed_LeistKatWahlLeist1Zuschlag.ChildOrder := 4;
    ed_LeistKatWahlLeist1Zuschlag.ElementFont := efCSS;
    ed_LeistKatWahlLeist1Zuschlag.ElementPosition := epIgnore;
    ed_LeistKatWahlLeist1Zuschlag.HeightStyle := ssAuto;
    ed_LeistKatWahlLeist1Zuschlag.HeightPercent := 100.00000000000000000;
    ed_LeistKatWahlLeist1Zuschlag.Text := 'ed_LeistKatWahlLeist1Zuschlag';
    ed_LeistKatWahlLeist1Zuschlag.WidthStyle := ssAuto;
    ed_LeistKatWahlLeist1Zuschlag.WidthPercent := 100.00000000000000000;
    ed_LeistKatWahlLeist2Zuschlag.SetParentComponent(pnLeistungsKategorie);
    ed_LeistKatWahlLeist2Zuschlag.Name := 'ed_LeistKatWahlLeist2Zuschlag';
    ed_LeistKatWahlLeist2Zuschlag.Left := 1042;
    ed_LeistKatWahlLeist2Zuschlag.Top := 224;
    ed_LeistKatWahlLeist2Zuschlag.Width := 120;
    ed_LeistKatWahlLeist2Zuschlag.Height := 22;
    ed_LeistKatWahlLeist2Zuschlag.ChildOrder := 4;
    ed_LeistKatWahlLeist2Zuschlag.ElementFont := efCSS;
    ed_LeistKatWahlLeist2Zuschlag.ElementPosition := epIgnore;
    ed_LeistKatWahlLeist2Zuschlag.HeightStyle := ssAuto;
    ed_LeistKatWahlLeist2Zuschlag.HeightPercent := 100.00000000000000000;
    ed_LeistKatWahlLeist2Zuschlag.Text := 'ed_LeistKatWahlLeist2Zuschlag';
    ed_LeistKatWahlLeist2Zuschlag.WidthStyle := ssAuto;
    ed_LeistKatWahlLeist2Zuschlag.WidthPercent := 100.00000000000000000;
    ed_LeistKatNormalZuschlag.SetParentComponent(pnLeistungsKategorie);
    ed_LeistKatNormalZuschlag.Name := 'ed_LeistKatNormalZuschlag';
    ed_LeistKatNormalZuschlag.Left := 1042;
    ed_LeistKatNormalZuschlag.Top := 269;
    ed_LeistKatNormalZuschlag.Width := 120;
    ed_LeistKatNormalZuschlag.Height := 22;
    ed_LeistKatNormalZuschlag.ChildOrder := 4;
    ed_LeistKatNormalZuschlag.ElementFont := efCSS;
    ed_LeistKatNormalZuschlag.ElementPosition := epIgnore;
    ed_LeistKatNormalZuschlag.HeightStyle := ssAuto;
    ed_LeistKatNormalZuschlag.HeightPercent := 100.00000000000000000;
    ed_LeistKatNormalZuschlag.Text := 'ed_LeistKatNormalZuschlag';
    ed_LeistKatNormalZuschlag.WidthStyle := ssAuto;
    ed_LeistKatNormalZuschlag.WidthPercent := 100.00000000000000000;
    pnPersonal.SetParentComponent(pgcSheetStationenPersonal);
    pnPersonal.Name := 'pnPersonal';
    pnPersonal.Left := 0;
    pnPersonal.Top := 417;
    pnPersonal.Width := 1600;
    pnPersonal.Height := 730;
    pnPersonal.HeightStyle := ssAuto;
    pnPersonal.WidthStyle := ssAuto;
    pnPersonal.Align := alClient;
    pnPersonal.Caption := 'pnPersonal';
    pnPersonal.ChildOrder := 2;
    pnPersonal.ElementFont := efCSS;
    pnPersonal.ElementPosition := epRelative;
    pnPersonal.ShowCaption := False;
    pnPersonal.TabOrder := 1;
    WebLabel19.SetParentComponent(pnPersonal);
    WebLabel19.Name := 'WebLabel19';
    WebLabel19.Left := 42;
    WebLabel19.Top := 47;
    WebLabel19.Width := 136;
    WebLabel19.Height := 18;
    WebLabel19.Caption := 'Personalma'#223'nahmen';
    WebLabel19.ElementFont := efCSS;
    WebLabel19.ElementPosition := epRelative;
    WebLabel19.HeightStyle := ssAuto;
    WebLabel19.HeightPercent := 100.00000000000000000;
    WebLabel19.HTMLType := tH3;
    WebLabel19.WidthPercent := 100.00000000000000000;
    lb_MassHead.SetParentComponent(pnPersonal);
    lb_MassHead.Name := 'lb_MassHead';
    lb_MassHead.Left := 201;
    lb_MassHead.Top := 137;
    lb_MassHead.Width := 86;
    lb_MassHead.Height := 18;
    lb_MassHead.Caption := 'lb_MassHead';
    lb_MassHead.HeightPercent := 100.00000000000000000;
    lb_MassHead.WidthPercent := 100.00000000000000000;
    lb_MassArztHead.SetParentComponent(pnPersonal);
    lb_MassArztHead.Name := 'lb_MassArztHead';
    lb_MassArztHead.Left := 453;
    lb_MassArztHead.Top := 138;
    lb_MassArztHead.Width := 112;
    lb_MassArztHead.Height := 18;
    lb_MassArztHead.Caption := 'lb_MassArztHead';
    lb_MassArztHead.HeightPercent := 100.00000000000000000;
    lb_MassArztHead.WidthPercent := 100.00000000000000000;
    lb_MassPflegeHead.SetParentComponent(pnPersonal);
    lb_MassPflegeHead.Name := 'lb_MassPflegeHead';
    lb_MassPflegeHead.Left := 619;
    lb_MassPflegeHead.Top := 138;
    lb_MassPflegeHead.Width := 125;
    lb_MassPflegeHead.Height := 18;
    lb_MassPflegeHead.Caption := 'lb_MassPflegeHead';
    lb_MassPflegeHead.HeightPercent := 100.00000000000000000;
    lb_MassPflegeHead.WidthPercent := 100.00000000000000000;
    lb_PersMassEinstellung.SetParentComponent(pnPersonal);
    lb_PersMassEinstellung.Name := 'lb_PersMassEinstellung';
    lb_PersMassEinstellung.Left := 26;
    lb_PersMassEinstellung.Top := 187;
    lb_PersMassEinstellung.Width := 146;
    lb_PersMassEinstellung.Height := 18;
    lb_PersMassEinstellung.Caption := 'lb_PersMassEinstellung';
    lb_PersMassEinstellung.HeightPercent := 100.00000000000000000;
    lb_PersMassEinstellung.WidthPercent := 100.00000000000000000;
    lb_PersMassEntlassung.SetParentComponent(pnPersonal);
    lb_PersMassEntlassung.Name := 'lb_PersMassEntlassung';
    lb_PersMassEntlassung.Left := 23;
    lb_PersMassEntlassung.Top := 232;
    lb_PersMassEntlassung.Width := 149;
    lb_PersMassEntlassung.Height := 18;
    lb_PersMassEntlassung.Caption := 'lb_PersMassEntlassung';
    lb_PersMassEntlassung.HeightPercent := 100.00000000000000000;
    lb_PersMassEntlassung.WidthPercent := 100.00000000000000000;
    lb_PersMassTraining.SetParentComponent(pnPersonal);
    lb_PersMassTraining.Name := 'lb_PersMassTraining';
    lb_PersMassTraining.Left := 23;
    lb_PersMassTraining.Top := 277;
    lb_PersMassTraining.Width := 131;
    lb_PersMassTraining.Height := 18;
    lb_PersMassTraining.Caption := 'lb_PersMassTraining';
    lb_PersMassTraining.HeightPercent := 100.00000000000000000;
    lb_PersMassTraining.WidthPercent := 100.00000000000000000;
    lb_PersMassNebenkosten.SetParentComponent(pnPersonal);
    lb_PersMassNebenkosten.Name := 'lb_PersMassNebenkosten';
    lb_PersMassNebenkosten.Left := 26;
    lb_PersMassNebenkosten.Top := 322;
    lb_PersMassNebenkosten.Width := 165;
    lb_PersMassNebenkosten.Height := 18;
    lb_PersMassNebenkosten.Caption := 'lb_PersMassNebenkosten';
    lb_PersMassNebenkosten.HeightPercent := 100.00000000000000000;
    lb_PersMassNebenkosten.WidthPercent := 100.00000000000000000;
    lb_PersMassEinstellungEinh.SetParentComponent(pnPersonal);
    lb_PersMassEinstellungEinh.Name := 'lb_PersMassEinstellungEinh';
    lb_PersMassEinstellungEinh.Left := 216;
    lb_PersMassEinstellungEinh.Top := 187;
    lb_PersMassEinstellungEinh.Width := 172;
    lb_PersMassEinstellungEinh.Height := 18;
    lb_PersMassEinstellungEinh.Caption := 'lb_PersMassEinstellungEinh';
    lb_PersMassEinstellungEinh.HeightPercent := 100.00000000000000000;
    lb_PersMassEinstellungEinh.WidthPercent := 100.00000000000000000;
    lb_PersMassEntlassungEinh.SetParentComponent(pnPersonal);
    lb_PersMassEntlassungEinh.Name := 'lb_PersMassEntlassungEinh';
    lb_PersMassEntlassungEinh.Left := 213;
    lb_PersMassEntlassungEinh.Top := 232;
    lb_PersMassEntlassungEinh.Width := 175;
    lb_PersMassEntlassungEinh.Height := 18;
    lb_PersMassEntlassungEinh.Caption := 'lb_PersMassEntlassungEinh';
    lb_PersMassEntlassungEinh.HeightPercent := 100.00000000000000000;
    lb_PersMassEntlassungEinh.WidthPercent := 100.00000000000000000;
    lb_PersMassTrainingEinh.SetParentComponent(pnPersonal);
    lb_PersMassTrainingEinh.Name := 'lb_PersMassTrainingEinh';
    lb_PersMassTrainingEinh.Left := 213;
    lb_PersMassTrainingEinh.Top := 277;
    lb_PersMassTrainingEinh.Width := 157;
    lb_PersMassTrainingEinh.Height := 18;
    lb_PersMassTrainingEinh.Caption := 'lb_PersMassTrainingEinh';
    lb_PersMassTrainingEinh.HeightPercent := 100.00000000000000000;
    lb_PersMassTrainingEinh.WidthPercent := 100.00000000000000000;
    lb_PersMassNebenkostenEinh.SetParentComponent(pnPersonal);
    lb_PersMassNebenkostenEinh.Name := 'lb_PersMassNebenkostenEinh';
    lb_PersMassNebenkostenEinh.Left := 216;
    lb_PersMassNebenkostenEinh.Top := 322;
    lb_PersMassNebenkostenEinh.Width := 191;
    lb_PersMassNebenkostenEinh.Height := 18;
    lb_PersMassNebenkostenEinh.Caption := 'lb_PersMassNebenkostenEinh';
    lb_PersMassNebenkostenEinh.HeightPercent := 100.00000000000000000;
    lb_PersMassNebenkostenEinh.WidthPercent := 100.00000000000000000;
    lb_PersMassNebenkostenInstitut.SetParentComponent(pnPersonal);
    lb_PersMassNebenkostenInstitut.Name := 'lb_PersMassNebenkostenInstitut';
    lb_PersMassNebenkostenInstitut.Left := 24;
    lb_PersMassNebenkostenInstitut.Top := 410;
    lb_PersMassNebenkostenInstitut.Width := 211;
    lb_PersMassNebenkostenInstitut.Height := 18;
    lb_PersMassNebenkostenInstitut.Caption := 'lb_PersMassNebenkostenInstitut';
    lb_PersMassNebenkostenInstitut.HeightPercent := 100.00000000000000000;
    lb_PersMassNebenkostenInstitut.WidthPercent := 100.00000000000000000;
    ed_PersMassEinstellungenArzt.SetParentComponent(pnPersonal);
    ed_PersMassEinstellungenArzt.Name := 'ed_PersMassEinstellungenArzt';
    ed_PersMassEinstellungenArzt.Left := 453;
    ed_PersMassEinstellungenArzt.Top := 184;
    ed_PersMassEinstellungenArzt.Width := 120;
    ed_PersMassEinstellungenArzt.Height := 22;
    ed_PersMassEinstellungenArzt.ChildOrder := 4;
    ed_PersMassEinstellungenArzt.ElementFont := efCSS;
    ed_PersMassEinstellungenArzt.ElementPosition := epIgnore;
    ed_PersMassEinstellungenArzt.HeightStyle := ssAuto;
    ed_PersMassEinstellungenArzt.HeightPercent := 100.00000000000000000;
    ed_PersMassEinstellungenArzt.Text := 'ed_PersMassEinstellungenArzt';
    ed_PersMassEinstellungenArzt.WidthStyle := ssAuto;
    ed_PersMassEinstellungenArzt.WidthPercent := 100.00000000000000000;
    ed_PersMassEntlassungArzt.SetParentComponent(pnPersonal);
    ed_PersMassEntlassungArzt.Name := 'ed_PersMassEntlassungArzt';
    ed_PersMassEntlassungArzt.Left := 450;
    ed_PersMassEntlassungArzt.Top := 222;
    ed_PersMassEntlassungArzt.Width := 120;
    ed_PersMassEntlassungArzt.Height := 22;
    ed_PersMassEntlassungArzt.ChildOrder := 4;
    ed_PersMassEntlassungArzt.ElementFont := efCSS;
    ed_PersMassEntlassungArzt.ElementPosition := epIgnore;
    ed_PersMassEntlassungArzt.HeightStyle := ssAuto;
    ed_PersMassEntlassungArzt.HeightPercent := 100.00000000000000000;
    ed_PersMassEntlassungArzt.Text := 'ed_PersMassEntlassungArzt';
    ed_PersMassEntlassungArzt.WidthStyle := ssAuto;
    ed_PersMassEntlassungArzt.WidthPercent := 100.00000000000000000;
    ed_PersMassTrainingArzt.SetParentComponent(pnPersonal);
    ed_PersMassTrainingArzt.Name := 'ed_PersMassTrainingArzt';
    ed_PersMassTrainingArzt.Left := 450;
    ed_PersMassTrainingArzt.Top := 274;
    ed_PersMassTrainingArzt.Width := 120;
    ed_PersMassTrainingArzt.Height := 22;
    ed_PersMassTrainingArzt.ChildOrder := 4;
    ed_PersMassTrainingArzt.ElementFont := efCSS;
    ed_PersMassTrainingArzt.ElementPosition := epIgnore;
    ed_PersMassTrainingArzt.HeightStyle := ssAuto;
    ed_PersMassTrainingArzt.HeightPercent := 100.00000000000000000;
    ed_PersMassTrainingArzt.Text := 'ed_PersMassTrainingArzt';
    ed_PersMassTrainingArzt.WidthStyle := ssAuto;
    ed_PersMassTrainingArzt.WidthPercent := 100.00000000000000000;
    ed_PersMassNebenkostenArzt.SetParentComponent(pnPersonal);
    ed_PersMassNebenkostenArzt.Name := 'ed_PersMassNebenkostenArzt';
    ed_PersMassNebenkostenArzt.Left := 450;
    ed_PersMassNebenkostenArzt.Top := 319;
    ed_PersMassNebenkostenArzt.Width := 120;
    ed_PersMassNebenkostenArzt.Height := 22;
    ed_PersMassNebenkostenArzt.ChildOrder := 4;
    ed_PersMassNebenkostenArzt.ElementFont := efCSS;
    ed_PersMassNebenkostenArzt.ElementPosition := epIgnore;
    ed_PersMassNebenkostenArzt.HeightStyle := ssAuto;
    ed_PersMassNebenkostenArzt.HeightPercent := 100.00000000000000000;
    ed_PersMassNebenkostenArzt.Text := 'ed_PersMassNebenkostenArzt';
    ed_PersMassNebenkostenArzt.WidthStyle := ssAuto;
    ed_PersMassNebenkostenArzt.WidthPercent := 100.00000000000000000;
    ed_PersMassEinstellungenPflege.SetParentComponent(pnPersonal);
    ed_PersMassEinstellungenPflege.Name := 'ed_PersMassEinstellungenPflege';
    ed_PersMassEinstellungenPflege.Left := 605;
    ed_PersMassEinstellungenPflege.Top := 184;
    ed_PersMassEinstellungenPflege.Width := 120;
    ed_PersMassEinstellungenPflege.Height := 22;
    ed_PersMassEinstellungenPflege.ChildOrder := 4;
    ed_PersMassEinstellungenPflege.ElementFont := efCSS;
    ed_PersMassEinstellungenPflege.ElementPosition := epIgnore;
    ed_PersMassEinstellungenPflege.HeightStyle := ssAuto;
    ed_PersMassEinstellungenPflege.HeightPercent := 100.00000000000000000;
    ed_PersMassEinstellungenPflege.Text := 'ed_PersMassEinstellungenPflege';
    ed_PersMassEinstellungenPflege.WidthStyle := ssAuto;
    ed_PersMassEinstellungenPflege.WidthPercent := 100.00000000000000000;
    ed_PersMassEntlassungPflege.SetParentComponent(pnPersonal);
    ed_PersMassEntlassungPflege.Name := 'ed_PersMassEntlassungPflege';
    ed_PersMassEntlassungPflege.Left := 602;
    ed_PersMassEntlassungPflege.Top := 229;
    ed_PersMassEntlassungPflege.Width := 120;
    ed_PersMassEntlassungPflege.Height := 22;
    ed_PersMassEntlassungPflege.ChildOrder := 4;
    ed_PersMassEntlassungPflege.ElementFont := efCSS;
    ed_PersMassEntlassungPflege.ElementPosition := epIgnore;
    ed_PersMassEntlassungPflege.HeightStyle := ssAuto;
    ed_PersMassEntlassungPflege.HeightPercent := 100.00000000000000000;
    ed_PersMassEntlassungPflege.Text := 'ed_PersMassEntlassungPflege';
    ed_PersMassEntlassungPflege.WidthStyle := ssAuto;
    ed_PersMassEntlassungPflege.WidthPercent := 100.00000000000000000;
    ed_PersMassTrainingPflege.SetParentComponent(pnPersonal);
    ed_PersMassTrainingPflege.Name := 'ed_PersMassTrainingPflege';
    ed_PersMassTrainingPflege.Left := 602;
    ed_PersMassTrainingPflege.Top := 274;
    ed_PersMassTrainingPflege.Width := 120;
    ed_PersMassTrainingPflege.Height := 22;
    ed_PersMassTrainingPflege.ChildOrder := 4;
    ed_PersMassTrainingPflege.ElementFont := efCSS;
    ed_PersMassTrainingPflege.ElementPosition := epIgnore;
    ed_PersMassTrainingPflege.HeightStyle := ssAuto;
    ed_PersMassTrainingPflege.HeightPercent := 100.00000000000000000;
    ed_PersMassTrainingPflege.Text := 'ed_PersMassTrainingPflege';
    ed_PersMassTrainingPflege.WidthStyle := ssAuto;
    ed_PersMassTrainingPflege.WidthPercent := 100.00000000000000000;
    ed_PersMassNebenkostenPflege.SetParentComponent(pnPersonal);
    ed_PersMassNebenkostenPflege.Name := 'ed_PersMassNebenkostenPflege';
    ed_PersMassNebenkostenPflege.Left := 602;
    ed_PersMassNebenkostenPflege.Top := 319;
    ed_PersMassNebenkostenPflege.Width := 120;
    ed_PersMassNebenkostenPflege.Height := 22;
    ed_PersMassNebenkostenPflege.ChildOrder := 4;
    ed_PersMassNebenkostenPflege.ElementFont := efCSS;
    ed_PersMassNebenkostenPflege.ElementPosition := epIgnore;
    ed_PersMassNebenkostenPflege.HeightStyle := ssAuto;
    ed_PersMassNebenkostenPflege.HeightPercent := 100.00000000000000000;
    ed_PersMassNebenkostenPflege.Text := 'ed_PersMassNebenkostenPflege';
    ed_PersMassNebenkostenPflege.WidthStyle := ssAuto;
    ed_PersMassNebenkostenPflege.WidthPercent := 100.00000000000000000;
    ed_PersMassNebenkostenInstitut.SetParentComponent(pnPersonal);
    ed_PersMassNebenkostenInstitut.Name := 'ed_PersMassNebenkostenInstitut';
    ed_PersMassNebenkostenInstitut.Left := 378;
    ed_PersMassNebenkostenInstitut.Top := 407;
    ed_PersMassNebenkostenInstitut.Width := 120;
    ed_PersMassNebenkostenInstitut.Height := 22;
    ed_PersMassNebenkostenInstitut.ChildOrder := 4;
    ed_PersMassNebenkostenInstitut.ElementFont := efCSS;
    ed_PersMassNebenkostenInstitut.ElementPosition := epIgnore;
    ed_PersMassNebenkostenInstitut.HeightStyle := ssAuto;
    ed_PersMassNebenkostenInstitut.HeightPercent := 100.00000000000000000;
    ed_PersMassNebenkostenInstitut.Text := 'ed_PersMassNebenkostenInstitut';
    ed_PersMassNebenkostenInstitut.WidthStyle := ssAuto;
    ed_PersMassNebenkostenInstitut.WidthPercent := 100.00000000000000000;
    pnVersetzungMitarbeiter.SetParentComponent(pgcSheetStationenPersonal);
    pnVersetzungMitarbeiter.Name := 'pnVersetzungMitarbeiter';
    pnVersetzungMitarbeiter.Left := 765;
    pnVersetzungMitarbeiter.Top := 467;
    pnVersetzungMitarbeiter.Width := 757;
    pnVersetzungMitarbeiter.Height := 501;
    pnVersetzungMitarbeiter.HeightStyle := ssAuto;
    pnVersetzungMitarbeiter.WidthStyle := ssAuto;
    pnVersetzungMitarbeiter.ChildOrder := 1;
    pnVersetzungMitarbeiter.ElementFont := efCSS;
    pnVersetzungMitarbeiter.ElementPosition := epIgnore;
    pnVersetzungMitarbeiter.TabOrder := 2;
    La3_Abt2.SetParentComponent(pnVersetzungMitarbeiter);
    La3_Abt2.Name := 'La3_Abt2';
    La3_Abt2.Left := 141;
    La3_Abt2.Top := 271;
    La3_Abt2.Width := 114;
    La3_Abt2.Height := 29;
    La3_Abt2.Caption := 'Abteilung';
    La3_Abt2.ElementFont := efCSS;
    La3_Abt2.ElementPosition := epRelative;
    La3_Abt2.Font.Charset := DEFAULT_CHARSET;
    La3_Abt2.Font.Color := clWindowText;
    La3_Abt2.Font.Height := -24;
    La3_Abt2.Font.Name := 'Tahoma';
    La3_Abt2.Font.Style := [fsBold];
    La3_Abt2.HeightStyle := ssAuto;
    La3_Abt2.HeightPercent := 100.00000000000000000;
    La3_Abt2.ParentFont := False;
    La3_Abt2.WidthPercent := 100.00000000000000000;
    La3_Abt3.SetParentComponent(pnVersetzungMitarbeiter);
    La3_Abt3.Name := 'La3_Abt3';
    La3_Abt3.Left := 142;
    La3_Abt3.Top := 343;
    La3_Abt3.Width := 114;
    La3_Abt3.Height := 29;
    La3_Abt3.Caption := 'Abteilung';
    La3_Abt3.ElementFont := efCSS;
    La3_Abt3.ElementPosition := epRelative;
    La3_Abt3.Font.Charset := DEFAULT_CHARSET;
    La3_Abt3.Font.Color := clWindowText;
    La3_Abt3.Font.Height := -24;
    La3_Abt3.Font.Name := 'Tahoma';
    La3_Abt3.Font.Style := [fsBold];
    La3_Abt3.HeightStyle := ssAuto;
    La3_Abt3.HeightPercent := 100.00000000000000000;
    La3_Abt3.ParentFont := False;
    La3_Abt3.WidthPercent := 100.00000000000000000;
    WebLabel20.SetParentComponent(pnVersetzungMitarbeiter);
    WebLabel20.Name := 'WebLabel20';
    WebLabel20.Left := 40;
    WebLabel20.Top := 31;
    WebLabel20.Width := 457;
    WebLabel20.Height := 29;
    WebLabel20.Caption := 'Versetzung Pflegedienstmitarbeitende';
    WebLabel20.ElementFont := efCSS;
    WebLabel20.ElementPosition := epRelative;
    WebLabel20.Font.Charset := DEFAULT_CHARSET;
    WebLabel20.Font.Color := clWindowText;
    WebLabel20.Font.Height := -24;
    WebLabel20.Font.Name := 'Tahoma';
    WebLabel20.Font.Style := [fsBold];
    WebLabel20.HeightStyle := ssAuto;
    WebLabel20.HeightPercent := 100.00000000000000000;
    WebLabel20.HTMLType := tH3;
    WebLabel20.ParentFont := False;
    WebLabel20.WidthPercent := 100.00000000000000000;
    LF3_NachA1.SetParentComponent(pnVersetzungMitarbeiter);
    LF3_NachA1.Name := 'LF3_NachA1';
    LF3_NachA1.Left := 312;
    LF3_NachA1.Top := 225;
    LF3_NachA1.Width := 150;
    LF3_NachA1.Height := 35;
    LF3_NachA1.ChildOrder := 11;
    LF3_NachA1.EditType := weNumeric;
    LF3_NachA1.ElementClassName := 'input input-bordered w-full';
    LF3_NachA1.ElementFont := efCSS;
    LF3_NachA1.ElementPosition := epRelative;
    LF3_NachA1.HeightStyle := ssAuto;
    LF3_NachA1.HeightPercent := 100.00000000000000000;
    LF3_NachA1.Text := 'LF3_NachA1';
    LF3_NachA1.WidthStyle := ssAuto;
    LF3_NachA1.WidthPercent := 100.00000000000000000;
    LF3_NachA1.DataField := 'Hpcc_Transfer_Care_Amount1';
    LF3_NachA1.DataSource := PerfCatWebDataSource;
    LF3_NachA2.SetParentComponent(pnVersetzungMitarbeiter);
    LF3_NachA2.Name := 'LF3_NachA2';
    LF3_NachA2.Left := 312;
    LF3_NachA2.Top := 275;
    LF3_NachA2.Width := 150;
    LF3_NachA2.Height := 35;
    LF3_NachA2.ChildOrder := 11;
    LF3_NachA2.EditType := weNumeric;
    LF3_NachA2.ElementClassName := 'input input-bordered w-full';
    LF3_NachA2.ElementFont := efCSS;
    LF3_NachA2.ElementPosition := epRelative;
    LF3_NachA2.HeightStyle := ssAuto;
    LF3_NachA2.HeightPercent := 100.00000000000000000;
    LF3_NachA2.Text := 'LF3_NachA2';
    LF3_NachA2.WidthStyle := ssAuto;
    LF3_NachA2.WidthPercent := 100.00000000000000000;
    LF3_NachA2.DataField := 'Hpcc_Transfer_Care_Amount2';
    LF3_NachA2.DataSource := PerfCatWebDataSource;
    RFE_AbteilungName.SetParentComponent(pnVersetzungMitarbeiter);
    RFE_AbteilungName.Name := 'RFE_AbteilungName';
    RFE_AbteilungName.Left := 398;
    RFE_AbteilungName.Top := 120;
    RFE_AbteilungName.Width := 193;
    RFE_AbteilungName.Height := 35;
    RFE_AbteilungName.ChildOrder := 11;
    RFE_AbteilungName.EditType := weSignedNumeric;
    RFE_AbteilungName.ElementClassName := 'input input-bordered w-full';
    RFE_AbteilungName.ElementFont := efCSS;
    RFE_AbteilungName.ElementPosition := epRelative;
    RFE_AbteilungName.HeightStyle := ssAuto;
    RFE_AbteilungName.HeightPercent := 100.00000000000000000;
    RFE_AbteilungName.Text := 'RFE_AbteilungName';
    RFE_AbteilungName.WidthStyle := ssAuto;
    RFE_AbteilungName.WidthPercent := 100.00000000000000000;
    pgcSheetFinanzen.SetParentComponent(pgcEntscheidungen);
    pgcSheetFinanzen.Name := 'pgcSheetFinanzen';
    pgcSheetFinanzen.Left := 0;
    pgcSheetFinanzen.Top := 20;
    pgcSheetFinanzen.Width := 1600;
    pgcSheetFinanzen.Height := 1147;
    pgcSheetFinanzen.HeightStyle := ssAuto;
    pgcSheetFinanzen.WidthStyle := ssAuto;
    pgcSheetFinanzen.Caption := 'Finanzen / Generell';
    pgcSheetFinanzen.ChildOrder := 2;
    pgcSheetFinanzen.ElementFont := efCSS;
    pgcSheetFinanzen.ElementPosition := epRelative;
    WebLabel4.SetParentComponent(pgcSheetFinanzen);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 136;
    WebLabel4.Top := 16;
    WebLabel4.Width := 157;
    WebLabel4.Height := 18;
    WebLabel4.Caption := 'Planung der Finanzmittel';
    WebLabel4.ElementClassName := 'font-bold text-4xl';
    WebLabel4.ElementFont := efCSS;
    WebLabel4.ElementPosition := epRelative;
    WebLabel4.HeightStyle := ssAuto;
    WebLabel4.HeightPercent := 100.00000000000000000;
    WebLabel4.HTMLType := tH2;
    WebLabel4.WidthStyle := ssAuto;
    WebLabel4.WidthPercent := 100.00000000000000000;
    WebLabel7.SetParentComponent(pgcSheetFinanzen);
    WebLabel7.Name := 'WebLabel7';
    WebLabel7.Left := 144;
    WebLabel7.Top := 24;
    WebLabel7.Width := 165;
    WebLabel7.Height := 18;
    WebLabel7.Caption := 'Generelle Entscheidungen';
    WebLabel7.ElementClassName := 'font-bold text-4xl';
    WebLabel7.ElementFont := efCSS;
    WebLabel7.ElementPosition := epRelative;
    WebLabel7.HeightStyle := ssAuto;
    WebLabel7.HeightPercent := 100.00000000000000000;
    WebLabel7.HTMLType := tH2;
    WebLabel7.WidthStyle := ssAuto;
    WebLabel7.WidthPercent := 100.00000000000000000;
    pnFinanzen.SetParentComponent(pgcSheetFinanzen);
    pnFinanzen.Name := 'pnFinanzen';
    pnFinanzen.Left := 0;
    pnFinanzen.Top := 0;
    pnFinanzen.Width := 654;
    pnFinanzen.Height := 1147;
    pnFinanzen.ElementClassName := 'card bg-base-100 shadow-xl grow basis-1/2';
    pnFinanzen.HeightStyle := ssAuto;
    pnFinanzen.WidthStyle := ssAuto;
    pnFinanzen.Align := alLeft;
    pnFinanzen.Caption := 'pnFinanzen';
    pnFinanzen.ChildOrder := 1;
    pnFinanzen.ElementBodyClassName := 'card-body';
    pnFinanzen.ElementFont := efCSS;
    pnFinanzen.ElementPosition := epRelative;
    pnFinanzen.ShowCaption := False;
    pnFinanzen.TabOrder := 0;
    lblStation1.SetParentComponent(pnFinanzen);
    lblStation1.Name := 'lblStation1';
    lblStation1.Left := 3;
    lblStation1.Top := 94;
    lblStation1.Width := 152;
    lblStation1.Height := 29;
    lblStation1.Caption := 'Kredite + / -';
    lblStation1.ElementClassName := 'card-title';
    lblStation1.ElementFont := efCSS;
    lblStation1.ElementPosition := epRelative;
    lblStation1.Font.Charset := DEFAULT_CHARSET;
    lblStation1.Font.Color := clWindowText;
    lblStation1.Font.Height := -24;
    lblStation1.Font.Name := 'Tahoma';
    lblStation1.Font.Style := [fsBold];
    lblStation1.HeightStyle := ssAuto;
    lblStation1.HeightPercent := 100.00000000000000000;
    lblStation1.HTMLType := tH3;
    lblStation1.ParentFont := False;
    lblStation1.WidthPercent := 100.00000000000000000;
    WebLabel2.SetParentComponent(pnFinanzen);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 32;
    WebLabel2.Top := 155;
    WebLabel2.Width := 216;
    WebLabel2.Height := 29;
    WebLabel2.Caption := 'kurzfristig (TEUR)';
    WebLabel2.ElementFont := efCSS;
    WebLabel2.ElementPosition := epRelative;
    WebLabel2.Font.Charset := DEFAULT_CHARSET;
    WebLabel2.Font.Color := clWindowText;
    WebLabel2.Font.Height := -24;
    WebLabel2.Font.Name := 'Tahoma';
    WebLabel2.Font.Style := [fsBold];
    WebLabel2.HeightStyle := ssAuto;
    WebLabel2.HeightPercent := 100.00000000000000000;
    WebLabel2.ParentFont := False;
    WebLabel2.WidthPercent := 100.00000000000000000;
    WebLabel3.SetParentComponent(pnFinanzen);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 32;
    WebLabel3.Top := 207;
    WebLabel3.Width := 235;
    WebLabel3.Height := 29;
    WebLabel3.Caption := 'mittelfristig (TEUR)';
    WebLabel3.ElementFont := efCSS;
    WebLabel3.ElementPosition := epRelative;
    WebLabel3.Font.Charset := DEFAULT_CHARSET;
    WebLabel3.Font.Color := clWindowText;
    WebLabel3.Font.Height := -24;
    WebLabel3.Font.Name := 'Tahoma';
    WebLabel3.Font.Style := [fsBold];
    WebLabel3.HeightStyle := ssAuto;
    WebLabel3.HeightPercent := 100.00000000000000000;
    WebLabel3.ParentFont := False;
    WebLabel3.WidthPercent := 100.00000000000000000;
    RFE_KrdKurz.SetParentComponent(pnFinanzen);
    RFE_KrdKurz.Name := 'RFE_KrdKurz';
    RFE_KrdKurz.Left := 497;
    RFE_KrdKurz.Top := 161;
    RFE_KrdKurz.Width := 150;
    RFE_KrdKurz.Height := 35;
    RFE_KrdKurz.ChildOrder := 11;
    RFE_KrdKurz.EditType := weSignedFloat;
    RFE_KrdKurz.ElementClassName := 'input input-bordered w-full';
    RFE_KrdKurz.ElementFont := efCSS;
    RFE_KrdKurz.ElementPosition := epRelative;
    RFE_KrdKurz.HeightStyle := ssAuto;
    RFE_KrdKurz.HeightPercent := 100.00000000000000000;
    RFE_KrdKurz.Text := 'RFE_KrdKurz';
    RFE_KrdKurz.WidthStyle := ssAuto;
    RFE_KrdKurz.WidthPercent := 100.00000000000000000;
    SetEvent(RFE_KrdKurz, Self, 'OnExit', 'RFE_KrdKurzExit');
    RFE_KrdKurz.DataField := 'Hbpm_Credit_Short';
    RFE_KrdKurz.DataSource := PerfMiscWebDataSource;
    RFE_KrdLang.SetParentComponent(pnFinanzen);
    RFE_KrdLang.Name := 'RFE_KrdLang';
    RFE_KrdLang.Left := 497;
    RFE_KrdLang.Top := 213;
    RFE_KrdLang.Width := 150;
    RFE_KrdLang.Height := 35;
    RFE_KrdLang.ChildOrder := 11;
    RFE_KrdLang.EditType := weSignedFloat;
    RFE_KrdLang.ElementClassName := 'input input-bordered w-full';
    RFE_KrdLang.ElementFont := efCSS;
    RFE_KrdLang.ElementPosition := epRelative;
    RFE_KrdLang.HeightStyle := ssAuto;
    RFE_KrdLang.HeightPercent := 100.00000000000000000;
    RFE_KrdLang.Text := 'RFE_KrdLang';
    RFE_KrdLang.WidthStyle := ssAuto;
    RFE_KrdLang.WidthPercent := 100.00000000000000000;
    SetEvent(RFE_KrdLang, Self, 'OnExit', 'RFE_KrdKurzExit');
    RFE_KrdLang.DataField := 'Hbpm_Credit_Medium';
    RFE_KrdLang.DataSource := PerfMiscWebDataSource;
    pnFinanzGenerell.SetParentComponent(pgcSheetFinanzen);
    pnFinanzGenerell.Name := 'pnFinanzGenerell';
    pnFinanzGenerell.Left := 654;
    pnFinanzGenerell.Top := 0;
    pnFinanzGenerell.Width := 946;
    pnFinanzGenerell.Height := 1147;
    pnFinanzGenerell.ElementClassName := 'card bg-base-100 shadow-xl grow basis-1/2';
    pnFinanzGenerell.Align := alClient;
    pnFinanzGenerell.Caption := 'pnFinanzGenerell';
    pnFinanzGenerell.ChildOrder := 1;
    pnFinanzGenerell.ElementBodyClassName := 'card-body';
    pnFinanzGenerell.ElementFont := efCSS;
    pnFinanzGenerell.ElementPosition := epRelative;
    pnFinanzGenerell.ShowCaption := False;
    pnFinanzGenerell.TabOrder := 1;
    WebLabel8.SetParentComponent(pnFinanzGenerell);
    WebLabel8.Name := 'WebLabel8';
    WebLabel8.Left := 19;
    WebLabel8.Top := 94;
    WebLabel8.Width := 381;
    WebLabel8.Height := 29;
    WebLabel8.Caption := 'Image und '#214'ffentlichkeitsarbeit';
    WebLabel8.ElementClassName := 'card-title';
    WebLabel8.ElementFont := efCSS;
    WebLabel8.ElementPosition := epRelative;
    WebLabel8.Font.Charset := DEFAULT_CHARSET;
    WebLabel8.Font.Color := clWindowText;
    WebLabel8.Font.Height := -24;
    WebLabel8.Font.Name := 'Tahoma';
    WebLabel8.Font.Style := [fsBold];
    WebLabel8.HeightStyle := ssAuto;
    WebLabel8.HeightPercent := 100.00000000000000000;
    WebLabel8.HTMLType := tH3;
    WebLabel8.ParentFont := False;
    WebLabel8.WidthPercent := 100.00000000000000000;
    La5_Abt1.SetParentComponent(pnFinanzGenerell);
    La5_Abt1.Name := 'La5_Abt1';
    La5_Abt1.Left := 443;
    La5_Abt1.Top := 155;
    La5_Abt1.Width := 136;
    La5_Abt1.Height := 29;
    La5_Abt1.Caption := 'Abteilung 1';
    La5_Abt1.ElementFont := efCSS;
    La5_Abt1.ElementPosition := epRelative;
    La5_Abt1.Font.Charset := DEFAULT_CHARSET;
    La5_Abt1.Font.Color := clWindowText;
    La5_Abt1.Font.Height := -24;
    La5_Abt1.Font.Name := 'Tahoma';
    La5_Abt1.Font.Style := [fsBold];
    La5_Abt1.HeightStyle := ssAuto;
    La5_Abt1.HeightPercent := 100.00000000000000000;
    La5_Abt1.ParentFont := False;
    La5_Abt1.WidthPercent := 100.00000000000000000;
    La5_Abt2.SetParentComponent(pnFinanzGenerell);
    La5_Abt2.Name := 'La5_Abt2';
    La5_Abt2.Left := 443;
    La5_Abt2.Top := 207;
    La5_Abt2.Width := 136;
    La5_Abt2.Height := 29;
    La5_Abt2.Caption := 'Abteilung 1';
    La5_Abt2.ElementFont := efCSS;
    La5_Abt2.ElementPosition := epRelative;
    La5_Abt2.Font.Charset := DEFAULT_CHARSET;
    La5_Abt2.Font.Color := clWindowText;
    La5_Abt2.Font.Height := -24;
    La5_Abt2.Font.Name := 'Tahoma';
    La5_Abt2.Font.Style := [fsBold];
    La5_Abt2.HeightStyle := ssAuto;
    La5_Abt2.HeightPercent := 100.00000000000000000;
    La5_Abt2.ParentFont := False;
    La5_Abt2.WidthPercent := 100.00000000000000000;
    La5_Abt3.SetParentComponent(pnFinanzGenerell);
    La5_Abt3.Name := 'La5_Abt3';
    La5_Abt3.Left := 443;
    La5_Abt3.Top := 259;
    La5_Abt3.Width := 136;
    La5_Abt3.Height := 29;
    La5_Abt3.Caption := 'Abteilung 1';
    La5_Abt3.ElementFont := efCSS;
    La5_Abt3.ElementPosition := epRelative;
    La5_Abt3.Font.Charset := DEFAULT_CHARSET;
    La5_Abt3.Font.Color := clWindowText;
    La5_Abt3.Font.Height := -24;
    La5_Abt3.Font.Name := 'Tahoma';
    La5_Abt3.Font.Style := [fsBold];
    La5_Abt3.HeightStyle := ssAuto;
    La5_Abt3.HeightPercent := 100.00000000000000000;
    La5_Abt3.ParentFont := False;
    La5_Abt3.WidthPercent := 100.00000000000000000;
    RFE_Imag1.SetParentComponent(pnFinanzGenerell);
    RFE_Imag1.Name := 'RFE_Imag1';
    RFE_Imag1.Left := 626;
    RFE_Imag1.Top := 161;
    RFE_Imag1.Width := 150;
    RFE_Imag1.Height := 35;
    RFE_Imag1.ChildOrder := 11;
    RFE_Imag1.EditType := weSignedFloat;
    RFE_Imag1.ElementClassName := 'input input-bordered w-full';
    RFE_Imag1.ElementFont := efCSS;
    RFE_Imag1.ElementPosition := epRelative;
    RFE_Imag1.HeightStyle := ssAuto;
    RFE_Imag1.HeightPercent := 100.00000000000000000;
    RFE_Imag1.Text := 'RFE_Imag1';
    RFE_Imag1.WidthStyle := ssAuto;
    RFE_Imag1.WidthPercent := 100.00000000000000000;
    SetEvent(RFE_Imag1, Self, 'OnExit', 'RFE_KrdKurzExit');
    RFE_Imag1.DataField := 'Hbpm_Image_Department1';
    RFE_Imag1.DataSource := PerfMiscWebDataSource;
    RFE_Imag2.SetParentComponent(pnFinanzGenerell);
    RFE_Imag2.Name := 'RFE_Imag2';
    RFE_Imag2.Left := 626;
    RFE_Imag2.Top := 213;
    RFE_Imag2.Width := 150;
    RFE_Imag2.Height := 35;
    RFE_Imag2.ChildOrder := 11;
    RFE_Imag2.EditType := weSignedFloat;
    RFE_Imag2.ElementClassName := 'input input-bordered w-full';
    RFE_Imag2.ElementFont := efCSS;
    RFE_Imag2.ElementPosition := epRelative;
    RFE_Imag2.HeightStyle := ssAuto;
    RFE_Imag2.HeightPercent := 100.00000000000000000;
    RFE_Imag2.Text := 'RFE_Imag2';
    RFE_Imag2.WidthStyle := ssAuto;
    RFE_Imag2.WidthPercent := 100.00000000000000000;
    SetEvent(RFE_Imag2, Self, 'OnExit', 'RFE_KrdKurzExit');
    RFE_Imag2.DataField := 'Hbpm_Image_Department2';
    RFE_Imag2.DataSource := PerfMiscWebDataSource;
    RFE_Imag3.SetParentComponent(pnFinanzGenerell);
    RFE_Imag3.Name := 'RFE_Imag3';
    RFE_Imag3.Left := 626;
    RFE_Imag3.Top := 265;
    RFE_Imag3.Width := 150;
    RFE_Imag3.Height := 35;
    RFE_Imag3.ChildOrder := 11;
    RFE_Imag3.EditType := weSignedFloat;
    RFE_Imag3.ElementClassName := 'input input-bordered w-full';
    RFE_Imag3.ElementFont := efCSS;
    RFE_Imag3.ElementPosition := epRelative;
    RFE_Imag3.HeightStyle := ssAuto;
    RFE_Imag3.HeightPercent := 100.00000000000000000;
    RFE_Imag3.Text := 'RFE_Imag3';
    RFE_Imag3.WidthStyle := ssAuto;
    RFE_Imag3.WidthPercent := 100.00000000000000000;
    SetEvent(RFE_Imag3, Self, 'OnExit', 'RFE_KrdKurzExit');
    RFE_Imag3.DataField := 'Hbpm_Image_Department3';
    RFE_Imag3.DataSource := PerfMiscWebDataSource;
    pnUeberschuss.SetParentComponent(pgcSheetFinanzen);
    pnUeberschuss.Name := 'pnUeberschuss';
    pnUeberschuss.Left := 12;
    pnUeberschuss.Top := 402;
    pnUeberschuss.Width := 636;
    pnUeberschuss.Height := 441;
    pnUeberschuss.ElementClassName := 'card bg-base-100 shadow-xl grow basis-1/2';
    pnUeberschuss.HeightStyle := ssAuto;
    pnUeberschuss.WidthStyle := ssAuto;
    pnUeberschuss.ChildOrder := 3;
    pnUeberschuss.ElementBodyClassName := 'card-body';
    pnUeberschuss.ElementFont := efCSS;
    pnUeberschuss.ElementPosition := epIgnore;
    pnUeberschuss.TabOrder := 2;
    WebLabel1.SetParentComponent(pnUeberschuss);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 30;
    WebLabel1.Top := 31;
    WebLabel1.Width := 284;
    WebLabel1.Height := 29;
    WebLabel1.Caption := #220'berschussverwendung';
    WebLabel1.ElementClassName := 'card-title';
    WebLabel1.ElementFont := efCSS;
    WebLabel1.ElementPosition := epRelative;
    WebLabel1.Font.Charset := DEFAULT_CHARSET;
    WebLabel1.Font.Color := clWindowText;
    WebLabel1.Font.Height := -24;
    WebLabel1.Font.Name := 'Tahoma';
    WebLabel1.Font.Style := [fsBold];
    WebLabel1.HeightStyle := ssAuto;
    WebLabel1.HeightPercent := 100.00000000000000000;
    WebLabel1.HTMLType := tH3;
    WebLabel1.ParentFont := False;
    WebLabel1.WidthPercent := 100.00000000000000000;
    WebLabel5.SetParentComponent(pnUeberschuss);
    WebLabel5.Name := 'WebLabel5';
    WebLabel5.Left := 15;
    WebLabel5.Top := 173;
    WebLabel5.Width := 459;
    WebLabel5.Height := 58;
    WebLabel5.Caption := 'Aussch'#252'ttung der Ertr'#228'ge (Dividende) (% v. Bilanzgewinn)';
    WebLabel5.ElementFont := efCSS;
    WebLabel5.ElementPosition := epRelative;
    WebLabel5.Font.Charset := DEFAULT_CHARSET;
    WebLabel5.Font.Color := clWindowText;
    WebLabel5.Font.Height := -24;
    WebLabel5.Font.Name := 'Tahoma';
    WebLabel5.Font.Style := [fsBold];
    WebLabel5.HeightStyle := ssAuto;
    WebLabel5.HeightPercent := 100.00000000000000000;
    WebLabel5.ParentFont := False;
    WebLabel5.WordWrap := True;
    WebLabel5.WidthPercent := 100.00000000000000000;
    WebLabel6.SetParentComponent(pnUeberschuss);
    WebLabel6.Name := 'WebLabel6';
    WebLabel6.Left := 30;
    WebLabel6.Top := 309;
    WebLabel6.Width := 304;
    WebLabel6.Height := 29;
    WebLabel6.Caption := 'Kauf Wertpapiere (TEUR)';
    WebLabel6.ElementFont := efCSS;
    WebLabel6.ElementPosition := epRelative;
    WebLabel6.Font.Charset := DEFAULT_CHARSET;
    WebLabel6.Font.Color := clWindowText;
    WebLabel6.Font.Height := -24;
    WebLabel6.Font.Name := 'Tahoma';
    WebLabel6.Font.Style := [fsBold];
    WebLabel6.HeightStyle := ssAuto;
    WebLabel6.HeightPercent := 100.00000000000000000;
    WebLabel6.ParentFont := False;
    WebLabel6.WidthPercent := 100.00000000000000000;
    RFE_Dividen.SetParentComponent(pnUeberschuss);
    RFE_Dividen.Name := 'RFE_Dividen';
    RFE_Dividen.Left := 480;
    RFE_Dividen.Top := 177;
    RFE_Dividen.Width := 150;
    RFE_Dividen.Height := 35;
    RFE_Dividen.ChildOrder := 11;
    RFE_Dividen.EditType := weSignedFloat;
    RFE_Dividen.ElementClassName := 'input input-bordered w-full';
    RFE_Dividen.ElementFont := efCSS;
    RFE_Dividen.ElementPosition := epRelative;
    RFE_Dividen.HeightStyle := ssAuto;
    RFE_Dividen.HeightPercent := 100.00000000000000000;
    RFE_Dividen.Text := 'RFE_Dividen';
    RFE_Dividen.WidthStyle := ssAuto;
    RFE_Dividen.WidthPercent := 100.00000000000000000;
    SetEvent(RFE_Dividen, Self, 'OnExit', 'RFE_KrdKurzExit');
    RFE_Dividen.DataField := 'Hbpm_Surplus_Income';
    RFE_Dividen.DataSource := PerfMiscWebDataSource;
    RFE_WpKauf.SetParentComponent(pnUeberschuss);
    RFE_WpKauf.Name := 'RFE_WpKauf';
    RFE_WpKauf.Left := 395;
    RFE_WpKauf.Top := 306;
    RFE_WpKauf.Width := 150;
    RFE_WpKauf.Height := 35;
    RFE_WpKauf.ChildOrder := 11;
    RFE_WpKauf.EditType := weSignedFloat;
    RFE_WpKauf.ElementClassName := 'input input-bordered w-full';
    RFE_WpKauf.ElementFont := efCSS;
    RFE_WpKauf.ElementPosition := epRelative;
    RFE_WpKauf.HeightStyle := ssAuto;
    RFE_WpKauf.HeightPercent := 100.00000000000000000;
    RFE_WpKauf.Text := 'RFE_WpKauf';
    RFE_WpKauf.WidthStyle := ssAuto;
    RFE_WpKauf.WidthPercent := 100.00000000000000000;
    SetEvent(RFE_WpKauf, Self, 'OnExit', 'RFE_KrdKurzExit');
    RFE_WpKauf.DataField := 'Hbpm_Surplus_Securities';
    RFE_WpKauf.DataSource := PerfMiscWebDataSource;
    pnRationalisierung.SetParentComponent(pgcSheetFinanzen);
    pnRationalisierung.Name := 'pnRationalisierung';
    pnRationalisierung.Left := 758;
    pnRationalisierung.Top := 351;
    pnRationalisierung.Width := 642;
    pnRationalisierung.Height := 551;
    pnRationalisierung.ElementClassName := 'card bg-base-100 shadow-xl grow basis-1/2';
    pnRationalisierung.HeightStyle := ssAuto;
    pnRationalisierung.WidthStyle := ssAuto;
    pnRationalisierung.ChildOrder := 3;
    pnRationalisierung.ElementBodyClassName := 'card-body';
    pnRationalisierung.ElementFont := efCSS;
    pnRationalisierung.ElementPosition := epIgnore;
    pnRationalisierung.TabOrder := 3;
    WebLabel10.SetParentComponent(pnRationalisierung);
    WebLabel10.Name := 'WebLabel10';
    WebLabel10.Left := 29;
    WebLabel10.Top := 60;
    WebLabel10.Width := 766;
    WebLabel10.Height := 29;
    WebLabel10.Caption := 'Management der behandelten Personen / Qualit'#228'tsmanagement';
    WebLabel10.ElementFont := efCSS;
    WebLabel10.ElementPosition := epRelative;
    WebLabel10.Font.Charset := DEFAULT_CHARSET;
    WebLabel10.Font.Color := clWindowText;
    WebLabel10.Font.Height := -24;
    WebLabel10.Font.Name := 'Tahoma';
    WebLabel10.Font.Style := [fsBold];
    WebLabel10.HeightStyle := ssAuto;
    WebLabel10.HeightPercent := 100.00000000000000000;
    WebLabel10.ParentFont := False;
    WebLabel10.WidthPercent := 100.00000000000000000;
    WebLabel13.SetParentComponent(pnRationalisierung);
    WebLabel13.Name := 'WebLabel13';
    WebLabel13.Left := 29;
    WebLabel13.Top := 214;
    WebLabel13.Width := 709;
    WebLabel13.Height := 29;
    WebLabel13.Caption := 'Rationalisierung / Ablaufoptimierung / Ger'#228'temanagement';
    WebLabel13.ElementFont := efCSS;
    WebLabel13.ElementPosition := epRelative;
    WebLabel13.Font.Charset := DEFAULT_CHARSET;
    WebLabel13.Font.Color := clWindowText;
    WebLabel13.Font.Height := -24;
    WebLabel13.Font.Name := 'Tahoma';
    WebLabel13.Font.Style := [fsBold];
    WebLabel13.HeightStyle := ssAuto;
    WebLabel13.HeightPercent := 100.00000000000000000;
    WebLabel13.ParentFont := False;
    WebLabel13.WidthPercent := 100.00000000000000000;
    WebLabel17.SetParentComponent(pnRationalisierung);
    WebLabel17.Name := 'WebLabel17';
    WebLabel17.Left := 3;
    WebLabel17.Top := 394;
    WebLabel17.Width := 429;
    WebLabel17.Height := 29;
    WebLabel17.Caption := 'Training Mitarbeitende der Institute';
    WebLabel17.ElementFont := efCSS;
    WebLabel17.ElementPosition := epRelative;
    WebLabel17.Font.Charset := DEFAULT_CHARSET;
    WebLabel17.Font.Color := clWindowText;
    WebLabel17.Font.Height := -24;
    WebLabel17.Font.Name := 'Tahoma';
    WebLabel17.Font.Style := [fsBold];
    WebLabel17.HeightStyle := ssAuto;
    WebLabel17.HeightPercent := 100.00000000000000000;
    WebLabel17.ParentFont := False;
    WebLabel17.WidthPercent := 100.00000000000000000;
    WebLabel9.SetParentComponent(pnRationalisierung);
    WebLabel9.Name := 'WebLabel9';
    WebLabel9.Left := 38;
    WebLabel9.Top := 39;
    WebLabel9.Width := 155;
    WebLabel9.Height := 29;
    WebLabel9.Caption := 'Management';
    WebLabel9.ElementClassName := 'card-title';
    WebLabel9.ElementFont := efCSS;
    WebLabel9.ElementPosition := epRelative;
    WebLabel9.Font.Charset := DEFAULT_CHARSET;
    WebLabel9.Font.Color := clWindowText;
    WebLabel9.Font.Height := -24;
    WebLabel9.Font.Name := 'Tahoma';
    WebLabel9.Font.Style := [fsBold];
    WebLabel9.HeightStyle := ssAuto;
    WebLabel9.HeightPercent := 100.00000000000000000;
    WebLabel9.HTMLType := tH3;
    WebLabel9.ParentFont := False;
    WebLabel9.WidthPercent := 100.00000000000000000;
    RFE_Patie.SetParentComponent(pnRationalisierung);
    RFE_Patie.Name := 'RFE_Patie';
    RFE_Patie.Left := 460;
    RFE_Patie.Top := 66;
    RFE_Patie.Width := 150;
    RFE_Patie.Height := 35;
    RFE_Patie.ChildOrder := 11;
    RFE_Patie.EditType := weSignedFloat;
    RFE_Patie.ElementClassName := 'input input-bordered w-full';
    RFE_Patie.ElementFont := efCSS;
    RFE_Patie.ElementPosition := epRelative;
    RFE_Patie.HeightStyle := ssAuto;
    RFE_Patie.HeightPercent := 100.00000000000000000;
    RFE_Patie.Text := 'RFE_Patie';
    RFE_Patie.WidthStyle := ssAuto;
    RFE_Patie.WidthPercent := 100.00000000000000000;
    SetEvent(RFE_Patie, Self, 'OnExit', 'RFE_KrdKurzExit');
    RFE_Patie.DataField := 'Hbpm_Management_Training';
    RFE_Patie.DataSource := PerfMiscWebDataSource;
    RFE_Ratio.SetParentComponent(pnRationalisierung);
    RFE_Ratio.Name := 'RFE_Ratio';
    RFE_Ratio.Left := 444;
    RFE_Ratio.Top := 236;
    RFE_Ratio.Width := 150;
    RFE_Ratio.Height := 35;
    RFE_Ratio.ChildOrder := 11;
    RFE_Ratio.EditType := weSignedFloat;
    RFE_Ratio.ElementClassName := 'input input-bordered w-full';
    RFE_Ratio.ElementFont := efCSS;
    RFE_Ratio.ElementPosition := epRelative;
    RFE_Ratio.HeightStyle := ssAuto;
    RFE_Ratio.HeightPercent := 100.00000000000000000;
    RFE_Ratio.Text := 'RFE_Ratio';
    RFE_Ratio.WidthStyle := ssAuto;
    RFE_Ratio.WidthPercent := 100.00000000000000000;
    SetEvent(RFE_Ratio, Self, 'OnExit', 'RFE_KrdKurzExit');
    RFE_Ratio.DataField := 'Hbpm_Management_Devices';
    RFE_Ratio.DataSource := PerfMiscWebDataSource;
    RFE_Train.SetParentComponent(pnRationalisierung);
    RFE_Train.Name := 'RFE_Train';
    RFE_Train.Left := 489;
    RFE_Train.Top := 396;
    RFE_Train.Width := 150;
    RFE_Train.Height := 35;
    RFE_Train.ChildOrder := 11;
    RFE_Train.EditType := weSignedFloat;
    RFE_Train.ElementClassName := 'input input-bordered w-full';
    RFE_Train.ElementFont := efCSS;
    RFE_Train.ElementPosition := epRelative;
    RFE_Train.HeightStyle := ssAuto;
    RFE_Train.HeightPercent := 100.00000000000000000;
    RFE_Train.Text := 'RFE_Train';
    RFE_Train.WidthStyle := ssAuto;
    RFE_Train.WidthPercent := 100.00000000000000000;
    SetEvent(RFE_Train, Self, 'OnExit', 'RFE_KrdKurzExit');
    RFE_Train.DataField := 'Hbpm_Management_Training';
    RFE_Train.DataSource := PerfMiscWebDataSource;
    pgcSheetKPI.SetParentComponent(pgcEntscheidungen);
    pgcSheetKPI.Name := 'pgcSheetKPI';
    pgcSheetKPI.Left := 0;
    pgcSheetKPI.Top := 20;
    pgcSheetKPI.Width := 1600;
    pgcSheetKPI.Height := 1147;
    pgcSheetKPI.HeightStyle := ssAuto;
    pgcSheetKPI.WidthStyle := ssAuto;
    pgcSheetKPI.Caption := 'KPI';
    pgcSheetKPI.ChildOrder := 3;
    pgcSheetKPI.ElementFont := efCSS;
    pgcSheetKPI.ElementPosition := epRelative;
    pgcSheetKPI.Visible := False;
    pnKPIData.SetParentComponent(pgcSheetKPI);
    pnKPIData.Name := 'pnKPIData';
    pnKPIData.Left := 0;
    pnKPIData.Top := 16;
    pnKPIData.Width := 1481;
    pnKPIData.Height := 788;
    pnKPIData.HeightStyle := ssAuto;
    pnKPIData.WidthStyle := ssAuto;
    pnKPIData.Caption := 'Hier die KPI Daten darstellen';
    pnKPIData.ElementFont := efCSS;
    pnKPIData.ElementPosition := epIgnore;
    pnKPIData.ShowCaption := False;
    pnKPIData.TabOrder := 0;
    weblabKPIHeadline.SetParentComponent(pnKPIData);
    weblabKPIHeadline.Name := 'weblabKPIHeadline';
    weblabKPIHeadline.Left := 17;
    weblabKPIHeadline.Top := 8;
    weblabKPIHeadline.Width := 123;
    weblabKPIHeadline.Height := 29;
    weblabKPIHeadline.Caption := 'KPI Daten';
    weblabKPIHeadline.ElementClassName := 'card-title';
    weblabKPIHeadline.ElementFont := efCSS;
    weblabKPIHeadline.ElementPosition := epRelative;
    weblabKPIHeadline.Font.Charset := DEFAULT_CHARSET;
    weblabKPIHeadline.Font.Color := clWindowText;
    weblabKPIHeadline.Font.Height := -24;
    weblabKPIHeadline.Font.Name := 'Tahoma';
    weblabKPIHeadline.Font.Style := [fsBold];
    weblabKPIHeadline.HeightStyle := ssAuto;
    weblabKPIHeadline.HeightPercent := 100.00000000000000000;
    weblabKPIHeadline.HTMLType := tH3;
    weblabKPIHeadline.ParentFont := False;
    weblabKPIHeadline.Visible := False;
    weblabKPIHeadline.WidthPercent := 100.00000000000000000;
    pnLeftNavigation.SetParentComponent(Self);
    pnLeftNavigation.Name := 'pnLeftNavigation';
    pnLeftNavigation.Left := 1653;
    pnLeftNavigation.Top := 28;
    pnLeftNavigation.Width := 272;
    pnLeftNavigation.Height := 1080;
    pnLeftNavigation.HeightStyle := ssAuto;
    pnLeftNavigation.WidthStyle := ssAuto;
    pnLeftNavigation.Alignment := taLeftJustify;
    pnLeftNavigation.Anchors := [];
    pnLeftNavigation.Caption := 'pnLeftNavigation';
    pnLeftNavigation.ChildOrder := 2;
    pnLeftNavigation.ElementFont := efCSS;
    pnLeftNavigation.ElementPosition := epRelative;
    pnLeftNavigation.ShowCaption := False;
    pnLeftNavigation.TabOrder := 2;
    lblPeriode.SetParentComponent(pnLeftNavigation);
    lblPeriode.Name := 'lblPeriode';
    lblPeriode.Left := 16;
    lblPeriode.Top := 365;
    lblPeriode.Width := 165;
    lblPeriode.Height := 29;
    lblPeriode.Caption := 'Gesch'#228'ftsjahr';
    lblPeriode.ElementFont := efCSS;
    lblPeriode.ElementPosition := epRelative;
    lblPeriode.Font.Charset := DEFAULT_CHARSET;
    lblPeriode.Font.Color := clWindowText;
    lblPeriode.Font.Height := -24;
    lblPeriode.Font.Name := 'Tahoma';
    lblPeriode.Font.Style := [fsBold];
    lblPeriode.HeightStyle := ssAuto;
    lblPeriode.HeightPercent := 100.00000000000000000;
    lblPeriode.ParentFont := False;
    lblPeriode.WidthStyle := ssAuto;
    lblPeriode.WidthPercent := 100.00000000000000000;
    lblAbteilung.SetParentComponent(pnLeftNavigation);
    lblAbteilung.Name := 'lblAbteilung';
    lblAbteilung.Left := 12;
    lblAbteilung.Top := 467;
    lblAbteilung.Width := 114;
    lblAbteilung.Height := 29;
    lblAbteilung.Caption := 'Abteilung';
    lblAbteilung.ElementFont := efCSS;
    lblAbteilung.ElementPosition := epRelative;
    lblAbteilung.Font.Charset := DEFAULT_CHARSET;
    lblAbteilung.Font.Color := clWindowText;
    lblAbteilung.Font.Height := -24;
    lblAbteilung.Font.Name := 'Tahoma';
    lblAbteilung.Font.Style := [fsBold];
    lblAbteilung.HeightStyle := ssAuto;
    lblAbteilung.HeightPercent := 100.00000000000000000;
    lblAbteilung.ParentFont := False;
    lblAbteilung.WidthStyle := ssAuto;
    lblAbteilung.WidthPercent := 100.00000000000000000;
    lblKrankenhaus.SetParentComponent(pnLeftNavigation);
    lblKrankenhaus.Name := 'lblKrankenhaus';
    lblKrankenhaus.Left := 12;
    lblKrankenhaus.Top := 570;
    lblKrankenhaus.Width := 155;
    lblKrankenhaus.Height := 29;
    lblKrankenhaus.Caption := 'Krankenhaus';
    lblKrankenhaus.ElementFont := efCSS;
    lblKrankenhaus.ElementPosition := epRelative;
    lblKrankenhaus.Font.Charset := DEFAULT_CHARSET;
    lblKrankenhaus.Font.Color := clWindowText;
    lblKrankenhaus.Font.Height := -24;
    lblKrankenhaus.Font.Name := 'Tahoma';
    lblKrankenhaus.Font.Style := [fsBold];
    lblKrankenhaus.HeightStyle := ssAuto;
    lblKrankenhaus.HeightPercent := 100.00000000000000000;
    lblKrankenhaus.ParentFont := False;
    lblKrankenhaus.WidthPercent := 100.00000000000000000;
    btnClose.SetParentComponent(pnLeftNavigation);
    btnClose.Name := 'btnClose';
    btnClose.Left := 10;
    btnClose.Top := 48;
    btnClose.Width := 250;
    btnClose.Height := 55;
    btnClose.Caption := 'Zur'#252'ck';
    btnClose.ChildOrder := 7;
    btnClose.ElementClassName := 'btn btn-outline';
    btnClose.ElementFont := efCSS;
    btnClose.ElementPosition := epRelative;
    btnClose.HeightStyle := ssAuto;
    btnClose.HeightPercent := 100.00000000000000000;
    btnClose.WidthStyle := ssAuto;
    btnClose.WidthPercent := 100.00000000000000000;
    SetEvent(btnClose, Self, 'OnClick', 'btnCloseClick');
    btnSave.SetParentComponent(pnLeftNavigation);
    btnSave.Name := 'btnSave';
    btnSave.Left := 10;
    btnSave.Top := 129;
    btnSave.Width := 250;
    btnSave.Height := 55;
    btnSave.Caption := 'Speichern';
    btnSave.ChildOrder := 7;
    btnSave.ElementClassName := 'btn btn-success btn-outline';
    btnSave.ElementFont := efCSS;
    btnSave.ElementPosition := epRelative;
    btnSave.Enabled := False;
    btnSave.HeightStyle := ssAuto;
    btnSave.HeightPercent := 100.00000000000000000;
    btnSave.WidthStyle := ssAuto;
    btnSave.WidthPercent := 100.00000000000000000;
    SetEvent(btnSave, Self, 'OnClick', 'webBtnSaveClick');
    spedPeriode.SetParentComponent(pnLeftNavigation);
    spedPeriode.Name := 'spedPeriode';
    spedPeriode.Left := 10;
    spedPeriode.Top := 400;
    spedPeriode.Width := 250;
    spedPeriode.Height := 57;
    spedPeriode.ElementClassName := 'input input-bordered w-full';
    spedPeriode.HeightStyle := ssAuto;
    spedPeriode.WidthStyle := ssAuto;
    spedPeriode.AutoSize := False;
    spedPeriode.BorderStyle := bsSingle;
    spedPeriode.ChildOrder := 7;
    spedPeriode.Color := clWhite;
    spedPeriode.ElementFont := efCSS;
    spedPeriode.ElementPosition := epRelative;
    spedPeriode.Increment := 1;
    spedPeriode.MaxValue := 100;
    spedPeriode.MinValue := 0;
    spedPeriode.Role := '';
    spedPeriode.Value := 0;
    SetEvent(spedPeriode, Self, 'OnChange', 'spedPeriodeChange');
    btnPrint.SetParentComponent(pnLeftNavigation);
    btnPrint.Name := 'btnPrint';
    btnPrint.Left := 10;
    btnPrint.Top := 736;
    btnPrint.Width := 250;
    btnPrint.Height := 55;
    btnPrint.Caption := 'Drucken';
    btnPrint.ChildOrder := 7;
    btnPrint.ElementClassName := 'btn border btn-outline btn-accent';
    btnPrint.ElementFont := efCSS;
    btnPrint.ElementPosition := epRelative;
    btnPrint.HeightStyle := ssAuto;
    btnPrint.HeightPercent := 100.00000000000000000;
    btnPrint.WidthStyle := ssAuto;
    btnPrint.WidthPercent := 100.00000000000000000;
    SetEvent(btnPrint, Self, 'OnClick', 'btnPrintClick');
    btnCancel.SetParentComponent(pnLeftNavigation);
    btnCancel.Name := 'btnCancel';
    btnCancel.Left := 10;
    btnCancel.Top := 815;
    btnCancel.Width := 250;
    btnCancel.Height := 55;
    btnCancel.Caption := 'Abbruch';
    btnCancel.ChildOrder := 7;
    btnCancel.ElementClassName := 'btn btn-error';
    btnCancel.ElementFont := efCSS;
    btnCancel.ElementPosition := epRelative;
    btnCancel.HeightStyle := ssAuto;
    btnCancel.HeightPercent := 100.00000000000000000;
    btnCancel.WidthStyle := ssAuto;
    btnCancel.WidthPercent := 100.00000000000000000;
    SetEvent(btnCancel, Self, 'OnClick', 'btnCancelClick');
    brnHelp.SetParentComponent(pnLeftNavigation);
    brnHelp.Name := 'brnHelp';
    brnHelp.Left := 19;
    brnHelp.Top := 929;
    brnHelp.Width := 250;
    brnHelp.Height := 55;
    brnHelp.Caption := 'Hilfe';
    brnHelp.ChildOrder := 7;
    brnHelp.ElementClassName := 'btn btn-info';
    brnHelp.ElementFont := efCSS;
    brnHelp.ElementPosition := epRelative;
    brnHelp.HeightStyle := ssAuto;
    brnHelp.HeightPercent := 100.00000000000000000;
    brnHelp.WidthStyle := ssAuto;
    brnHelp.WidthPercent := 100.00000000000000000;
    spedAbteilung.SetParentComponent(pnLeftNavigation);
    spedAbteilung.Name := 'spedAbteilung';
    spedAbteilung.Left := 3;
    spedAbteilung.Top := 502;
    spedAbteilung.Width := 250;
    spedAbteilung.Height := 57;
    spedAbteilung.ElementClassName := 'input input-bordered w-full';
    spedAbteilung.HeightStyle := ssAuto;
    spedAbteilung.WidthStyle := ssAuto;
    spedAbteilung.AutoSize := False;
    spedAbteilung.BorderStyle := bsSingle;
    spedAbteilung.ChildOrder := 7;
    spedAbteilung.Color := clWhite;
    spedAbteilung.ElementFont := efCSS;
    spedAbteilung.ElementPosition := epRelative;
    spedAbteilung.Increment := 1;
    spedAbteilung.MaxValue := 100;
    spedAbteilung.MinValue := 0;
    spedAbteilung.Role := '';
    spedAbteilung.Value := 0;
    SetEvent(spedAbteilung, Self, 'OnChange', 'spedAbteilungChanged');
    spedKrankenhaus.SetParentComponent(pnLeftNavigation);
    spedKrankenhaus.Name := 'spedKrankenhaus';
    spedKrankenhaus.Left := 6;
    spedKrankenhaus.Top := 605;
    spedKrankenhaus.Width := 250;
    spedKrankenhaus.Height := 57;
    spedKrankenhaus.ElementClassName := 'input input-bordered w-full';
    spedKrankenhaus.HeightStyle := ssAuto;
    spedKrankenhaus.WidthStyle := ssAuto;
    spedKrankenhaus.AutoSize := False;
    spedKrankenhaus.BorderStyle := bsSingle;
    spedKrankenhaus.ChildOrder := 7;
    spedKrankenhaus.Color := clWhite;
    spedKrankenhaus.ElementFont := efCSS;
    spedKrankenhaus.ElementPosition := epRelative;
    spedKrankenhaus.Increment := 1;
    spedKrankenhaus.MaxValue := 100;
    spedKrankenhaus.MinValue := 0;
    spedKrankenhaus.Role := '';
    spedKrankenhaus.Value := 0;
    SetEvent(spedKrankenhaus, Self, 'OnChange', 'spedKrankenhausChange');
    btnSaveAndLock.SetParentComponent(pnLeftNavigation);
    btnSaveAndLock.Name := 'btnSaveAndLock';
    btnSaveAndLock.Left := 3;
    btnSaveAndLock.Top := 233;
    btnSaveAndLock.Width := 250;
    btnSaveAndLock.Height := 55;
    btnSaveAndLock.Caption := 'Speichern und abschlie'#223'en';
    btnSaveAndLock.ChildOrder := 7;
    btnSaveAndLock.ElementClassName := 'btn btn-success';
    btnSaveAndLock.ElementFont := efCSS;
    btnSaveAndLock.ElementPosition := epRelative;
    btnSaveAndLock.Enabled := False;
    btnSaveAndLock.HeightStyle := ssAuto;
    btnSaveAndLock.HeightPercent := 100.00000000000000000;
    btnSaveAndLock.WidthStyle := ssAuto;
    btnSaveAndLock.WidthPercent := 100.00000000000000000;
    SetEvent(btnSaveAndLock, Self, 'OnClick', 'btnSaveAndLockClick');
    WebMessageDlg.SetParentComponent(Self);
    WebMessageDlg.Name := 'WebMessageDlg';
    WebMessageDlg.Left := 1269;
    WebMessageDlg.Top := 749;
    WebMessageDlg.Width := 24;
    WebMessageDlg.Height := 24;
    WebMessageDlg.Buttons := [];
    WebMessageDlg.Opacity := 0.20000000000000000;
    WebMessageDlg.ElementButtonClassName := 'btn';
    WebMessageDlg.ElementDialogClassName := 'shadow-lg p-3 mb-5 rounded styled-modal bg-base-100';
    WebMessageDlg.ElementTitleClassName := 'text-body';
    WebMessageDlg.ElementContentClassName := 'text-body';
    XDataWebDataSetPerfPlan.SetParentComponent(Self);
    XDataWebDataSetPerfPlan.Name := 'XDataWebDataSetPerfPlan';
    XDataWebDataSetPerfPlan.AfterOpen := XDataWebDataSetPerfPlanAfterOpen;
    SetEvent(XDataWebDataSetPerfPlan, Self, 'OnEditError', 'XDataWebDataSetPerfPlanEditError');
    XDataWebDataSetPerfPlan.EntitySetName := 'Tblhbm_Performance_Planing';
    XDataWebDataSetPerfPlan.Connection := XDataWebConnection1;
    XDataWebDataSetPerfPlan.Left := 818;
    XDataWebDataSetPerfPlan.Top := 656;
    PerfPlanDataSource.SetParentComponent(Self);
    PerfPlanDataSource.Name := 'PerfPlanDataSource';
    PerfPlanDataSource.DataSet := XDataWebDataSetPerfPlan;
    PerfPlanDataSource.Left := 970;
    PerfPlanDataSource.Top := 656;
    XDataWebConnection1.SetParentComponent(Self);
    XDataWebConnection1.Name := 'XDataWebConnection1';
    XDataWebConnection1.URL := 'https://hbm-online.eu/MFCWebServices/';
    XDataWebConnection1.Left := 1458;
    XDataWebConnection1.Top := 640;
    XDataWebDataSetPerfCat.SetParentComponent(Self);
    XDataWebDataSetPerfCat.Name := 'XDataWebDataSetPerfCat';
    XDataWebDataSetPerfCat.AfterOpen := XDataWebDataSetPerfCatAfterOpen;
    SetEvent(XDataWebDataSetPerfCat, Self, 'OnEditError', 'XDataWebDataSetPerfCatEditError');
    XDataWebDataSetPerfCat.EntitySetName := 'Tblhbm_Performance_Categories';
    XDataWebDataSetPerfCat.Connection := XDataWebConnection1;
    XDataWebDataSetPerfCat.Left := 818;
    XDataWebDataSetPerfCat.Top := 720;
    PerfCatWebDataSource.SetParentComponent(Self);
    PerfCatWebDataSource.Name := 'PerfCatWebDataSource';
    PerfCatWebDataSource.DataSet := XDataWebDataSetPerfCat;
    PerfCatWebDataSource.Left := 962;
    PerfCatWebDataSource.Top := 720;
    XDataWebDataSetPerfMisc.SetParentComponent(Self);
    XDataWebDataSetPerfMisc.Name := 'XDataWebDataSetPerfMisc';
    XDataWebDataSetPerfMisc.AfterOpen := XDataWebDataSetPerfMiscAfterOpen;
    XDataWebDataSetPerfMisc.EntitySetName := 'Tblhbm_Performance_Miscellaneous';
    XDataWebDataSetPerfMisc.Connection := XDataWebConnection1;
    XDataWebDataSetPerfMisc.Left := 818;
    XDataWebDataSetPerfMisc.Top := 792;
    PerfMiscWebDataSource.SetParentComponent(Self);
    PerfMiscWebDataSource.Name := 'PerfMiscWebDataSource';
    PerfMiscWebDataSource.DataSet := XDataWebDataSetPerfMisc;
    PerfMiscWebDataSource.Left := 962;
    PerfMiscWebDataSource.Top := 792;
    XDataWebDataSetFaelle.SetParentComponent(Self);
    XDataWebDataSetFaelle.Name := 'XDataWebDataSetFaelle';
    XDataWebDataSetFaelle.AfterOpen := XDataWebDataSetFaelleAfterOpen;
    SetEvent(XDataWebDataSetFaelle, Self, 'OnEditError', 'XDataWebDataSetPerfPlanEditError');
    XDataWebDataSetFaelle.EntitySetName := 'Tblhbm_Faelle';
    XDataWebDataSetFaelle.Connection := XDataWebConnection1;
    XDataWebDataSetFaelle.Left := 1162;
    XDataWebDataSetFaelle.Top := 744;
    FaelleDataSource.SetParentComponent(Self);
    FaelleDataSource.Name := 'FaelleDataSource';
    FaelleDataSource.DataSet := XDataWebDataSetFaelle;
    FaelleDataSource.Left := 1370;
    FaelleDataSource.Top := 744;
    XDataWebDataSetKPIData.SetParentComponent(Self);
    XDataWebDataSetKPIData.Name := 'XDataWebDataSetKPIData';
    XDataWebDataSetKPIData.AfterOpen := XDataWebDataSetKPIDataAfterOpen;
    SetEvent(XDataWebDataSetKPIData, Self, 'OnEditError', 'XDataWebDataSetKPIDataEditError');
    XDataWebDataSetKPIData.EntitySetName := 'Tblhbm_Kpi_Data';
    XDataWebDataSetKPIData.Connection := XDataWebConnection1;
    XDataWebDataSetKPIData.Left := 826;
    XDataWebDataSetKPIData.Top := 592;
    KPIDataWebDataSource.SetParentComponent(Self);
    KPIDataWebDataSource.Name := 'KPIDataWebDataSource';
    KPIDataWebDataSource.DataSet := XDataWebDataSetKPIData;
    KPIDataWebDataSource.Left := 970;
    KPIDataWebDataSource.Top := 600;
  finally
    WaitMessage.AfterLoadDFMValues;
    pgcEntscheidungen.AfterLoadDFMValues;
    pgcSheetFaelleInstitute.AfterLoadDFMValues;
    pnInstitutsEntscheidungen.AfterLoadDFMValues;
    lblOutsourcingAlternativen.AfterLoadDFMValues;
    lblLaundryAktiv.AfterLoadDFMValues;
    cbxOutsourceWaescherei.AfterLoadDFMValues;
    pnLeistungsPlanung.AfterLoadDFMValues;
    WebLabel16.AfterLoadDFMValues;
    WebLabel11.AfterLoadDFMValues;
    WebLabel12.AfterLoadDFMValues;
    WebLabel14.AfterLoadDFMValues;
    WebLabel15.AfterLoadDFMValues;
    WebLabel21.AfterLoadDFMValues;
    WebLabel22.AfterLoadDFMValues;
    ed_LeistPlAbteilung.AfterLoadDFMValues;
    ed_LeistPlStation1.AfterLoadDFMValues;
    ed_LeistPlStation2.AfterLoadDFMValues;
    ed_LeistPlStation3.AfterLoadDFMValues;
    ed_LeistPlStation5.AfterLoadDFMValues;
    ed_LeistPlStation4.AfterLoadDFMValues;
    ed_LeistPlStation6.AfterLoadDFMValues;
    ed_LeistPlStationSumme.AfterLoadDFMValues;
    edLeistPlWahl1Stat1.AfterLoadDFMValues;
    edLeistPlWahl1Stat2.AfterLoadDFMValues;
    edLeistPlWahl1Stat3.AfterLoadDFMValues;
    edLeistPlWahl1Stat5.AfterLoadDFMValues;
    edLeistPlWahl1Stat4.AfterLoadDFMValues;
    edLeistPlWahl1Stat6.AfterLoadDFMValues;
    edLeistPlWahl1Summe.AfterLoadDFMValues;
    edLeistPlWahl2Stat1.AfterLoadDFMValues;
    edLeistPlWahl2Stat2.AfterLoadDFMValues;
    edLeistPlWahl2Stat3.AfterLoadDFMValues;
    edLeistPlWahl2Stat5.AfterLoadDFMValues;
    edLeistPlWahl2Stat4.AfterLoadDFMValues;
    edLeistPlWahl2Stat6.AfterLoadDFMValues;
    edLeistPlWahl2Summe.AfterLoadDFMValues;
    edLeistPlNormStat1.AfterLoadDFMValues;
    edLeistPlNormStat2.AfterLoadDFMValues;
    edLeistPlNormStat3.AfterLoadDFMValues;
    edLeistPlNormStat5.AfterLoadDFMValues;
    edLeistPlNormStat4.AfterLoadDFMValues;
    edLeistPlNormStat6.AfterLoadDFMValues;
    edLeistPlNormSumme.AfterLoadDFMValues;
    edLeistPlSumStat1.AfterLoadDFMValues;
    edLeistPlSumStat2.AfterLoadDFMValues;
    edLeistPlSumStat3.AfterLoadDFMValues;
    edLeistPlSumStat5.AfterLoadDFMValues;
    edLeistPlSumStat4.AfterLoadDFMValues;
    edLeistPlSumStat6.AfterLoadDFMValues;
    edLeistPlSumSumme.AfterLoadDFMValues;
    edLeistSumFaelleAbtl.AfterLoadDFMValues;
    pnKodierdienst.AfterLoadDFMValues;
    lblCaseManagementAktiv.AfterLoadDFMValues;
    lblCaseManagement.AfterLoadDFMValues;
    cb_CodD.AfterLoadDFMValues;
    pgcSheetStationenPersonal.AfterLoadDFMValues;
    pnLeistungsKategorie.AfterLoadDFMValues;
    WebLabel18.AfterLoadDFMValues;
    lb_LeistKatStation.AfterLoadDFMValues;
    lb_LeistKatAnzahlAlt.AfterLoadDFMValues;
    lb_LeistKatUmwandlung.AfterLoadDFMValues;
    lb_LeistKatErwAbbau.AfterLoadDFMValues;
    lb_LeistKatAnzahlNeu.AfterLoadDFMValues;
    lb_LeistKatZuschlag.AfterLoadDFMValues;
    lb_LeistKatStat1.AfterLoadDFMValues;
    lb_LeistKatStat2.AfterLoadDFMValues;
    lb_LeistKatStat3.AfterLoadDFMValues;
    lb_LeistKatStatSumme.AfterLoadDFMValues;
    ed_LeistKatWahlLeist1AnzAltZi.AfterLoadDFMValues;
    ed_LeistKatWahlLeist2AnzAltZi.AfterLoadDFMValues;
    ed_LeistKatNormalAnzAltZi.AfterLoadDFMValues;
    ed_LeistSummeAnzAltZi.AfterLoadDFMValues;
    ed_LeistKatWahlLeist1AnzAltBt.AfterLoadDFMValues;
    ed_LeistKatWahlLeist2AnzAltBt.AfterLoadDFMValues;
    ed_LeistKatNormalAnzAltBt.AfterLoadDFMValues;
    ed_LeistSummeAnzAltBt.AfterLoadDFMValues;
    ed_LeistKatWahlLeist1Umwandlung.AfterLoadDFMValues;
    ed_LeistKatWahlLeist2Umwandlung.AfterLoadDFMValues;
    ed_LeistKatNormalUmwandlung.AfterLoadDFMValues;
    ed_LeistSummeUmwandlung.AfterLoadDFMValues;
    ed_LeistKatWahlLeist1ErwAbbau.AfterLoadDFMValues;
    ed_LeistKatWahlLeist2ErwAbbau.AfterLoadDFMValues;
    ed_LeistKatNormalErwAbbau.AfterLoadDFMValues;
    ed_LeistSummeErwAbbau.AfterLoadDFMValues;
    ed_LeistKatWahlLeist1AnzNeuZi.AfterLoadDFMValues;
    ed_LeistKatWahlLeist2AnzNeuZi.AfterLoadDFMValues;
    ed_LeistKatNormalAnzNeuZi.AfterLoadDFMValues;
    ed_LeistSummeAnzNeuZi.AfterLoadDFMValues;
    ed_LeistKatWahlLeist1AnzNeuBt.AfterLoadDFMValues;
    ed_LeistKatWahlLeist2AnzNeuBt.AfterLoadDFMValues;
    ed_LeistKatNormalAnzNeuBt.AfterLoadDFMValues;
    ed_LeistSummeAnzNeuBt.AfterLoadDFMValues;
    ed_LeistKatWahlLeist1Zuschlag.AfterLoadDFMValues;
    ed_LeistKatWahlLeist2Zuschlag.AfterLoadDFMValues;
    ed_LeistKatNormalZuschlag.AfterLoadDFMValues;
    pnPersonal.AfterLoadDFMValues;
    WebLabel19.AfterLoadDFMValues;
    lb_MassHead.AfterLoadDFMValues;
    lb_MassArztHead.AfterLoadDFMValues;
    lb_MassPflegeHead.AfterLoadDFMValues;
    lb_PersMassEinstellung.AfterLoadDFMValues;
    lb_PersMassEntlassung.AfterLoadDFMValues;
    lb_PersMassTraining.AfterLoadDFMValues;
    lb_PersMassNebenkosten.AfterLoadDFMValues;
    lb_PersMassEinstellungEinh.AfterLoadDFMValues;
    lb_PersMassEntlassungEinh.AfterLoadDFMValues;
    lb_PersMassTrainingEinh.AfterLoadDFMValues;
    lb_PersMassNebenkostenEinh.AfterLoadDFMValues;
    lb_PersMassNebenkostenInstitut.AfterLoadDFMValues;
    ed_PersMassEinstellungenArzt.AfterLoadDFMValues;
    ed_PersMassEntlassungArzt.AfterLoadDFMValues;
    ed_PersMassTrainingArzt.AfterLoadDFMValues;
    ed_PersMassNebenkostenArzt.AfterLoadDFMValues;
    ed_PersMassEinstellungenPflege.AfterLoadDFMValues;
    ed_PersMassEntlassungPflege.AfterLoadDFMValues;
    ed_PersMassTrainingPflege.AfterLoadDFMValues;
    ed_PersMassNebenkostenPflege.AfterLoadDFMValues;
    ed_PersMassNebenkostenInstitut.AfterLoadDFMValues;
    pnVersetzungMitarbeiter.AfterLoadDFMValues;
    La3_Abt2.AfterLoadDFMValues;
    La3_Abt3.AfterLoadDFMValues;
    WebLabel20.AfterLoadDFMValues;
    LF3_NachA1.AfterLoadDFMValues;
    LF3_NachA2.AfterLoadDFMValues;
    RFE_AbteilungName.AfterLoadDFMValues;
    pgcSheetFinanzen.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    WebLabel7.AfterLoadDFMValues;
    pnFinanzen.AfterLoadDFMValues;
    lblStation1.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    RFE_KrdKurz.AfterLoadDFMValues;
    RFE_KrdLang.AfterLoadDFMValues;
    pnFinanzGenerell.AfterLoadDFMValues;
    WebLabel8.AfterLoadDFMValues;
    La5_Abt1.AfterLoadDFMValues;
    La5_Abt2.AfterLoadDFMValues;
    La5_Abt3.AfterLoadDFMValues;
    RFE_Imag1.AfterLoadDFMValues;
    RFE_Imag2.AfterLoadDFMValues;
    RFE_Imag3.AfterLoadDFMValues;
    pnUeberschuss.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WebLabel5.AfterLoadDFMValues;
    WebLabel6.AfterLoadDFMValues;
    RFE_Dividen.AfterLoadDFMValues;
    RFE_WpKauf.AfterLoadDFMValues;
    pnRationalisierung.AfterLoadDFMValues;
    WebLabel10.AfterLoadDFMValues;
    WebLabel13.AfterLoadDFMValues;
    WebLabel17.AfterLoadDFMValues;
    WebLabel9.AfterLoadDFMValues;
    RFE_Patie.AfterLoadDFMValues;
    RFE_Ratio.AfterLoadDFMValues;
    RFE_Train.AfterLoadDFMValues;
    pgcSheetKPI.AfterLoadDFMValues;
    pnKPIData.AfterLoadDFMValues;
    weblabKPIHeadline.AfterLoadDFMValues;
    pnLeftNavigation.AfterLoadDFMValues;
    lblPeriode.AfterLoadDFMValues;
    lblAbteilung.AfterLoadDFMValues;
    lblKrankenhaus.AfterLoadDFMValues;
    btnClose.AfterLoadDFMValues;
    btnSave.AfterLoadDFMValues;
    spedPeriode.AfterLoadDFMValues;
    btnPrint.AfterLoadDFMValues;
    btnCancel.AfterLoadDFMValues;
    brnHelp.AfterLoadDFMValues;
    spedAbteilung.AfterLoadDFMValues;
    spedKrankenhaus.AfterLoadDFMValues;
    btnSaveAndLock.AfterLoadDFMValues;
    WebMessageDlg.AfterLoadDFMValues;
    XDataWebDataSetPerfPlan.AfterLoadDFMValues;
    PerfPlanDataSource.AfterLoadDFMValues;
    XDataWebConnection1.AfterLoadDFMValues;
    XDataWebDataSetPerfCat.AfterLoadDFMValues;
    PerfCatWebDataSource.AfterLoadDFMValues;
    XDataWebDataSetPerfMisc.AfterLoadDFMValues;
    PerfMiscWebDataSource.AfterLoadDFMValues;
    XDataWebDataSetFaelle.AfterLoadDFMValues;
    FaelleDataSource.AfterLoadDFMValues;
    XDataWebDataSetKPIData.AfterLoadDFMValues;
    KPIDataWebDataSource.AfterLoadDFMValues;
  end;
end;

end.

